import React, {useState, useEffect, useRef} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {Card} from "primereact/card";
import {Button} from "primereact/button";
import {ConfirmDialog} from "primereact/confirmdialog";
import {Dialog} from "primereact/dialog";
import {Calendar} from "primereact/calendar";
import {addLocale} from "primereact/api";
import {Sidebar} from "primereact/sidebar";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {InputNumber} from "primereact/inputnumber";
import {InputMask} from "primereact/inputmask";
import {InputSwitch} from "primereact/inputswitch";
import {Slider} from "primereact/slider";
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {ProgressBar} from "primereact/progressbar";
import {SelectButton} from "primereact/selectbutton";
import {Accordion, AccordionTab} from 'primereact/accordion';
import {Tooltip} from "primereact/tooltip";
import {Chart} from "primereact/chart";
import {Panel} from "primereact/panel";
import axios from "axios";
import Cookies from "js-cookie";
import currencyFormatter from "currency-formatter";
import moment from "moment/moment";
import fileDownload from "js-file-download";
import logoFelhomatrac from "../assets/images/logo-felhomatrac.png";
import logoFelhomatracDark from "../assets/images/logo-felhomatrac-dark.png";
import wizard from "../assets/images/gfx-wizard.png";
import wizardEnd from "../assets/images/gfx-wizard-end.png";

import _FM_ReservationFormComponent from "../components/_FM_reservation/_FM_ReservationFormComponent";
import _FM_ReservationShowComponent from "../components/_FM_reservation/_FM_ReservationShowComponent";
import _FM_FolioFormComponent from "../components/_FM_folio/_FM_FolioFormComponent";
import _FM_ReservationgroupShowComponent from "../components/_FM_reservationgroup/_FM_ReservationgroupShowComponent";
import _FM_CustomerShowComponent from "../components/_FM_customer/_FM_CustomerShowComponent";
import _FM_FolioDndComponent from "../components/_FM_folio/_FM_FolioDndComponent";
import _FM_ReceiptFormComponent from "../components/_FM_receipt/_FM_ReceiptFormComponent";
import _FM_ReceiptShowComponent from "../components/_FM_receipt/_FM_ReceiptShowComponent";
import HelpComponent from "../components/HelpComponent";


const _FM_ControlpanelPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id, action, entity} = useParams();
  const [loading, setLoading] = useState(false);

  const [accommodations, setAccommodations] = useState([]);
  const [operatorsLoaded, setOperatorsLoaded] = useState(false);
  const [accommodationsLoaded, setAccommodationsLoaded] = useState(false);
  const [wizardModalVisible, setWizardModalVisible] = useState(false);
  const [accommodationWizardCompleted, setAccommodationWizardCompleted] = useState(false);
  const [operator, setOperator] = useState({});
  const [wizardStep, setWizardStep] = useState(1);
  const [wizardInitialized, setWizardInitialized] = useState(false);
  const [wizardSaving, setWizardSaving] = useState(false);
  const [wizardLoading, setWizardLoading] = useState(false);
  const [wizardStepCompleted, setWizardStepCompleted] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false
  });
  const [wizardOperatorData, setWizardOperatorData] = useState({
    company_name: '',
    tax_number: '',
    zip_code: '',
    registered_office_city: '',
    street_and_house_number: '',
    billing_integration: '',
    szamlazz_hu_agent_code: '',
    billingo_api_key: '',
    billingo_block_id: '',
    billingo_bank_account_id: '',
    vat_payment: true
  });
  const [wizardAccommodationData, setWizardAccommodationData] = useState({
    name: '',
    short_name: '',
    country: '',
    zip_code: '',
    city: '',
    street_and_number: '',
    contact_name: '',
    contact_email: '',
    contact_phone: '',
    currency_code: '',
    child_age_limit: '',
    auto_check_in_time: '',
    auto_check_out_time: '',
    daily_reservation_allowed: true,
    api: false,
    guest_information_request_page: null,
    customer_data_email_send_mode: '',
    customer_data_email_auto_repeat_send: '',
    customer_data_email_reply_to: '',
    default_payment_method: null,
    auto_invoice: 'NONE',
    advance_invoice_trigger: 'NONE',
    advance_invoice_strategy: null,
    advance_invoice_value: null,
    channel_manager: 'NONE',
    e_zee_centrix_hotel_code: '',
    e_zee_centrix_auth_key: '',
    airbnb_calendar_url: '',
    szallas_calendar_url: '',
    booking_calendar_url: '',
    reservation_from_to_input_type: 'merged'
  });
  const [wizardCountrySpecificData, setWizardCountrySpecificData] = useState({});
  const [wizardCountrySpecificFields, setWizardCountrySpecificFields] = useState([]);
  const [wizardCountrySpecificOptions, setWizardCountrySpecificOptions] = useState({});
  const [wizardOperatorId, setWizardOperatorId] = useState(null);
  const [wizardAccommodationId, setWizardAccommodationId] = useState(null);
  const [wizardCountrySpecificEndpoint, setWizardCountrySpecificEndpoint] = useState('');
  const [wizardCountrySpecificId, setWizardCountrySpecificId] = useState(null);
  const [wizardValidationErrors, setWizardValidationErrors] = useState({});
  const [wizardApiValidationErrors, setWizardApiValidationErrors] = useState({});
  const [wizardApiErrorStepByField, setWizardApiErrorStepByField] = useState({});
  const [wizardBillingIntegrations, setWizardBillingIntegrations] = useState([]);
  const [wizardCountries, setWizardCountries] = useState([]);
  const [wizardCurrencies, setWizardCurrencies] = useState([]);
  const [wizardGuestInfos, setWizardGuestInfos] = useState([]);
  const [wizardCustomerDataEmailSendModes, setWizardCustomerDataEmailSendModes] = useState([]);
  const [wizardCustomerDataEmailAutoRepeatSends, setWizardCustomerDataEmailAutoRepeatSends] = useState([]);
  const [wizardPaymentMethods, setWizardPaymentMethods] = useState([]);
  const [wizardAutoInvoiceBehaviors, setWizardAutoInvoiceBehaviors] = useState([]);
  const [wizardAdvanceInvoiceTriggers, setWizardAdvanceInvoiceTriggers] = useState([]);
  const [wizardAdvanceInvoiceStrategies, setWizardAdvanceInvoiceStrategies] = useState([]);
  const [wizardChannelManagers, setWizardChannelManagers] = useState([]);

  const [checksArrivalDay, setChecksArrivalDay] = useState(moment.utc(new Date()).local().format(t('YYYY-MM-DD')));
  const [checksDepartureDay, setChecksDepartureDay] = useState(moment.utc(new Date()).local().format(t('YYYY-MM-DD')));
  const [checksArrivals, setChecksArrivals] = useState([]);
  const [checksArrivalsFiltered, setChecksArrivalsFiltered] = useState([]);
  const [checksDepartures, setChecksDepartures] = useState([]);
  const [checksDeparturesFiltered, setChecksDeparturesFiltered] = useState([]);

  const [closeDay, setCloseDay] = useState(moment.utc(new Date()).local().format(t('YYYY-MM-DD')));
  const [closeAccommodation, setCloseAccommodation] = useState();

  const [reservedDay, setReservedDay] = useState(moment.utc(new Date()).local().format(t('YYYY-MM-DD')));

  const [ntakReportDay, setNtakReportDay] = useState(moment.utc(new Date()).local().format(t('YYYY-MM-DD')));
  const [ntakAccommodation, setNtakAccommodation] = useState();
  const [ntakAccommodationId, setNtakAccommodationId] = useState('');
  const [ntakReport, setNtakReport] = useState(null);
  const [ntakReportNotAvailable, setNtakReportNotAvailable] = useState(false);
  const [ntakReportLoading, setNtakReportLoading] = useState(false);
  const [ntakReportContentHeight, setNtakReportContentHeight] = useState(0);
  const ntakReportContentRef = useRef(null);

  const [reservations, setReservations] = useState([]);

  const [folios, setFolios] = useState([]);
  const [folioFilter, setFolioFilter] = useState('');
  const [selectedFolios, setSelectedFolios] = useState([]);

  const [dailyClosureStatuses, setDailyClosureStatuses] = useState([]);
  const [dailyClosureStatusMeta, setDailyClosureStatusMeta] = useState({});
  const [dailyClosureStatusLoading, setDailyClosureStatusLoading] = useState(false);
  const dailyClosureRefreshTimerRef = useRef(null);

  const [reservationsByStatusesData, setReservationsByStatusesData] = useState([]);
  const [reservationsByStatusesLabel, setReservationsByStatusesLabel] = useState([]);
  const [reservationsByChanelsData, setReservationsByChanelsData] = useState([]);
  const [reservationsByChanelsLabel, setReservationsByChanelsLabel] = useState([]);
  const [reservationsByOccupancyData, setReservationsByOccupancyData] = useState([]);
  const [reservationsByOccupancyDatasets, setReservationsByOccupancyDatasets] = useState([]);
  const [reservationsByOccupancyLabel, setReservationsByOccupancyLabel] = useState([]);
  const [reservationsByOccupancyMultidata, setReservationsByOccupancyMultidata] = useState({});
  const [reservationsByOccupancyType, setReservationsByOccupancyType] = useState('bar');
  const [reservationsDateRange, setReservationsDateRange] = useState([
    moment.utc(new Date()).local().toDate(),
    moment.utc(new Date()).local().add(15, 'days').toDate()
  ]);

  const [setupState, setSetupState] = useState({});

  addLocale('default', {
    firstDayOfWeek: 1,
    dayNames: [t('sunday'), t('monday'), t('tuesday'), t('wednesday'), t('thursday'), t('friday'), t('saturday')],
    dayNamesShort: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    dayNamesMin: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    monthNames: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    monthNamesShort: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    today: t('today'),
    clear: t('delete')
  });

  const normalizeNtakAmount = (value) => (Number(value) || 0) / 100;

  const getNtakRevenueChartValues = (report) => {
    const allCharges = [
      ...(report?.sold_nights || []).flatMap((night) => night?.charges || []),
      ...(report?.other_charges || []),
      ...(report?.post_stay_charges || [])
    ];
    const getCategoryTotal = (isMatch) => allCharges.reduce((sum, charge) => {
      const amount = Number(charge?.gross_amount) || 0;
      return sum + (isMatch(charge?.main_category) ? amount : 0);
    }, 0);

    return [
      normalizeNtakAmount(getCategoryTotal((mainCategory) => mainCategory === 'IFA')),
      normalizeNtakAmount(getCategoryTotal((mainCategory) => mainCategory === 'SZALLASDIJ')),
      normalizeNtakAmount(getCategoryTotal((mainCategory) => !['IFA', 'SZALLASDIJ'].includes(mainCategory))),
    ];
  };

  const ntakRevenueChartValues = getNtakRevenueChartValues(ntakReport);
  const ntakRoomChartValues = [
    Number(ntakReport?.room_summary?.issued_rooms) || 0,
    Number(ntakReport?.room_summary?.out_of_order_rooms) || 0,
    Number(ntakReport?.room_summary?.out_of_service_rooms) || 0,
    Math.max(
      (Number(ntakReport?.room_summary?.saleable_rooms) || 0)
      - (Number(ntakReport?.room_summary?.issued_rooms) || 0),
      0
    )
  ];
  const hasNtakRoomChartData = ntakRoomChartValues.some((value) => Number(value) > 0);
  const hasNtakRevenueChartData = ntakRevenueChartValues.some((value) => Number(value) > 0);
  const isDarkTheme = Cookies.get('theme') === 'dark';
  const ntakChartSurfaceColor = isDarkTheme ? '#343a40' : '#ffffff';
  const ntakChartTextColor = isDarkTheme ? 'rgba(255, 255, 255, 0.78)' : '#595d6e';
  const ntakDoughnutChartOptions = {
    animation: false,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          color: ntakChartTextColor,
          padding: 12
        }
      }
    }
  };

  const getTranslatedLabel = (key, fallbackValue) => {
    const translated = t(key);
    return translated === key ? fallbackValue : translated;
  };

  const getDailyClosureStatusMeta = (status) => {
    const statusValue = String(status || '').toLowerCase().trim();
    const neutralStyle = {backgroundColor: '#dddddd', color: '#5f656b'};
    const successStyle = {backgroundColor: '#0abb87', color: '#ffffff'};
    const failedStyle = {backgroundColor: '#f7a2a2', color: '#5f656b'};

    if (!statusValue) {
      return {
        value: getTranslatedLabel('daily_closure_status_not_started', 'Még nincs státusz'),
        style: neutralStyle
      };
    }

    if (statusValue === 'up_to_date') {
      return {
        value: getTranslatedLabel('daily_closure_status_up_to_date', 'Naprakész'),
        style: successStyle
      };
    }
    if (statusValue === 'attention') {
      return {
        value: getTranslatedLabel('daily_closure_status_attention', 'Figyelmet igényel'),
        style: failedStyle
      };
    }
    if (statusValue === 'pending') {
      return {
        value: getTranslatedLabel('daily_closure_status_pending', 'Függőben'),
        style: neutralStyle
      };
    }
    if (statusValue === 'not_ready') {
      return {
        value: getTranslatedLabel('daily_closure_status_not_ready', 'Nincs kész állapotban'),
        style: neutralStyle
      };
    }
    if (statusValue === 'not_applicable') {
      return {
        value: getTranslatedLabel('daily_closure_status_not_applicable', 'Nem releváns'),
        style: neutralStyle
      };
    }
    if (statusValue === 'failed') {
      return {
        value: getTranslatedLabel('hotelconnect_status_failed', 'Sikertelen'),
        style: failedStyle
      };
    }

    return {
      value: getTranslatedLabel('unknown_status', 'Ismeretlen státusz'),
      style: neutralStyle
    };
  };

  const getDailyClosureAttemptStatusMeta = (status) => {
    const statusValue = String(status || '').toLowerCase().trim();
    const neutralStyle = {backgroundColor: '#dddddd', color: '#5f656b'};
    const successStyle = {backgroundColor: '#0abb87', color: '#ffffff'};
    const failedStyle = {backgroundColor: '#f7a2a2', color: '#5f656b'};

    if (!statusValue) {
      return {
        value: getTranslatedLabel('daily_closure_status_not_started', 'Még nincs státusz'),
        style: neutralStyle
      };
    }
    if (statusValue === 'success') {
      return {
        value: getTranslatedLabel('hotelconnect_status_success', 'Sikeres'),
        style: successStyle
      };
    }
    if (statusValue === 'failed' || statusValue === 'error') {
      return {
        value: getTranslatedLabel('hotelconnect_status_failed', 'Sikertelen'),
        style: failedStyle
      };
    }
    if (statusValue === 'skipped') {
      return {
        value: getTranslatedLabel('hotelconnect_status_skipped', 'Kihagyva'),
        style: neutralStyle
      };
    }
    return {
      value: getTranslatedLabel('unknown_status', 'Ismeretlen státusz'),
      style: neutralStyle
    };
  };

  const formatDailyClosureDateTime = (value) => {
    if (!value) {
      return '-';
    }
    const parsed = moment(value);
    if (!parsed.isValid()) {
      return value;
    }
    return parsed.format('YYYY-MM-DD HH:mm');
  };

  const loadDailyClosureStatuses = () => {
    setDailyClosureStatusLoading(true);
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "accommodation/hotelconnect-ntak-napizaras-status",
      params: {
        // A napi zárás után mindig az aktuális státuszt kérjük le, ne egy cache-elt GET választ.
        _: Date.now()
      },
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        const responseData = response?.data?.data || {};
        setDailyClosureStatuses(responseData?.accommodations || []);
        setDailyClosureStatusMeta(responseData || {});
        return responseData;
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error.response);
        setDailyClosureStatuses([]);
        setDailyClosureStatusMeta({});
        return null;
      })
      .finally(() => {
        setDailyClosureStatusLoading(false);
      });
  };

  const refreshDailyClosureStatusesAfterClose = (accommodationId, closedDay, attempt = 0) => {
    const maxAttempts = 6;

    if (dailyClosureRefreshTimerRef.current) {
      clearTimeout(dailyClosureRefreshTimerRef.current);
      dailyClosureRefreshTimerRef.current = null;
    }

    loadDailyClosureStatuses().then((responseData) => {
      const accommodationStatus = responseData?.accommodations?.find((item) =>
        String(item?.accommodationId) === String(accommodationId)
      );
      const lastClosedDay = accommodationStatus?.lastClosedDay;
      const statusIsUpdated = lastClosedDay
        && moment(lastClosedDay).isSameOrAfter(moment(closedDay), 'day');

      if (!statusIsUpdated && attempt < maxAttempts - 1) {
        dailyClosureRefreshTimerRef.current = setTimeout(() => {
          refreshDailyClosureStatusesAfterClose(accommodationId, closedDay, attempt + 1);
        }, 1500);
      }
    });
  };

  const openReservationCheckinLink = (reservationId) => {
    if (!reservationId) {
      return;
    }

    const checkinTab = window.open('', '_blank');

    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + 'reservation/' + reservationId,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get('userToken'),
        'Sys-name': Cookies.get('instanceId'),
        'Preferred-locale': Cookies.get('language')
      }
    })
      .then((response) => {
        const reservationData = response?.data?.data || {};
        const uniqueId = reservationData?.unique_id || reservationData?.uniqueId;
        const password = reservationData?.password;

        if (!uniqueId || !password) {
          if (checkinTab) {
            checkinTab.close();
          }
          window.App.toastShow('error', t('error'), 'Missing check-in credentials for this reservation.');
          return;
        }

        const checkinUrl = process.env.REACT_APP_APP_PROTOCOL
          + window.location.hostname.split('.')[0]
          + '.'
          + process.env.REACT_APP_APP_HOST.replace('/#/', '/#')
          + '/fast-checkin?uniqueId='
          + encodeURIComponent(uniqueId)
          + '&password='
          + encodeURIComponent(password);

        if (checkinTab) {
          checkinTab.location.href = checkinUrl;
        } else {
          window.open(checkinUrl, '_blank', 'noopener,noreferrer');
        }
      })
      .catch((error) => {
        if (checkinTab) {
          checkinTab.close();
        }
        window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error?.response);
      });
  };

  const wizardStepDefinitions = [
    {id: 1, key: 'onboarding_step_welcome', subtitle: 'onboarding_step_welcome_subtitle'},
    {id: 2, key: 'onboarding_step_operator', subtitle: 'onboarding_step_operator_subtitle'},
    {id: 3, key: 'onboarding_step_accommodation', subtitle: 'onboarding_step_accommodation_subtitle'},
    {id: 4, key: 'onboarding_step_settings', subtitle: 'onboarding_step_settings_subtitle'},
    {id: 5, key: 'onboarding_step_billing', subtitle: 'onboarding_step_billing_subtitle'},
    {id: 6, key: 'onboarding_step_channel_manager', subtitle: 'onboarding_step_channel_manager_subtitle'},
    {id: 7, key: 'onboarding_step_country_specific', subtitle: 'onboarding_step_country_specific_subtitle'},
    {id: 8, key: 'onboarding_step_welcome', subtitle: 'onboarding_step_welcome_subtitle'}
  ];

  const wizardApiCall = (method, url, data = null) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + url,
      data: data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    });
  };

  const getCountrySpecificMeta = (accommodationData) => {
    const countrySpecifics = accommodationData?._country_specifics || {};
    const countrySpecificKey = Object.keys(countrySpecifics || {})[0];
    if (!countrySpecificKey) {
      return null;
    }
    const endpoint = "accommodation-" + countrySpecificKey.toLowerCase();
    const collectionKey = "accommodation_" + countrySpecificKey.toLowerCase() + "s";
    const entityId = accommodationData?.[collectionKey]?.[0]?.id || null;
    return {countrySpecificKey, endpoint, collectionKey, entityId};
  };

  const normalizeAdvanceInvoiceValue = (value) => {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    const parsedValue = Number(value);
    if (Number.isNaN(parsedValue)) {
      return value;
    }
    return Math.trunc(parsedValue);
  };

  const normalizeAccommodationForWizard = (accommodationData = {}) => {
    const restAccommodationData = {...(accommodationData || {})};
    delete restAccommodationData.daily_close_behavior;
    delete restAccommodationData.ezee_centrtix_update_mode;
    return {
      ...restAccommodationData,
      operator_data: accommodationData?.operator_data?.id || accommodationData?.operator_data || null,
      country: accommodationData?.country || '',
      currency_code: accommodationData?.currency_code || '',
      child_age_limit: accommodationData?.child_age_limit ?? '',
      auto_invoice: accommodationData?.auto_invoice ?? accommodationData?.auto_invoice_on_check_out ?? 'NONE',
      advance_invoice_trigger: accommodationData?.advance_invoice_trigger ?? 'NONE',
      advance_invoice_strategy: accommodationData?.advance_invoice_strategy ?? null,
      advance_invoice_value: normalizeAdvanceInvoiceValue(accommodationData?.advance_invoice_value),
      default_payment_method: accommodationData?.default_payment_method?.id || accommodationData?.default_payment_method || null,
      guest_information_request_page: accommodationData?.guest_information_request_page?.id || accommodationData?.guest_information_request_page || null,
      customer_data_email_send_mode: accommodationData?.customer_data_email_send_mode || '',
      customer_data_email_auto_repeat_send: accommodationData?.customer_data_email_auto_repeat_send || '',
      channel_manager: accommodationData?.channel_manager || 'NONE',
    };
  };

  const loadCountrySpecificFields = async (accommodationData, forceCountryCode = '') => {
    const accommodationCountry = (forceCountryCode || accommodationData?.country || '').toUpperCase();
    const fallbackCountryKey = accommodationCountry.toLowerCase();
    const meta = getCountrySpecificMeta(accommodationData);
    const countrySpecificKey = (meta?.countrySpecificKey || fallbackCountryKey || '').toLowerCase();

    if (!countrySpecificKey) {
      setWizardCountrySpecificFields([]);
      setWizardCountrySpecificData({});
      setWizardCountrySpecificOptions({});
      setWizardCountrySpecificEndpoint('');
      setWizardCountrySpecificId(null);
      return;
    }
    const endpoint = meta?.endpoint || ("accommodation-" + countrySpecificKey);
    const entityId = meta?.entityId || null;
    const transformedCountry = countrySpecificKey.charAt(0).toUpperCase() + countrySpecificKey.slice(1).toLowerCase();
    const infoResponse = await wizardApiCall('get', 'info/Accommodation' + transformedCountry);
    const editableFields = infoResponse?.data?.editable_fields || [];
    setWizardCountrySpecificFields(editableFields);
    setWizardCountrySpecificEndpoint(endpoint);
    setWizardCountrySpecificId(entityId);

    const optionsMap = {};
    for (const field of editableFields) {
      if (!field?.type?.includes("Enum")) {
        continue;
      }
      try {
        const dictionaryResponse = await wizardApiCall('get', "dictionary/" + field.name.replaceAll('_', '-'));
        optionsMap[field.name] = Object.values(dictionaryResponse?.data?.data || {}).flat();
      } catch (error) {
        optionsMap[field.name] = [];
      }
    }
    setWizardCountrySpecificOptions(optionsMap);

    if (entityId) {
      const detailResponse = await wizardApiCall('get', endpoint + "/" + entityId);
      setWizardCountrySpecificData(detailResponse?.data?.data || {});
    } else {
      const initialData = {accommodation: accommodationData?.id};
      if (accommodationCountry === 'HU' && initialData.ifa_type === undefined) {
        initialData.ifa_type = '';
      }
      setWizardCountrySpecificData(initialData);
    }
  };

  const loadWizardDictionaries = async () => {
    setWizardLoading(true);
    try {
      const responses = await Promise.allSettled([
        wizardApiCall('get', 'dictionary/billing-integration'),
        wizardApiCall('get', 'dictionary/country'),
        wizardApiCall('get', 'dictionary/currency'),
        wizardApiCall('get', 'guest-information-request-page'),
        wizardApiCall('get', 'dictionary/customer-data-email-send-mode'),
        wizardApiCall('get', 'dictionary/customer-data-email-auto-repeat-send'),
        wizardApiCall('get', 'payment-method'),
        wizardApiCall('get', 'dictionary/auto-invoice-behavior'),
        wizardApiCall('get', 'dictionary/advance-invoice-trigger'),
        wizardApiCall('get', 'dictionary/advance-invoice-strategy'),
        wizardApiCall('get', 'dictionary/channel-manager')
      ]);

      const responseData = (index, fallback = []) => responses[index]?.status === 'fulfilled'
        ? responses[index]?.value?.data?.data ?? fallback
        : fallback;

      const countries = responseData(1, []);
      const currencies = responseData(2, []);
      const prioritizedCountries = JSON.parse(process.env.REACT_APP_PRIORITIZEDCOUNTRIES || "[]");
      const prioritizedCurrencies = JSON.parse(process.env.REACT_APP_PRIORITIZEDCURRENCIES || "[]");
      const prioritizedCurrencyMap = new Map(currencies.map((currency) => [currency.code, currency]));
      const sortedCountries = [
        ...countries.filter((country) => prioritizedCountries.includes(country.code)),
        ...countries.filter((country) => !prioritizedCountries.includes(country.code)),
      ];
      const sortedCurrencies = [
        ...prioritizedCurrencies
          .map((code) => prioritizedCurrencyMap.get(code))
          .filter(Boolean),
        ...currencies.filter((currency) => !prioritizedCurrencies.includes(currency.code)),
      ];

      setWizardBillingIntegrations(responseData(0, []));
      setWizardCountries(sortedCountries);
      setWizardCurrencies(sortedCurrencies);
      setWizardGuestInfos(responseData(3, {items: []})?.items || []);
      setWizardCustomerDataEmailSendModes(responseData(4, []));
      setWizardCustomerDataEmailAutoRepeatSends(responseData(5, []));
      setWizardPaymentMethods(responseData(6, {items: []})?.items || []);
      setWizardAutoInvoiceBehaviors(responseData(7, []));
      setWizardAdvanceInvoiceTriggers(responseData(8, []));
      setWizardAdvanceInvoiceStrategies(responseData(9, []));
      setWizardChannelManagers(responseData(10, []));

    } catch (error) {
      window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error.response);
    } finally {
      setWizardLoading(false);
    }
  };

  const initWizardFromExistingData = () => {
    const nextOperatorData = {
      company_name: operator?.company_name || '',
      tax_number: operator?.tax_number || '',
      zip_code: operator?.zip_code || '',
      registered_office_city: operator?.registered_office_city || '',
      street_and_house_number: operator?.street_and_house_number || '',
      billing_integration: operator?.billing_integration || '',
      szamlazz_hu_agent_code: operator?.szamlazz_hu_agent_code || '',
      billingo_api_key: operator?.billingo_api_key || '',
      billingo_block_id: operator?.billingo_block_id || '',
      billingo_bank_account_id: operator?.billingo_bank_account_id || '',
      vat_payment: operator?.vat_payment ?? true
    };
    setWizardOperatorData(nextOperatorData);
    setWizardOperatorId(operator?.id || null);

    const firstAccommodation = accommodations?.[0] || null;
    if (firstAccommodation) {
      setWizardAccommodationId(firstAccommodation.id);
      setWizardAccommodationData((prev) => ({
        ...prev,
        ...normalizeAccommodationForWizard(firstAccommodation),
        operator_data: firstAccommodation?.operator_data?.id || firstAccommodation?.operator_data || operator?.id || null
      }));
    } else {
      setWizardAccommodationId(null);
    }

    setWizardStepCompleted({
      1: false,
      2: Boolean(operator?.id),
      3: Boolean(firstAccommodation?.id),
      4: false,
      5: false,
      6: false,
      7: false,
      8: false
    });
    setWizardStep(1);
  };

  const validateStep = (stepId) => {
    const errors = {};
    const isValidEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(String(email || '').trim());
    const isValid24HourTime = (timeValue) => /^([01]\d|2[0-3]):([0-5]\d)$/.test(String(timeValue || '').trim());

    if (stepId === 2) {
      if (!wizardOperatorData.company_name) errors.company_name = t('required_field');
      if (!wizardOperatorData.tax_number) errors.tax_number = t('required_field');
      if (!wizardOperatorData.zip_code) errors.zip_code = t('required_field');
      if (!wizardOperatorData.registered_office_city) errors.registered_office_city = t('required_field');
      if (!wizardOperatorData.street_and_house_number) errors.street_and_house_number = t('required_field');
      if (!wizardOperatorData.billing_integration) errors.billing_integration = t('required_field');
    }
    if (stepId === 3) {
      if (!wizardAccommodationData.name) errors.name = t('required_field');
      if (!wizardAccommodationData.short_name) errors.short_name = t('required_field');
      if (!wizardAccommodationData.country) errors.country = t('required_field');
      if (!wizardAccommodationData.zip_code) errors.zip_code = t('required_field');
      if (!wizardAccommodationData.city) errors.city = t('required_field');
      if (!wizardAccommodationData.street_and_number) errors.street_and_number = t('required_field');
      if (!wizardAccommodationData.currency_code) errors.currency_code = t('required_field');
      if (!wizardAccommodationData.contact_email) {
        errors.contact_email = t('required_field');
      } else if (!isValidEmail(wizardAccommodationData.contact_email)) {
        errors.contact_email = t('please_use_a_valid_email_address');
      }
    }
    if (stepId === 4) {
      if (wizardAccommodationData.child_age_limit === undefined || wizardAccommodationData.child_age_limit === null || wizardAccommodationData.child_age_limit === '') errors.child_age_limit = t('required_field');
      if (wizardAccommodationData.auto_check_in_time && !isValid24HourTime(wizardAccommodationData.auto_check_in_time)) {
        errors.auto_check_in_time = t('please_use_a_valid_24h_time');
      }
      if (wizardAccommodationData.auto_check_out_time && !isValid24HourTime(wizardAccommodationData.auto_check_out_time)) {
        errors.auto_check_out_time = t('please_use_a_valid_24h_time');
      }
      if (!wizardAccommodationData.customer_data_email_send_mode) errors.customer_data_email_send_mode = t('required_field');
      if (wizardAccommodationData.customer_data_email_send_mode === 'AUTO' && !wizardAccommodationData.customer_data_email_auto_repeat_send) {
        errors.customer_data_email_auto_repeat_send = t('required_field');
      }
      if (wizardAccommodationData.customer_data_email_send_mode === 'AUTO') {
        if (!wizardAccommodationData.customer_data_email_reply_to) {
          errors.customer_data_email_reply_to = t('required_field');
        } else if (!isValidEmail(wizardAccommodationData.customer_data_email_reply_to)) {
          errors.customer_data_email_reply_to = t('please_use_a_valid_email_address');
        }
      }
    }
    return errors;
  };

  const persistOperatorData = async () => {
    const payload = {
      company_name: wizardOperatorData.company_name,
      tax_number: wizardOperatorData.tax_number,
      zip_code: wizardOperatorData.zip_code,
      registered_office_city: wizardOperatorData.registered_office_city,
      street_and_house_number: wizardOperatorData.street_and_house_number,
      billing_integration: wizardOperatorData.billing_integration,
      szamlazz_hu_agent_code: wizardOperatorData.szamlazz_hu_agent_code,
      billingo_api_key: wizardOperatorData.billingo_api_key,
      billingo_block_id: wizardOperatorData.billingo_block_id,
      billingo_bank_account_id: wizardOperatorData.billingo_bank_account_id,
      vat_payment: wizardOperatorData.vat_payment
    };
    const response = wizardOperatorId
      ? await wizardApiCall('patch', 'operator-data/' + wizardOperatorId, payload)
      : await wizardApiCall('post', 'operator-data', payload);

    const operatorResponse = response?.data?.data || {};
    setWizardOperatorId(operatorResponse?.id || wizardOperatorId || null);
    setOperator(operatorResponse || {});
    setWizardOperatorData((prev) => ({...prev, ...operatorResponse}));
    window.App.setState({
      rerenderOperatorList: Math.random(),
      selectedOperatorId: operatorResponse?.id
    });
    return operatorResponse;
  };

  const persistAccommodationData = async (options = {}) => {
    const {reloadCountrySpecific = true} = options;
    const operatorIdForPayload = wizardOperatorId || operator?.id || wizardAccommodationData?.operator_data?.id || wizardAccommodationData?.operator_data;
    const isAdvanceInvoiceValueEmpty = wizardAccommodationData?.advance_invoice_value === null
      || wizardAccommodationData?.advance_invoice_value === undefined
      || wizardAccommodationData?.advance_invoice_value === '';
    const advanceInvoiceValue = wizardAccommodationData?.advance_invoice_strategy === 'PERCENTAGE' && isAdvanceInvoiceValueEmpty
      ? 10
      : wizardAccommodationData?.advance_invoice_strategy === 'FIXED_AMOUNT' && isAdvanceInvoiceValueEmpty
        ? 0
        : wizardAccommodationData?.advance_invoice_value;
    const normalizedAdvanceInvoiceValue = normalizeAdvanceInvoiceValue(advanceInvoiceValue);
    const accommodationPayload = {...wizardAccommodationData};
    delete accommodationPayload.ezee_centrtix_update_mode;
    const payload = {
      ...accommodationPayload,
      operator_data: operatorIdForPayload,
      guest_information_request_page: wizardAccommodationData?.guest_information_request_page?.id || wizardAccommodationData?.guest_information_request_page || null,
      default_payment_method: wizardAccommodationData?.default_payment_method?.id || wizardAccommodationData?.default_payment_method || null,
      advance_invoice_value: normalizedAdvanceInvoiceValue
    };
    const response = wizardAccommodationId
      ? await wizardApiCall('patch', 'accommodation/' + wizardAccommodationId, payload)
      : await wizardApiCall('post', 'accommodation', payload);

    const accommodationResponse = response?.data?.data || {};
    const normalizedAccommodation = normalizeAccommodationForWizard(accommodationResponse);
    const nextAccommodationId = accommodationResponse?.id || wizardAccommodationId || null;
    setWizardAccommodationId(nextAccommodationId);
    setWizardAccommodationData((prev) => ({...prev, ...normalizedAccommodation}));
    setAccommodations((prev) => {
      if (!nextAccommodationId) return prev;
      if (prev.some((item) => item.id === nextAccommodationId)) {
        return prev.map((item) => item.id === nextAccommodationId ? accommodationResponse : item);
      }
      return [accommodationResponse, ...prev];
    });
    localStorage.setItem('selectedAccommodation', nextAccommodationId);
    window.App.setState({
      rerenderAccommodationList: Math.random(),
      selectedAccommodationId: nextAccommodationId
    });
    if (reloadCountrySpecific) {
      await loadCountrySpecificFields(accommodationResponse, payload.country);
    }
    return accommodationResponse;
  };

  const persistCountrySpecificData = async () => {
    const accommodationIdForCountrySpecific = wizardAccommodationId || accommodations?.[0]?.id || null;
    if (!accommodationIdForCountrySpecific || !wizardCountrySpecificEndpoint) {
      return;
    }
    const isHuCountrySpecific = (wizardAccommodationData?.country || '').toUpperCase() === 'HU';
    const normalizedIfaType = typeof wizardCountrySpecificData?.ifa_type === 'string'
      ? wizardCountrySpecificData.ifa_type.toLowerCase().trim()
      : '';
    const isIfaPercentEmpty = wizardCountrySpecificData?.ifa_percent === null
      || wizardCountrySpecificData?.ifa_percent === undefined
      || wizardCountrySpecificData?.ifa_percent === '';
    const payload = {
      ...wizardCountrySpecificData,
      ifa_percent: isHuCountrySpecific && normalizedIfaType === 'percent' && isIfaPercentEmpty
        ? 4
        : wizardCountrySpecificData?.ifa_percent,
      accommodation: accommodationIdForCountrySpecific
    };
    const response = wizardCountrySpecificId
      ? await wizardApiCall('patch', wizardCountrySpecificEndpoint + "/" + wizardCountrySpecificId, payload)
      : await wizardApiCall('post', wizardCountrySpecificEndpoint, payload);
    const countrySpecificResponse = response?.data?.data || {};
    setWizardCountrySpecificData(countrySpecificResponse);
    setWizardCountrySpecificId(countrySpecificResponse?.id || wizardCountrySpecificId || null);
  };

  const persistCurrentStep = async (currentStep, options = {}) => {
    const {skipCountrySpecificSettings = false} = options;
    const errors = validateStep(currentStep);
    setWizardValidationErrors(errors);
    setWizardApiValidationErrors({});
    setWizardApiErrorStepByField({});
    if (Object.keys(errors).length > 0) {
      window.App.toastShow('warn', t('warning'), t('onboarding_required_fields_message'));
      return false;
    }
    setWizardSaving(true);
    try {
      if (currentStep === 2) {
        await persistOperatorData();
      }
      if (currentStep === 3) {
        // Collect only; accommodation is persisted after billing step.
      }
      if (currentStep === 4) {
        // Collect only; accommodation is persisted after billing step.
      }
      if (currentStep === 5) {
        await persistAccommodationData();
      }
      if (currentStep === 6) {
        await persistAccommodationData();
      }
      if (currentStep === 7) {
        await persistAccommodationData({reloadCountrySpecific: false});
        if (!skipCountrySpecificSettings) {
          await persistCountrySpecificData();
        }
      }
      setWizardStepCompleted((prev) => ({...prev, [currentStep]: true}));
      return true;
    } catch (error) {
      const apiErrors = error?.response?.data?.data?.errors || {};
      const normalizedErrors = Object.entries(apiErrors).reduce((acc, [field, value]) => {
        acc[field] = Array.isArray(value) ? (value[0] || '') : String(value || '');
        return acc;
      }, {});
      if (Object.keys(normalizedErrors).length > 0) {
        const responseUrl = String(error?.response?.data?.data?.url || '').toLowerCase();
        const operatorStepFields = [
          'company_name',
          'tax_number',
          'zip_code',
          'registered_office_city',
          'street_and_house_number',
          'billing_integration',
          'szamlazz_hu_agent_code',
          'billingo_api_key',
          'billingo_block_id',
          'billingo_bank_account_id',
          'vat_payment'
        ];
        const accommodationStepByField = {
          name: 3,
          short_name: 3,
          country: 3,
          zip_code: 3,
          city: 3,
          street_and_number: 3,
          currency_code: 3,
          contact_name: 3,
          contact_email: 3,
          contact_phone: 3,
          child_age_limit: 4,
          auto_check_in_time: 4,
          auto_check_out_time: 4,
          daily_reservation_allowed: 4,
          api: 4,
          guest_information_request_page: 4,
          customer_data_email_send_mode: 4,
          customer_data_email_auto_repeat_send: 4,
          customer_data_email_reply_to: 4,
          default_payment_method: 5,
          auto_invoice: 5,
          auto_invoice_on_check_out: 5,
          advance_invoice_trigger: 5,
          advance_invoice_strategy: 5,
          advance_invoice_value: 5,
          channel_manager: 6,
          e_zee_centrix_hotel_code: 6,
          e_zee_centrix_auth_key: 6,
          airbnb_calendar_url: 6,
          szallas_calendar_url: 6,
          booking_calendar_url: 6
        };
        const stepByField = Object.keys(normalizedErrors).reduce((acc, fieldName) => {
          if (responseUrl.includes('/operator-data')) {
            acc[fieldName] = 2;
            return acc;
          }
          if (responseUrl.includes('/accommodation-')) {
            acc[fieldName] = 7;
            return acc;
          }
          if (responseUrl.includes('/accommodation')) {
            acc[fieldName] = accommodationStepByField[fieldName] || currentStep;
            return acc;
          }
          if (operatorStepFields.includes(fieldName)) {
            acc[fieldName] = 2;
            return acc;
          }
          acc[fieldName] = accommodationStepByField[fieldName] || currentStep;
          return acc;
        }, {});
        setWizardApiValidationErrors(normalizedErrors);
        setWizardApiErrorStepByField(stepByField);
      }
      window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error.response);
      return false;
    } finally {
      setWizardSaving(false);
    }
  };

  const onWizardNext = async () => {
    if (wizardStep === 8) {
      setAccommodationWizardCompleted(true);
      setWizardInitialized(false);
      setWizardModalVisible(false);
      return;
    }
    const stepSaved = await persistCurrentStep(wizardStep);
    if (!stepSaved) {
      return;
    }
    if (wizardStep === 1) {
      setWizardStepCompleted((prev) => ({...prev, 1: true}));
    }
    setWizardStep((prev) => Math.min(prev + 1, 8));
  };

  const onWizardSaveWithoutNtakSettings = async () => {
    const stepSaved = await persistCurrentStep(7, {skipCountrySpecificSettings: true});
    if (!stepSaved) {
      return;
    }
    setWizardStep(8);
  };

  const onWizardBack = () => {
    setWizardStep((prev) => Math.max(prev - 1, 1));
  };

  const getWizardStepState = (stepId) => {
    if (Object.values(wizardApiErrorStepByField).includes(stepId)) return 'error';
    if (stepId === wizardStep) return 'active';
    if (wizardStepCompleted[stepId]) return 'completed';
    return 'pending';
  };

  const canNavigateToStepByState = (stepState) => {
    return stepState === 'completed' || stepState === 'active' || stepState === 'error';
  };

  useEffect(() => {
    document.title = t('control_panel') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/control-panel')
    setOperatorsLoaded(false);
    setAccommodationsLoaded(false);

    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "accommodation",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setAccommodations(response.data.data.items)
        if (response?.data?.data?.items?.[0]?.id) {
          setNtakAccommodation((prev) => prev || response.data.data.items[0].id);
        }
      })
      .catch(error => {

      })
      .finally(() => {
        setAccommodationsLoaded(true);
      })
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "operator-data",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setOperator(response?.data?.data?.items?.[0] || {})
      })
      .catch(error => {

      })
      .finally(() => {
        setOperatorsLoaded(true);
      })
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "default/setup-state",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setSetupState(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [window.App.state.rerenderOperatorList, window.App.state.rerenderAccommodationList]);

  useEffect(() => {
    if (!reservationsDateRange?.[0] || !reservationsDateRange?.[1]) {
      return;
    }
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "statistics/reservations/statuses",
      params: {
        start_date: moment.utc(reservationsDateRange[0]).local().format('YYYY-MM-DD'),
        end_date: moment.utc(reservationsDateRange[1]).local().format('YYYY-MM-DD'),
      },
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(repsponse => {
        let _data = []
        let _labels = []
        repsponse.data.data.map((item, index) => {
          _data.push(item.reservationCount)
          _labels.push(t(item.status))
        })
        setReservationsByStatusesData(_data)
        setReservationsByStatusesLabel(_labels)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "statistics/reservations/channel-share",
      params: {
        start_date: moment.utc(reservationsDateRange[0]).local().format('YYYY-MM-DD'),
        end_date: moment.utc(reservationsDateRange[1]).local().format('YYYY-MM-DD'),
      },
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(repsponse => {
        let _data = []
        let _labels = []
        repsponse.data.data.map((item, index) => {
          _data.push(item.reservations)
          _labels.push(t(item?.channel?.toLowerCase()))
        })
        setReservationsByChanelsData(_data)
        setReservationsByChanelsLabel(_labels)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "statistics/reservations/occupancy-trend",
      params: {
        start_date: moment.utc(reservationsDateRange[0]).local().format('YYYY-MM-DD'),
        end_date: moment.utc(reservationsDateRange[1]).local().format('YYYY-MM-DD'),
      },
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        const chartData = {
          labels: [],
          datasets: []
        };
        chartData.labels = response.data.data.map(item => item.date);
        const datasetKeys = Object.keys(response?.data?.data?.[0] || {}).filter(key => key !== 'date');
        chartData.datasets = datasetKeys.map(key => ({
          label: t(key),
          data: response.data.data.map(item => item[key]),
          fill: false,
          tension: 0.5
        }));
        setReservationsByOccupancyMultidata(chartData)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [reservationsDateRange, window.App.state.rerenderOperatorList, window.App.state.rerenderAccommodationList]);

  useEffect(() => {
    if (action === 'update' && entity === 'reservation') {
      window.App.help('/reservation')
    }
  }, [action, entity]);

  useEffect(() => {
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "statistics/arrivals?start_date=" + checksArrivalDay,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setChecksArrivals(response.data.data)
        setChecksArrivalsFiltered(response.data.data)
      })
      .catch(error => {

      })
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "statistics/departures?end_date=" + checksDepartureDay,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setChecksDepartures(response.data.data)
        setChecksDeparturesFiltered(response.data.data)
      })
      .catch(error => {

      })
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST
        // + "reservation?search[deleted_at][operator]=is_null&search[reservedFrom][operator]=between&search[reservedFrom][value]="
        // + reservedDay + ',' + moment.utc(reservedDay).local().add(1, 'day').format(t('YYYY-MM-DD')),
        // + "reservation?search[reserved_from][operator]=<=&search[reserved_from][value]=" + moment.utc(reservedDay).local().subtract(0, 'day').format(t('YYYY-MM-DD'))
        // + " 00:00:00&search[reserved_to][operator]=>=&search[reserved_to][value]=" + moment.utc(reservedDay).local().add(1, 'day').format(t('YYYY-MM-DD')) + " 23:59:00",
        + "reservation?search[deleted_at][operator]=is_null&search[reserved_from][operator]=<=&search[reserved_from][value]="
        + moment.utc(reservedDay).local().subtract(0, 'day').format(t('YYYY-MM-DD'))
        + " 23:59:59&search[reserved_to][operator]=>=&search[reserved_to][value]=" + moment.utc(reservedDay).local().subtract(0, 'day').format(t('YYYY-MM-DD')) + " 00:00:00",

      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        let _reservations = []
        if (response.data && response.data.data.items && response.data.data.items[0]) {
          response.data.data.items.map(item => {
            if (item.status !== 'cancelled' && item.status !== 'no_show') {
              _reservations.push(item)
            }
          })
        }
        console.log(_reservations)
        setReservations(_reservations)
      })
      .catch(error => {

      })
  }, [reservedDay, checksArrivalDay, checksDepartureDay, window.App.state.rerenderReservationGuestList, window.App.state.rerenderReservationList]);

  useEffect(() => {
    loadDailyClosureStatuses();
  }, [window.App.state.rerenderAccommodationList]);

  useEffect(() => {
    return () => {
      if (dailyClosureRefreshTimerRef.current) {
        clearTimeout(dailyClosureRefreshTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (localStorage.getItem('folioFilter') && localStorage.getItem('folioFilter').length > 0) {
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "folio?search[customer_name]=" + localStorage.getItem('folioFilter'),
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setFolios(response.data.data.items)
        })
        .catch(error => {

        })
    } else {
      setFolios([])
    }
  }, [window.App.state.rerenderFolioList]);

  useEffect(() => {
    if (!ntakAccommodation && accommodations?.[0]?.id) {
      setNtakAccommodation(accommodations[0].id);
    }
  }, [accommodations, ntakAccommodation]);

  useEffect(() => {
    if (!ntakAccommodation) {
      setNtakAccommodationId('')
      setNtakReport(null)
      return
    }
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "accommodation-hu/" + ntakAccommodation,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        const ntakId = response?.data?.data?.ntak_adatszolgaltatasi_azon
          || response?.data?.ntak_adatszolgaltatasi_azon
          || '';
        setNtakAccommodationId(ntakId);
        setNtakReport(null);
        setNtakReportNotAvailable(false);
      })
      .catch(error => {
        setNtakAccommodationId('');
        setNtakReport(null);
        setNtakReportNotAvailable(false);
        if (error?.response?.status !== 404) {
          window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error.response);
        }
      })
  }, [ntakAccommodation]);

  useEffect(() => {
    if (!ntakAccommodation || !ntakAccommodationId) {
      return;
    }

    if (ntakReportContentRef.current) {
      setNtakReportContentHeight(ntakReportContentRef.current.offsetHeight || 0);
    }
    setNtakReport(null);
    setNtakReportNotAvailable(false);
    setNtakReportLoading(true);
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST
        + "public/ntak-report/accommodations/" + ntakAccommodationId + "/daily-report/"
        + moment(ntakReportDay).format('YYYY-MM-DD'),
      params: {},
      headers: {
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setNtakReport(response?.data?.data || response?.data || null);
        setNtakReportNotAvailable(false);
      })
      .catch(error => {
        setNtakReport(null);
        if (error?.response?.status === 404) {
          setNtakReportNotAvailable(true);
        } else {
          setNtakReportNotAvailable(false);
          window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error.response);
        }
      })
      .finally(() => {
        setNtakReportLoading(false);
      })
  }, [ntakAccommodation, ntakAccommodationId, ntakReportDay]);

  useEffect(() => {
    if (ntakReport && ntakReportContentRef.current) {
      setNtakReportContentHeight(ntakReportContentRef.current.offsetHeight || 0);
    }
  }, [ntakReport]);

  useEffect(() => {
    const isBootstrapLoaded = operatorsLoaded && accommodationsLoaded;
    const hasMissingData = !operator?.id || !accommodations?.[0];

    if (isBootstrapLoaded && hasMissingData) {
      setAccommodationWizardCompleted(false);
      setWizardModalVisible(true);
    }
  }, [operatorsLoaded, accommodationsLoaded, operator, accommodations]);

  useEffect(() => {
    if (!wizardModalVisible || !operatorsLoaded || !accommodationsLoaded || wizardInitialized) {
      return;
    }
    initWizardFromExistingData();
    loadWizardDictionaries();
    setWizardInitialized(true);
  }, [wizardModalVisible, operatorsLoaded, accommodationsLoaded, wizardInitialized]);

  useEffect(() => {
    if (!wizardModalVisible || !wizardAccommodationData?.country || !wizardAccommodationId) {
      return;
    }
    const linkedAccommodationId = wizardCountrySpecificData?.accommodation?.id || wizardCountrySpecificData?.accommodation;
    if (!linkedAccommodationId) {
      setWizardCountrySpecificData((prev) => ({
        ...prev,
        accommodation: wizardAccommodationId
      }));
      return;
    }
    if (String(linkedAccommodationId) !== String(wizardAccommodationId)) {
      setWizardCountrySpecificData({accommodation: wizardAccommodationId});
    }
  }, [wizardModalVisible, wizardAccommodationId, wizardAccommodationData?.country]);

  useEffect(() => {
    if (!wizardModalVisible) {
      setWizardInitialized(false);
    }
  }, [wizardModalVisible]);

  useEffect(() => {
    if (!wizardModalVisible || wizardStep < 7 || !wizardAccommodationId) {
      return;
    }
    wizardApiCall('get', 'accommodation/' + wizardAccommodationId)
      .then((response) => {
        const accommodationSnapshot = response?.data?.data || {
          ...wizardAccommodationData,
          id: wizardAccommodationId
        };
        return loadCountrySpecificFields(accommodationSnapshot, accommodationSnapshot?.country || wizardAccommodationData.country);
      })
      .catch((error) => {
        window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error.response);
      });
  }, [wizardModalVisible, wizardStep, wizardAccommodationId]);

  useEffect(() => {
    if (!wizardModalVisible || !wizardBillingIntegrations.length) {
      return;
    }
    if (!wizardOperatorData.billing_integration) {
      setWizardOperatorData((prev) => ({
        ...prev,
        billing_integration: wizardBillingIntegrations[0]?.value || ''
      }));
    }
  }, [wizardModalVisible, wizardBillingIntegrations, wizardOperatorData.billing_integration]);

  useEffect(() => {
    if (!wizardModalVisible) {
      return;
    }
    if (!wizardAccommodationData.country && wizardCountries[0]?.code) {
      setWizardAccommodationData((prev) => ({
        ...prev,
        country: wizardCountries[0].code
      }));
    }
    if (!wizardAccommodationData.currency_code && wizardCurrencies[0]?.code) {
      setWizardAccommodationData((prev) => ({
        ...prev,
        currency_code: wizardCurrencies[0].code
      }));
    }
    if (!wizardAccommodationData.customer_data_email_send_mode && wizardCustomerDataEmailSendModes[0]?.value) {
      setWizardAccommodationData((prev) => ({
        ...prev,
        customer_data_email_send_mode: wizardCustomerDataEmailSendModes[0].value
      }));
    }
    if (!wizardAccommodationData.customer_data_email_auto_repeat_send && wizardCustomerDataEmailAutoRepeatSends[0]?.value) {
      setWizardAccommodationData((prev) => ({
        ...prev,
        customer_data_email_auto_repeat_send: wizardCustomerDataEmailAutoRepeatSends[0].value
      }));
    }
    if (!wizardAccommodationData.guest_information_request_page && wizardGuestInfos[0]?.id) {
      setWizardAccommodationData((prev) => ({
        ...prev,
        guest_information_request_page: wizardGuestInfos[0].id
      }));
    }
    if (!wizardAccommodationData.default_payment_method && wizardPaymentMethods[0]?.id) {
      setWizardAccommodationData((prev) => ({
        ...prev,
        default_payment_method: wizardPaymentMethods[0].id
      }));
    }
  }, [
    wizardModalVisible,
    wizardCountries,
    wizardCurrencies,
    wizardCustomerDataEmailSendModes,
    wizardCustomerDataEmailAutoRepeatSends,
    wizardGuestInfos,
    wizardPaymentMethods,
    wizardAccommodationData.country,
    wizardAccommodationData.currency_code,
    wizardAccommodationData.customer_data_email_send_mode,
    wizardAccommodationData.customer_data_email_auto_repeat_send,
    wizardAccommodationData.guest_information_request_page,
    wizardAccommodationData.default_payment_method
  ]);

  const hasOperator = !!operator?.id;
  const hasAccommodation = !!accommodations?.[0];
  const wizardCountryName = wizardCountries.find((country) => country.code === wizardAccommodationData.country)?.name
    || (wizardAccommodationData.country || '').toUpperCase();
  const wizardCountrySpecificStepTitle = (wizardAccommodationData.country || '').toUpperCase() === 'HU'
    ? t('onboarding_ntak_settings')
    : t('onboarding_country_specific_settings');
  const wizardDisplayTotalSteps = Math.max(wizardStepDefinitions.length - 1, 1);
  const wizardDisplayStep = Math.min(Math.max(wizardStep - 1, 0), wizardDisplayTotalSteps);
  const wizardDisplayStepHuman = Math.min(Math.max(wizardStep, 1), wizardDisplayTotalSteps);
  const wizardProgressValue = Math.round((wizardDisplayStep / wizardDisplayTotalSteps) * 100);
  const wizardProgressLabel = wizardDisplayStepHuman + '/' + wizardDisplayTotalSteps + ' ' + t('onboarding_steps_label');
  const setupProgressPercent = Number(setupState?.progress_percent ?? 0);
  const setupStep1Ready = setupState?.operator_data?.is_ready === true;
  const setupStep2Ready = setupState?.accommodations?.is_ready === true;
  const setupStep3Ready = setupState?.accommodations?.items?.length > 0
    && setupState.accommodations.items.every((accommodation) => accommodation?.residential_categories?.items?.length > 0
      && accommodation.residential_categories.items.every((category) => category?.is_ready === true));
  const setupStep4Ready = setupState?.accommodations?.items?.length > 0
    && setupState.accommodations.items.every((accommodation) => accommodation?.residential_categories?.items?.length > 0
      && accommodation.residential_categories.items.every((category) => category?.residential_units?.items?.length > 0));
  const isSetupUnitPricingReady = (unit) => {
    const pricedDays = Number(unit?.prices?.items?.priced_days || 0);
    const requiredDays = Number(unit?.prices?.items?.required_days || 0);
    return requiredDays > 0 && pricedDays >= requiredDays;
  };
  const setupStep5Ready = setupStep4Ready
    && setupState.accommodations.items.every((accommodation) =>
      accommodation.residential_categories.items.every((category) =>
        category.residential_units.items.every(isSetupUnitPricingReady)));
  const setupTodos = (() => {
    const todos = [];
    const accommodationsItems = setupState?.accommodations?.items || [];

    if (setupState?.operator_data?.is_ready !== true) {
      todos.push({
        type: 'missing_operator_data',
        label: t('no_operator_data'),
        route: '/operator/create'
      });
    }

    if (accommodationsItems.length === 0) {
      todos.push({
        type: 'missing_accommodation',
        label: t('no_accommodation'),
        route: '/accommodation/create'
      });
    }

    const accommodationsWithoutCategoriesCount = accommodationsItems.filter((accommodation) =>
      (accommodation?.residential_categories?.items?.length || 0) === 0
    ).length;

    if (accommodationsWithoutCategoriesCount > 0) {
      todos.push({
        type: 'missing_categories',
        label: t('setup_todo_missing_categories_for_accommodations', {count: accommodationsWithoutCategoriesCount}),
        route: '/category/create'
      });
    }

    const categoriesWithoutUnitsCount = accommodationsItems.reduce((sum, accommodation) => {
      const categories = accommodation?.residential_categories?.items || [];
      return sum + categories.filter((category) => (category?.residential_units?.items?.length || 0) === 0).length;
    }, 0);

    if (categoriesWithoutUnitsCount > 0) {
      todos.push({
        type: 'missing_units',
        label: t('setup_todo_missing_units_for_categories', {count: categoriesWithoutUnitsCount}),
        route: '/unit/create'
      });
    }

    const unitsWithMissingPrices = [];
    accommodationsItems.forEach((accommodation) => {
      (accommodation?.residential_categories?.items || []).forEach((category) => {
        (category?.residential_units?.items || []).forEach((unit) => {
          const pricedDays = Number(unit?.prices?.items?.priced_days || 0);
          const requiredDays = Number(unit?.prices?.items?.required_days || 0);
          if (requiredDays > 0 && pricedDays < requiredDays) {
            unitsWithMissingPrices.push({
              pricedDays,
              requiredDays
            });
          }
        });
      });
    });

    if (unitsWithMissingPrices.length > 0) {
      const first = unitsWithMissingPrices[0];
      const sameWindow = unitsWithMissingPrices.every((item) =>
        item.pricedDays === first.pricedDays && item.requiredDays === first.requiredDays
      );
      const pricedDaysValue = sameWindow
        ? first.pricedDays
        : Math.min(...unitsWithMissingPrices.map((item) => item.pricedDays));
      const requiredDaysValue = sameWindow
        ? first.requiredDays
        : Math.max(...unitsWithMissingPrices.map((item) => item.requiredDays));

      todos.push({
        type: 'missing_prices',
        label: t('setup_todo_prices_for_units', {
          count: unitsWithMissingPrices.length,
          pricedDays: pricedDaysValue,
          requiredDays: requiredDaysValue
        }),
        route: '/price'
      });
    }

    const todoTypeOrder = {
      missing_prices: 1,
      missing_categories: 2,
      missing_units: 3,
      missing_operator_data: 4,
      missing_accommodation: 5
    };

    return todos.sort((a, b) => {
      const aOrder = todoTypeOrder[a.type] || 99;
      const bOrder = todoTypeOrder[b.type] || 99;
      return aOrder - bOrder;
    });
  })();
  const hasSingleAccommodation = (setupState?.accommodations?.items?.length || 0) === 1;
  const missingCategoriesTodo = setupTodos.find((todo) => todo.type === 'missing_categories');
  const setupPriceFallbackStartDate = moment().format('YYYY-MM-DD');
  const getSetupUnitPriceRoute = (unit, category) => {
    if (!unit?.id || !category?.id) return '/unit/create';
    const startDate = unit?.prices?.items?.start_date || setupPriceFallbackStartDate;
    return `/price/${startDate}/U-${unit.id}?categoryId=${category.id}`;
  };
  const getSetupCategoryPriceRoute = (category) => {
    if (!category?.id) return '/category/create';
    const firstUnit = category?.residential_units?.items?.[0];
    const startDate = firstUnit?.prices?.items?.start_date || setupPriceFallbackStartDate;
    return `/price/${startDate}/C-${category.id}?categoryId=${category.id}`;
  };
  const firstMissingPriceTarget = (() => {
    for (const accommodation of setupState?.accommodations?.items || []) {
      for (const category of accommodation?.residential_categories?.items || []) {
        const unit = (category?.residential_units?.items || []).find((item) => !isSetupUnitPricingReady(item));
        if (unit) return {unit, category};
      }
    }
    return null;
  })();
  const setupPricingRoute = firstMissingPriceTarget
    ? getSetupUnitPriceRoute(firstMissingPriceTarget.unit, firstMissingPriceTarget.category)
    : '/price';
  const getSetupWarningLinkProps = (route) => ({
    role: 'link',
    tabIndex: 0,
    style: {cursor: 'pointer', textDecoration: 'underline'},
    onClick: (event) => {
      event.preventDefault();
      event.stopPropagation();
      navigate(route);
    },
    onKeyDown: (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        event.stopPropagation();
        navigate(route);
      }
    }
  });
  const clearWizardFieldErrors = (fieldName) => {
    setWizardValidationErrors((prev) => {
      if (!prev[fieldName]) return prev;
      const next = {...prev};
      delete next[fieldName];
      return next;
    });
    setWizardApiValidationErrors((prev) => {
      if (!prev[fieldName]) return prev;
      const next = {...prev};
      delete next[fieldName];
      return next;
    });
    setWizardApiErrorStepByField((prev) => {
      if (!prev[fieldName]) return prev;
      const next = {...prev};
      delete next[fieldName];
      return next;
    });
  };

  const setWizardOperatorField = (fieldName, value) => {
    clearWizardFieldErrors(fieldName);
    setWizardOperatorData((prev) => ({...prev, [fieldName]: value}));
  };

  const setWizardAccommodationField = (fieldName, value) => {
    clearWizardFieldErrors(fieldName);
    setWizardAccommodationData((prev) => ({...prev, [fieldName]: value}));
  };

  const setWizardAccommodationTimeField = (fieldName, value) => {
    const normalizedValue = value === '' ? null : value;
    const isValid24HourTime = (timeValue) => /^([01]\d|2[0-3]):([0-5]\d)$/.test(String(timeValue || '').trim());

    setWizardAccommodationField(fieldName, normalizedValue);

    if (normalizedValue && !isValid24HourTime(normalizedValue)) {
      setWizardValidationErrors((prev) => ({
        ...prev,
        [fieldName]: t('please_use_a_valid_24h_time')
      }));
    }
  };

  const setWizardChildAgeLimitField = (value) => {
    const rawValue = String(value ?? '');
    const normalizedValue = rawValue.replace(/\D+/g, '');

    if (normalizedValue !== rawValue) {
      window.App.toastShow('warn', t('warning'), t('child_age_limit_only_numbers'));
    }

    setWizardAccommodationField('child_age_limit', normalizedValue);
  };

  const setWizardCountrySpecificField = (fieldName, value) => {
    clearWizardFieldErrors(fieldName);
    setWizardCountrySpecificData((prev) => ({
      ...prev,
      accommodation: wizardAccommodationId,
      [fieldName]: value
    }));
  };

  const isWizardFieldRequiredAndMissing = (fieldName) => {
    if (wizardStep === 2) {
      if (fieldName === 'company_name') return !wizardOperatorData.company_name;
      if (fieldName === 'tax_number') return !wizardOperatorData.tax_number;
      if (fieldName === 'zip_code') return !wizardOperatorData.zip_code;
      if (fieldName === 'registered_office_city') return !wizardOperatorData.registered_office_city;
      if (fieldName === 'street_and_house_number') return !wizardOperatorData.street_and_house_number;
      if (fieldName === 'billing_integration') return !wizardOperatorData.billing_integration;
    }
    if (wizardStep === 3) {
      if (fieldName === 'name') return !wizardAccommodationData.name;
      if (fieldName === 'short_name') return !wizardAccommodationData.short_name;
      if (fieldName === 'country') return !wizardAccommodationData.country;
      if (fieldName === 'zip_code') return !wizardAccommodationData.zip_code;
      if (fieldName === 'city') return !wizardAccommodationData.city;
      if (fieldName === 'street_and_number') return !wizardAccommodationData.street_and_number;
      if (fieldName === 'currency_code') return !wizardAccommodationData.currency_code;
      if (fieldName === 'contact_email') return !wizardAccommodationData.contact_email;
    }
    if (wizardStep === 4) {
      if (fieldName === 'child_age_limit') {
        return wizardAccommodationData.child_age_limit === undefined || wizardAccommodationData.child_age_limit === null || wizardAccommodationData.child_age_limit === '';
      }
      if (fieldName === 'customer_data_email_send_mode') return !wizardAccommodationData.customer_data_email_send_mode;
      if (fieldName === 'customer_data_email_auto_repeat_send') {
        return wizardAccommodationData.customer_data_email_send_mode === 'AUTO' && !wizardAccommodationData.customer_data_email_auto_repeat_send;
      }
      if (fieldName === 'customer_data_email_reply_to') {
        return wizardAccommodationData.customer_data_email_send_mode === 'AUTO' && !wizardAccommodationData.customer_data_email_reply_to;
      }
    }
    return false;
  };

  const wizardFieldError = (fieldName) => {
    if (wizardApiValidationErrors[fieldName]) {
      return <small className="p-error p-d-block p-mt-1">{wizardApiValidationErrors[fieldName]}</small>;
    }
    if (isWizardFieldRequiredAndMissing(fieldName) || wizardValidationErrors[fieldName]) {
      return <small
        className="p-validate p-d-block p-mt-1">{wizardValidationErrors[fieldName] || t('required_field')}</small>;
    }
    return null;
  };

  const isWizardCountrySpecificFieldVisible = (fieldName) => {
    const countryCode = (wizardAccommodationData?.country || '').toUpperCase();
    const isHuCountrySpecific = countryCode === 'HU';
    const ifaType = wizardCountrySpecificData?.ifa_type;
    const normalizedIfaType = typeof ifaType === 'string' ? ifaType.toLowerCase().trim() : '';
    const isNoneLikeIfaType = !normalizedIfaType
      || normalizedIfaType === 'none'
      || /^im([1-9]|10|11)$/.test(normalizedIfaType);
    const isIfaNightField = fieldName === 'ifa_night_fee' || fieldName === 'ifa_night';
    const isIfaPercentField = fieldName === 'ifa_percent';

    if (isHuCountrySpecific && isNoneLikeIfaType) {
      if (isIfaPercentField || isIfaNightField) {
        return false;
      }
    }

    if (isHuCountrySpecific && normalizedIfaType === 'percent') {
      if (fieldName === 'ifa_percent') {
        return true;
      }
      if (isIfaNightField) {
        return false;
      }
    }

    if (isHuCountrySpecific && normalizedIfaType === 'fix_amount') {
      if (isIfaPercentField) {
        return false;
      }
    }

    return true;
  };

  return (
    <div className="_FM_ControlpanelPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/control-panel"}/>
      {(!localStorage.getItem('adminSession') || localStorage.getItem('adminSession') === 'false') ? (
          <>

            <Dialog
              header={(
                <div className={"fm-onboarding-wizard__header"}>
                  <span>{t('wizard')}</span>
                  <span className={"p-badge p-badge-info fm-onboarding-wizard__header-badge"}>
                    {t('onboarding_wizard_resume_info')}
                  </span>
                </div>
              )}
              visible={wizardModalVisible && (!operatorsLoaded || !accommodationsLoaded || !hasOperator || !hasAccommodation || !accommodationWizardCompleted)}
              onHide={() => {
                setWizardInitialized(false);
                setWizardModalVisible(false);
              }}
              draggable={false}
              blockScroll={true}
              breakpoints={{'960px': '95vw'}}
              style={{width: '1180px', maxWidth: '1180px'}}
              className={"fm-onboarding-dialog"}
            >
              <div className={"fm-onboarding-wizard"}>
                <div className={"fm-onboarding-wizard__sidebar"}>
                  <div className={"fm-onboarding-wizard__brand"}>
                    {Cookies.get('theme') === 'dark' ? (
                      <img src={logoFelhomatracDark} className={"fm-onboarding-wizard__logo"} alt={"Felhomatrac"}/>
                    ) : (
                      <img src={logoFelhomatrac} className={"fm-onboarding-wizard__logo"} alt={"Felhomatrac"}/>
                    )}
                  </div>
                  <div className={"fm-onboarding-wizard__steps"}>
                    {wizardStepDefinitions.map((step) => {
                      const stepState = getWizardStepState(step.id);
                      const isLastStepActive = step.id === 8 && stepState === 'active';
                      const isStepClickable = canNavigateToStepByState(stepState) && !wizardSaving && !wizardLoading;
                      return (
                        <button
                          key={step.id}
                          type="button"
                          className={"fm-onboarding-wizard__step fm-onboarding-wizard__step--" + stepState + (isLastStepActive ? " fm-onboarding-wizard__step--last-active" : "") + (isStepClickable ? " fm-onboarding-wizard__step--clickable" : "")}
                          disabled={!isStepClickable}
                          onClick={() => {
                            if (!isStepClickable) return;
                            setWizardStep(step.id);
                          }}
                        >
                          <span className={"fm-onboarding-wizard__step-number"}>
                            {isLastStepActive ? <i className={"pi pi-check"}></i> : String(step.id).padStart(2, '0')}
                          </span>
                          <span className={"fm-onboarding-wizard__step-text"}>
                            <strong>{step.id === 7 ? wizardCountrySpecificStepTitle : (step.id === 8 ? 'Összegzés' : t(step.key))}</strong>
                            <small>{step.id === 8 ? 'Varázsló befejezése és indulás!' : t(step.subtitle)}</small>
                          </span>
                          {stepState === 'completed' && <i className={"pi pi-check-circle"}></i>}
                          {stepState === 'active' && !isLastStepActive && <i className={"pi pi-spin pi-spinner"}></i>}
                          {stepState === 'pending' && <i className={"pi pi-clock"}></i>}
                          {stepState === 'error' && <i className={"pi pi-exclamation-triangle"}></i>}
                        </button>
                      );
                    })}
                  </div>
                </div>

                <div className={"fm-onboarding-wizard__content"}>
                  <div className={"fm-onboarding-wizard__content-head"}>
                    <div className={"fm-onboarding-wizard__progress-wrap"}>
                      <ProgressBar value={wizardProgressValue}
                                   showValue={false}
                                   style={{height: '2rem', position: 'relative'}}
                      />
                      <span className={"fm-onboarding-wizard__progress-label"}>
                        {wizardProgressLabel}
                      </span>
                    </div>
                  </div>

                  {/*{(wizardLoading || wizardSaving) &&*/}
                  {/*  <ProgressBar mode="indeterminate" style={{height: '4px', marginBottom: '1rem', position: 'relative'}}></ProgressBar>*/}
                  {/*}*/}

                  {wizardStep === 1 && (
                    <div className={"p-text-center"}>
                      <HelpComponent type={"section"} tabNumber={1} sectionNumber={0}/>
                      <img src={wizard} alt={"Felhomatrac Varázsló"} style={{width: '200px'}}/>
                      <h2 className={"p-my-0"}>{t('onboarding_welcome_title')}</h2>
                      <h3>{t('onboarding_welcome_text')}</h3>
                      <p className={"onboarding_welcome_text p-my-0"}>{t('onboarding_description')}</p>
                    </div>
                  )}

                  {wizardStep === 2 && (
                    <Panel className={"p-shadow-0"}>
                      <h2 className={"p-mt-0"}>{t('onboarding_step_operator')}</h2>
                      <HelpComponent type={"section"} tabNumber={2} sectionNumber={0}/>
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-6"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"company_name"}/>
                            <label htmlFor={"wizard_company_name"}>{t('company_name')}</label>
                            <span className="p-d-block">
                            <InputText id={"wizard_company_name"} value={wizardOperatorData.company_name}
                                       onChange={(e) => setWizardOperatorField('company_name', e.target.value)}/>
                          </span>
                            {wizardFieldError('company_name')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-6"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"tax_number"}/>
                            <label htmlFor={"wizard_tax_number"}>{t('tax_number')}</label>
                            <span className="p-d-block">
                            <InputText id={"wizard_tax_number"} value={wizardOperatorData.tax_number}
                                       onChange={(e) => setWizardOperatorField('tax_number', e.target.value)}/>
                          </span>
                            {wizardFieldError('tax_number')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-2 p-xl-2"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"zip_code"}/>
                            <label htmlFor={"wizard_zip_code"}>{t('zip_code')}</label>
                            <span className="p-d-block">
                            <InputText id={"wizard_zip_code"} value={wizardOperatorData.zip_code}
                                       onChange={(e) => {
                                         const nextValue = e.target.value;
                                         setWizardOperatorField('zip_code', nextValue);
                                         if (nextValue?.length >= 4) {
                                           window.App.zipCode(nextValue, (city) => {
                                             setWizardOperatorField('registered_office_city', city);
                                           });
                                         }
                                       }}/>
                          </span>
                            {wizardFieldError('zip_code')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-4 p-xl-4"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"registered_office_city"}/>
                            <label htmlFor={"wizard_registered_office_city"}>{t('registered_office_city')}</label>
                            <span className="p-d-block">
                            <InputText id={"wizard_registered_office_city"}
                                       value={wizardOperatorData.registered_office_city}
                                       onChange={(e) => setWizardOperatorField('registered_office_city', e.target.value)}/>
                          </span>
                            {wizardFieldError('registered_office_city')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-6"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"street_and_house_number"}/>
                            <label htmlFor={"wizard_street_and_house_number"}>{t('street_and_house_number')}</label>
                            <span className="p-d-block">
                            <InputText id={"wizard_street_and_house_number"}
                                       value={wizardOperatorData.street_and_house_number}
                                       onChange={(e) => setWizardOperatorField('street_and_house_number', e.target.value)}/>
                          </span>
                            {wizardFieldError('street_and_house_number')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-6 p-xl-6"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"vat_payment"}/>
                            <label htmlFor={"wizard_vat_payment"}>{t('vat_payment')}</label>
                            <span className="p-d-block">
                              <InputSwitch
                                id={"wizard_vat_payment"}
                                className={"p-mt-2"}
                                checked={Boolean(wizardOperatorData.vat_payment)}
                                value={Boolean(wizardOperatorData.vat_payment)}
                                onChange={(e) => setWizardOperatorField('vat_payment', e.value)}
                              />
                            </span>
                            {wizardFieldError('vat_payment')}
                          </div>
                        </div>
                      </div>
                      <h3 className={"p-mt-0"}>{t('billing_integration')}</h3>
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-6"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"billing_integration_name"}/>
                            <label htmlFor={"wizard_billing_integration"}>{t('billing_integration_name')}</label>
                            <span className="p-d-block">
                            <Dropdown id={"wizard_billing_integration"} options={wizardBillingIntegrations}
                                      optionLabel={(option) => window.App.getTranslatedLabel(option.key)}
                                      optionValue="value"
                                      emptyMessage={t('empty_message')}
                                      emptyFilterMessage={t('empty_message')}
                                      value={wizardOperatorData.billing_integration}
                                      onChange={(e) => setWizardOperatorField('billing_integration', e.value)}/>
                          </span>
                            {wizardFieldError('billing_integration')}
                          </div>
                        </div>
                        {wizardOperatorData.billing_integration === 'számlázz.hu' && (
                          <div className={"p-col-12 p-lg-12"}>
                            <div className="p-field p-fluid">
                              <HelpComponent type={"field"} field={"szamlazz_hu_agent_code"}/>
                              <label htmlFor={"wizard_szamlazz_hu_agent_code"}>{t('szamlazz_hu_agent_code')}</label>
                              <span className="p-d-block">
                                <InputText id={"wizard_szamlazz_hu_agent_code"}
                                           value={wizardOperatorData.szamlazz_hu_agent_code || ''}
                                           onChange={(e) => setWizardOperatorField('szamlazz_hu_agent_code', e.target.value)}/>
                              </span>
                              {wizardFieldError('szamlazz_hu_agent_code')}
                            </div>
                          </div>
                        )}
                        {wizardOperatorData.billing_integration === 'Billingo' && (
                          <>
                            <div className={"p-col-12 p-lg-8"}>
                              <div className="p-field p-fluid">
                                <HelpComponent type={"field"} field={"billingo_api_key"}/>
                                <label htmlFor={"wizard_billingo_api_key"}>{t('billingo_api_key')}</label>
                                <span className="p-d-block">
                                  <InputText id={"wizard_billingo_api_key"}
                                             value={wizardOperatorData.billingo_api_key || ''}
                                             onChange={(e) => setWizardOperatorField('billingo_api_key', e.target.value)}/>
                                </span>
                                {wizardFieldError('billingo_api_key')}
                              </div>
                            </div>
                            <div className={"p-col-12 p-lg-4"}>
                              <div className="p-field p-fluid">
                                <HelpComponent type={"field"} field={"billingo_block_id"}/>
                                <label htmlFor={"wizard_billingo_block_id"}>{t('billingo_block_id')}</label>
                                <span className="p-d-block">
                                  <InputText id={"wizard_billingo_block_id"}
                                             value={wizardOperatorData.billingo_block_id || ''}
                                             onChange={(e) => setWizardOperatorField('billingo_block_id', e.target.value)}/>
                                </span>
                                {wizardFieldError('billingo_block_id')}
                              </div>
                            </div>
                            <div className={"p-col-12 p-lg-4"}>
                              <div className="p-field p-fluid">
                                <HelpComponent type={"field"} field={"billingo_bank_account_id"}/>
                                <label htmlFor={"wizard_billingo_bank_account_id"}>{t('billingo_bank_account_id')}</label>
                                <span className="p-d-block">
                                  <InputText id={"wizard_billingo_bank_account_id"}
                                             value={wizardOperatorData.billingo_bank_account_id || ''}
                                             onChange={(e) => setWizardOperatorField('billingo_bank_account_id', e.target.value)}/>
                                </span>
                                {wizardFieldError('billingo_bank_account_id')}
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </Panel>
                  )}

                  {wizardStep === 3 && (
                    <Panel className={"p-shadow-0"}>
                      <h2 className={"p-mt-0"}>{t('onboarding_step_accommodation')}</h2>
                      <HelpComponent type={"section"} tabNumber={3} sectionNumber={0}/>
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-6"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"name"}/>
                            <label htmlFor={"wizard_acc_name"}>{t('name')}</label>
                            <span className="p-d-block">
                            <InputText id={"wizard_acc_name"} value={wizardAccommodationData.name || ''}
                                       onChange={(e) => setWizardAccommodationField('name', e.target.value)}/>
                          </span>
                            {wizardFieldError('name')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-3"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"short_name"}/>
                            <label htmlFor={"wizard_acc_short_name"}>{t('short_name')}</label>
                            <span className="p-d-block">
                            <InputText id={"wizard_acc_short_name"} value={wizardAccommodationData.short_name || ''}
                                       onChange={(e) => setWizardAccommodationField('short_name', e.target.value)}/>
                          </span>
                            {wizardFieldError('short_name')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-3"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"country"}/>
                            <label htmlFor={"wizard_acc_country"}>{t('country')}</label>
                            <span className="p-d-block">
                            <Dropdown id={"wizard_acc_country"} options={wizardCountries}
                                      optionLabel="name"
                                      optionValue="code"
                                      filter
                                      value={wizardAccommodationData.country}
                                      onChange={(e) => setWizardAccommodationField('country', e.value)}/>
                          </span>
                            {wizardFieldError('country')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-3"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"zip_code"}/>
                            <label htmlFor={"wizard_acc_zip"}>{t('zip_code')}</label>
                            <span className="p-d-block">
                            <InputText id={"wizard_acc_zip"} value={wizardAccommodationData.zip_code || ''}
                                       onChange={(e) => {
                                         const nextValue = e.target.value;
                                         setWizardAccommodationField('zip_code', nextValue);
                                         if (nextValue?.length >= 4) {
                                           window.App.zipCode(nextValue, (city) => {
                                             setWizardAccommodationField('city', city);
                                           });
                                         }
                                       }}/>
                          </span>
                            {wizardFieldError('zip_code')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-3"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"city"}/>
                            <label htmlFor={"wizard_acc_city"}>{t('city')}</label>
                            <span className="p-d-block">
                            <InputText id={"wizard_acc_city"} value={wizardAccommodationData.city || ''}
                                       onChange={(e) => setWizardAccommodationField('city', e.target.value)}/>
                          </span>
                            {wizardFieldError('city')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-6 p-xl-6"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"street_and_number"}/>
                            <label htmlFor={"wizard_acc_street"}>{t('street_and_number')}</label>
                            <span className="p-d-block">
                            <InputText id={"wizard_acc_street"} value={wizardAccommodationData.street_and_number || ''}
                                       onChange={(e) => setWizardAccommodationField('street_and_number', e.target.value)}/>
                          </span>
                            {wizardFieldError('street_and_number')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-4"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"currency"}/>
                            <label htmlFor={"wizard_acc_currency"}>{t('currency')}</label>
                            <span className="p-d-block">
                            <Dropdown id={"wizard_acc_currency"} options={wizardCurrencies}
                                      optionLabel="code"
                                      optionValue="code"
                                      value={wizardAccommodationData.currency_code}
                                      onChange={(e) => setWizardAccommodationField('currency_code', e.value)}/>
                          </span>
                            {wizardFieldError('currency_code')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-4"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"contact_name"}/>
                            <label htmlFor={"wizard_acc_contact_name"}>{t('contact_name')}</label>
                            <span className="p-d-block">
                            <InputText id={"wizard_acc_contact_name"} value={wizardAccommodationData.contact_name || ''}
                                       onChange={(e) => setWizardAccommodationField('contact_name', e.target.value)}/>
                          </span>
                            {wizardFieldError('contact_name')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-4"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"contact_email"}/>
                            <label htmlFor={"wizard_acc_contact_email"}>{t('contact_email')}</label>
                            <span className="p-d-block">
                            <InputText id={"wizard_acc_contact_email"} type={"email"}
                                       value={wizardAccommodationData.contact_email || ''}
                                       onChange={(e) => setWizardAccommodationField('contact_email', e.target.value)}/>
                          </span>
                            {wizardFieldError('contact_email')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-4"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"contact_phone"}/>
                            <label htmlFor={"wizard_acc_contact_phone"}>{t('contact_phone')}</label>
                            <span className="p-d-block">
                            <InputText id={"wizard_acc_contact_phone"}
                                       value={wizardAccommodationData.contact_phone || ''}
                                       onChange={(e) => setWizardAccommodationField('contact_phone', e.target.value)}/>
                          </span>
                            {wizardFieldError('contact_phone')}
                          </div>
                        </div>
                      </div>
                    </Panel>
                  )}

                  {wizardStep === 4 && (
                    <Panel className={"p-shadow-0"}>
                      <h2 className={"p-mt-0"}>{t('onboarding_step_settings')}</h2>
                      <HelpComponent type={"section"} tabNumber={4} sectionNumber={0}/>
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-4"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"child_age_limit"}/>
                            <label htmlFor={"wizard_child_age_limit"}>{t('child_age_limit')}</label>
                            <span className="p-d-block">
                            <InputText id={"wizard_child_age_limit"}
                                       value={wizardAccommodationData.child_age_limit ?? ''}
                                       onChange={(e) => setWizardChildAgeLimitField(e.target.value)}/>
                          </span>
                            {wizardFieldError('child_age_limit')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-4"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"auto_check_in_time"}/>
                            <label htmlFor={"wizard_auto_check_in_time"}>{t('auto_check_in_time')}</label>
                            <span className="p-d-block">
                            <InputMask id={"wizard_auto_check_in_time"}
                                       mask={'99:99'}
                                       value={wizardAccommodationData.auto_check_in_time || ''}
                                       onChange={(e) => {
                                         if (e.value.indexOf("_") === -1) {
                                           setWizardAccommodationTimeField('auto_check_in_time', e.value);
                                         }
                                       }}/>
                          </span>
                            {wizardFieldError('auto_check_in_time')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-4"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"auto_check_out_time"}/>
                            <label htmlFor={"wizard_auto_check_out_time"}>{t('auto_check_out_time')}</label>
                            <span className="p-d-block">
                            <InputMask id={"wizard_auto_check_out_time"}
                                       mask={'99:99'}
                                       value={wizardAccommodationData.auto_check_out_time || ''}
                                       onChange={(e) => {
                                         if (e.value.indexOf("_") === -1) {
                                           setWizardAccommodationTimeField('auto_check_out_time', e.value);
                                         }
                                       }}/>
                          </span>
                            {wizardFieldError('auto_check_out_time')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-4"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"daily_reservation_allowed"}/>
                            <label htmlFor={"wizard_daily_reservation_allowed"}>{t('daily_reservation_allowed')}</label>
                            <span className="p-d-block">
                            <InputSwitch inputId={"wizard_daily_reservation_allowed"}
                                         checked={!!wizardAccommodationData.daily_reservation_allowed}
                                         onChange={(e) => setWizardAccommodationField('daily_reservation_allowed', e.value)}/>
                          </span>
                            {wizardFieldError('daily_reservation_allowed')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-4"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"api"}/>
                            <label htmlFor={"wizard_api"}>{t('api')}</label>
                            <span className="p-d-block">
                            <InputSwitch inputId={"wizard_api"} checked={!!wizardAccommodationData.api}
                                         onChange={(e) => setWizardAccommodationField('api', e.value)}/>
                          </span>
                            {wizardFieldError('api')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-6"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"guest_information_request_page"}/>
                            <label
                              htmlFor={"wizard_guest_information_request_page"}>{t('guest_information_request_page')}</label>
                            <span className="p-d-block">
                            <Dropdown id={"wizard_guest_information_request_page"} options={wizardGuestInfos}
                                      optionLabel="name"
                                      optionValue="id"
                                      value={wizardAccommodationData.guest_information_request_page}
                                      onChange={(e) => setWizardAccommodationField('guest_information_request_page', e.value)}/>
                          </span>
                            {wizardFieldError('guest_information_request_page')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-6"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"customer_data_email_send_mode"}/>
                            <label
                              htmlFor={"wizard_customer_data_email_send_mode"}>{t('customer_data_email_send_mode')}</label>
                            <span className="p-d-block">
                            <Dropdown id={"wizard_customer_data_email_send_mode"}
                                      options={wizardCustomerDataEmailSendModes}
                                      optionLabel={(option) => window.App.getTranslatedLabel(option.key)}
                                      optionValue="value"
                                      value={wizardAccommodationData.customer_data_email_send_mode}
                                      onChange={(e) => setWizardAccommodationField('customer_data_email_send_mode', e.value)}/>
                          </span>
                            {wizardFieldError('customer_data_email_send_mode')}
                          </div>
                        </div>
                        {wizardAccommodationData.customer_data_email_send_mode === 'AUTO' && (
                          <div className={"p-col-12 p-lg-6"}>
                            <div className="p-field p-fluid">
                              <HelpComponent type={"field"} field={"customer_data_email_auto_repeat_send"}/>
                              <label
                                htmlFor={"wizard_customer_data_email_auto_repeat_send"}>{t('customer_data_email_auto_repeat_send')}</label>
                              <span className="p-d-block">
                              <Dropdown id={"wizard_customer_data_email_auto_repeat_send"}
                                        options={wizardCustomerDataEmailAutoRepeatSends}
                                        optionLabel={(option) => window.App.getTranslatedLabel(option.key)}
                                        optionValue="value"
                                        value={wizardAccommodationData.customer_data_email_auto_repeat_send}
                                        onChange={(e) => setWizardAccommodationField('customer_data_email_auto_repeat_send', e.value)}/>
                            </span>
                              {wizardFieldError('customer_data_email_auto_repeat_send')}
                            </div>
                          </div>
                        )}
                        {wizardAccommodationData.customer_data_email_send_mode === 'AUTO' && (
                          <div className={"p-col-12 p-lg-6"}>
                            <div className="p-field p-fluid">
                              <HelpComponent type={"field"} field={"customer_data_email_reply_to"}/>
                              <label
                                htmlFor={"wizard_customer_data_email_reply_to"}>{t('customer_data_email_reply_to')}</label>
                              <span className="p-d-block">
                              <InputText id={"wizard_customer_data_email_reply_to"} type={"email"}
                                         value={wizardAccommodationData.customer_data_email_reply_to || ''}
                                         onChange={(e) => setWizardAccommodationField('customer_data_email_reply_to', e.target.value)}/>
                            </span>
                              {wizardFieldError('customer_data_email_reply_to')}
                            </div>
                          </div>
                        )}
                      </div>
                    </Panel>
                  )}

                  {wizardStep === 5 && (
                    <Panel className={"p-shadow-0"}>
                      <h2 className={"p-mt-0"}>{t('onboarding_step_billing')}</h2>
                      <HelpComponent type={"section"} tabNumber={5} sectionNumber={0}/>
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-4"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"default_payment_method"}/>
                            <label htmlFor={"wizard_default_payment_method"}>{t('default_payment_method')}</label>
                            <span className="p-d-block">
                            <Dropdown id={"wizard_default_payment_method"} options={wizardPaymentMethods}
                                      optionLabel={(option) => window.App.getTranslatedLabel(option.name)?.replaceAll('_', ' ')}
                                      optionValue="id"
                                      value={wizardAccommodationData.default_payment_method}
                                      onChange={(e) => setWizardAccommodationField('default_payment_method', e.value)}/>
                          </span>
                            {wizardFieldError('default_payment_method')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-4"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"auto_invoice_on_check_out"}/>
                            <label htmlFor={"wizard_auto_invoice"}>{t('auto_invoice_on_check_out')}</label>
                            <span className="p-d-block">
                            <Dropdown id={"wizard_auto_invoice"} options={wizardAutoInvoiceBehaviors}
                                      optionLabel={(option) => window.App.getTranslatedLabel(option.key)}
                                      optionValue="value"
                                      value={wizardAccommodationData.auto_invoice}
                                      onChange={(e) => setWizardAccommodationField('auto_invoice', e.value)}/>
                          </span>
                            {wizardFieldError('auto_invoice')}
                          </div>
                        </div>
                        <div className={"p-col-12 p-lg-4"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"advance_invoice_trigger"}/>
                            <label htmlFor={"wizard_advance_invoice_trigger"}>{t('advance_invoice_trigger')}</label>
                            <span className="p-d-block">
                            <Dropdown id={"wizard_advance_invoice_trigger"} options={wizardAdvanceInvoiceTriggers}
                                      optionLabel={(option) => window.App.getTranslatedLabel(option.key)}
                                      optionValue="value"
                                      value={wizardAccommodationData.advance_invoice_trigger}
                                      onChange={(e) => {
                                        const nextTrigger = e.value;
                                        clearWizardFieldErrors('advance_invoice_trigger');
                                        clearWizardFieldErrors('advance_invoice_strategy');
                                        clearWizardFieldErrors('advance_invoice_value');
                                        setWizardAccommodationData((prev) => ({
                                          ...prev,
                                          advance_invoice_trigger: nextTrigger,
                                          advance_invoice_strategy: nextTrigger === 'NONE' ? null : prev.advance_invoice_strategy,
                                          advance_invoice_value: nextTrigger === 'NONE' ? null : prev.advance_invoice_value
                                        }));
                                      }}/>
                          </span>
                            {wizardFieldError('advance_invoice_trigger')}
                          </div>
                        </div>
                        {wizardAccommodationData.advance_invoice_trigger !== 'NONE' && (
                          <>
                            <div className={"p-col-12 p-lg-4"}>
                              <div className="p-field p-fluid">
                                <HelpComponent type={"field"} field={"advance_invoice_strategy"}/>
                                <label htmlFor={"wizard_advance_invoice_strategy"}>{t('advance_invoice_strategy')}</label>
                                <span className="p-d-block">
                                <Dropdown id={"wizard_advance_invoice_strategy"}
                                          options={wizardAdvanceInvoiceStrategies}
                                          optionLabel={(option) => window.App.getTranslatedLabel(option.key)}
                                          optionValue="value"
                                          value={wizardAccommodationData.advance_invoice_strategy}
                                          onChange={(e) => {
                                            const nextStrategy = e.value;
                                            const strategyTypes = ['FIXED_AMOUNT', 'PERCENTAGE'];
                                            const shouldResetValue = !strategyTypes.includes(nextStrategy);
                                            const isSwitchingBetweenValueStrategies = strategyTypes.includes(wizardAccommodationData.advance_invoice_strategy)
                                              && strategyTypes.includes(nextStrategy)
                                              && wizardAccommodationData.advance_invoice_strategy !== nextStrategy;
                                            const isAdvanceValueEmpty = wizardAccommodationData.advance_invoice_value === null
                                              || wizardAccommodationData.advance_invoice_value === undefined
                                              || wizardAccommodationData.advance_invoice_value === '';
                                            let nextValue = wizardAccommodationData.advance_invoice_value;
                                            if (shouldResetValue) {
                                              nextValue = null;
                                            } else if (isSwitchingBetweenValueStrategies) {
                                              nextValue = nextStrategy === 'FIXED_AMOUNT' ? 0 : 10;
                                            } else if (nextStrategy === 'FIXED_AMOUNT' && isAdvanceValueEmpty) {
                                              nextValue = 0;
                                            } else if (nextStrategy === 'PERCENTAGE' && isAdvanceValueEmpty) {
                                              nextValue = 10;
                                            }
                                            clearWizardFieldErrors('advance_invoice_strategy');
                                            clearWizardFieldErrors('advance_invoice_value');
                                            setWizardAccommodationData((prev) => ({
                                              ...prev,
                                              advance_invoice_strategy: nextStrategy,
                                              advance_invoice_value: nextValue
                                            }));
                                          }}/>
                              </span>
                                {wizardFieldError('advance_invoice_strategy')}
                              </div>
                            </div>
                            {['FIXED_AMOUNT', 'PERCENTAGE'].includes(wizardAccommodationData.advance_invoice_strategy) && (
                              <div className={"p-col-12 p-lg-4"}>
                                <div className="p-field p-fluid">
                                  <HelpComponent type={"field"} field={"advance_invoice_value"}/>
                                  <label htmlFor={"wizard_advance_invoice_value"}>{t('advance_invoice_value')}</label>
                                  <span className="p-d-block">
                                    {wizardAccommodationData.advance_invoice_strategy === 'FIXED_AMOUNT' && (
                                      <InputNumber id="wizard_advance_invoice_value"
                                                   value={normalizeAdvanceInvoiceValue(wizardAccommodationData.advance_invoice_value)}
                                                   mode="currency"
                                                   locale="hu-HU"
                                                   currency={wizardAccommodationData.currency || wizardAccommodationData.currency_code}
                                                   currencyDisplay="code"
                                                   min={0}
                                                   minFractionDigits={0}
                                                   maxFractionDigits={0}
                                                   onValueChange={(e) => setWizardAccommodationField('advance_invoice_value', e.value)}
                                      />
                                    )}
                                    {wizardAccommodationData.advance_invoice_strategy === 'PERCENTAGE' && (
                                      <div className="p-d-flex p-ai-center">
                                        <Slider id="wizard_advance_invoice_value"
                                                value={normalizeAdvanceInvoiceValue(wizardAccommodationData.advance_invoice_value) ?? 10}
                                                min={0}
                                                max={99}
                                                step={1}
                                                onChange={(e) => setWizardAccommodationField('advance_invoice_value', e.value)}
                                                style={{width: '100%'}}
                                        />
                                        <span style={{marginLeft: '0.75rem', minWidth: '3rem', textAlign: 'right'}}>
                                          {normalizeAdvanceInvoiceValue(wizardAccommodationData.advance_invoice_value) ?? 10}%
                                        </span>
                                      </div>
                                    )}
                                  </span>
                                  {wizardFieldError('advance_invoice_value')}
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </Panel>
                  )}

                  {wizardStep === 6 && (
                    <Panel className={"p-shadow-0"}>
                      <h2 className={"p-mt-0"}>{t('onboarding_step_channel_manager')}</h2>
                      <HelpComponent type={"section"} tabNumber={6} sectionNumber={0}/>
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-6"}>
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"channel_manager"}/>
                            <label htmlFor={"wizard_channel_manager"}>{t('channel_manager')}</label>
                            <span className="p-d-block">
                              <Dropdown id={"wizard_channel_manager"} options={wizardChannelManagers}
                                        optionLabel={(option) => window.App.getTranslatedLabel(option.key)}
                                        optionValue="value"
                                        value={wizardAccommodationData.channel_manager}
                                        onChange={(e) => setWizardAccommodationField('channel_manager', e.value)}/>
                            </span>
                            {wizardFieldError('channel_manager')}
                          </div>
                        </div>
                        {wizardAccommodationData.channel_manager === 'EZEE' && (
                          <>
                            <div className={"p-col-12 p-lg-12 p-xl-12"}>
                              <div className="p-field p-fluid">
                                <HelpComponent type={"field"} field={"ezee_centrix_hotel_code"}/>
                                <label htmlFor={"wizard_e_zee_centrix_hotel_code"}>{t('ezee_centrix_hotel_code')}</label>
                                <span className="p-d-block">
                                  <InputText id={"wizard_e_zee_centrix_hotel_code"}
                                             value={wizardAccommodationData.e_zee_centrix_hotel_code || ''}
                                             onChange={(e) => setWizardAccommodationField('e_zee_centrix_hotel_code', e.target.value)}/>
                                </span>
                                {wizardFieldError('e_zee_centrix_hotel_code')}
                              </div>
                            </div>
                            <div className={"p-col-12 p-lg-12 p-xl-12"}>
                              <div className="p-field p-fluid">
                                <HelpComponent type={"field"} field={"ezee_centrix_auth_key"}/>
                                <label htmlFor={"wizard_e_zee_centrix_auth_key"}>{t('ezee_centrix_auth_key')}</label>
                                <span className="p-d-block">
                                  <InputText id={"wizard_e_zee_centrix_auth_key"}
                                             value={wizardAccommodationData.e_zee_centrix_auth_key || ''}
                                             onChange={(e) => setWizardAccommodationField('e_zee_centrix_auth_key', e.target.value)}/>
                                </span>
                                {wizardFieldError('e_zee_centrix_auth_key')}
                              </div>
                            </div>
                          </>
                        )}
                        {wizardAccommodationData.channel_manager === 'FELHOMATRAC_ICAL_FEED' && (
                          <>
                            <div className={"p-col-12 p-lg-12 p-xl-12"}>
                              <div className="p-field p-fluid">
                                <HelpComponent type={"field"} field={"airbnb_calendar_url"}/>
                                <label htmlFor={"wizard_airbnb_calendar_url"}>{t('airbnb_calendar_url')}</label>
                                <span className="p-d-block">
                                  <InputText id={"wizard_airbnb_calendar_url"}
                                             value={wizardAccommodationData.airbnb_calendar_url || ''}
                                             onChange={(e) => setWizardAccommodationField('airbnb_calendar_url', e.target.value)}/>
                                </span>
                                {wizardFieldError('airbnb_calendar_url')}
                              </div>
                            </div>
                            <div className={"p-col-12 p-lg-12 p-xl-12"}>
                              <div className="p-field p-fluid">
                                <HelpComponent type={"field"} field={"szallas_calendar_url"}/>
                                <label htmlFor={"wizard_szallas_calendar_url"}>{t('szallas_calendar_url')}</label>
                                <span className="p-d-block">
                                  <InputText id={"wizard_szallas_calendar_url"}
                                             value={wizardAccommodationData.szallas_calendar_url || ''}
                                             onChange={(e) => setWizardAccommodationField('szallas_calendar_url', e.target.value)}/>
                                </span>
                                {wizardFieldError('szallas_calendar_url')}
                              </div>
                            </div>
                            <div className={"p-col-12 p-lg-12 p-xl-12"}>
                              <div className="p-field p-fluid">
                                <HelpComponent type={"field"} field={"booking_calendar_url"}/>
                                <label htmlFor={"wizard_booking_calendar_url"}>{t('booking_calendar_url')}</label>
                                <span className="p-d-block">
                                  <InputText id={"wizard_booking_calendar_url"}
                                             value={wizardAccommodationData.booking_calendar_url || ''}
                                             onChange={(e) => setWizardAccommodationField('booking_calendar_url', e.target.value)}/>
                                </span>
                                {wizardFieldError('booking_calendar_url')}
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </Panel>
                  )}

                  {wizardStep === 7 && (
                    <Panel className={"p-shadow-0"}>
                      <h2 className={"p-mt-0"}>{wizardCountrySpecificStepTitle}</h2>
                      <HelpComponent type={"section"} tabNumber={7} sectionNumber={0}/>
                      <div className={"p-grid p-mb-2"}>
                        <div className={"p-col-12"}>
                          <small className={"p-text-secondary"}>{wizardCountryName}</small>
                        </div>
                      </div>
                      <div className={"p-grid"}>
                        {wizardCountrySpecificFields.map((field, index) => {
                          if (!field?.name) return null;
                          if (field.name === 'accommodation') return null;
                          if (!isWizardCountrySpecificFieldVisible(field.name)) return null;
                          const value = wizardCountrySpecificData[field.name] ?? '';
                          const isHuCountrySpecific = (wizardAccommodationData?.country || '').toUpperCase() === 'HU';
                          const normalizedIfaType = typeof wizardCountrySpecificData?.ifa_type === 'string'
                            ? wizardCountrySpecificData.ifa_type.toLowerCase().trim()
                            : '';
                          const isHuFixAmountField = isHuCountrySpecific
                            && normalizedIfaType === 'fix_amount'
                            && ['ifa_night_fee', 'ifa_night'].includes(field.name);
                          const isHuPercentField = isHuCountrySpecific
                            && normalizedIfaType === 'percent'
                            && field.name === 'ifa_percent';
                          if (field.type.includes("Enum")) {
                            return (
                              <div key={field.name || index} className={"p-col-12 p-lg-6"}>
                                <div className="p-field p-fluid">
                                  <label htmlFor={"wizard_csf_" + field.name}>{t(field.name)}</label>
                                  <span className="p-d-block">
                                    <Dropdown id={"wizard_csf_" + field.name}
                                              options={wizardCountrySpecificOptions[field.name] || []}
                                              optionLabel={(option) => window.App.getTranslatedLabel(option.value)}
                                              optionValue="value"
                                              value={value}
                                              onChange={(e) => setWizardCountrySpecificField(field.name, e.value)}/>
                                  </span>
                                  {wizardFieldError(field.name)}
                                </div>
                              </div>
                            );
                          }
                          return (
                            <div key={field.name || index} className={"p-col-12 p-lg-6"}>
                              <div className="p-field p-fluid">
                                <label htmlFor={"wizard_csf_" + field.name}>{t(field.name)}</label>
                                <span className="p-d-block">
                                  {isHuFixAmountField ? (
                                    <InputNumber id={"wizard_csf_" + field.name}
                                                 value={value === '' ? null : value}
                                                 mode="currency"
                                                 locale="hu-HU"
                                                 currency={wizardAccommodationData.currency || wizardAccommodationData.currency_code}
                                                 currencyDisplay="code"
                                                 min={0}
                                                 minFractionDigits={0}
                                                 maxFractionDigits={0}
                                                 onValueChange={(e) => setWizardCountrySpecificField(field.name, e.value)}/>
                                  ) : isHuPercentField ? (
                                    <div className="p-d-flex p-ai-center">
                                      <Slider id={"wizard_csf_" + field.name}
                                              value={value === '' ? 4 : value}
                                              min={0}
                                              max={99}
                                              step={1}
                                              onChange={(e) => setWizardCountrySpecificField(field.name, e.value)}
                                              style={{width: '100%'}}
                                      />
                                      <span style={{marginLeft: '0.75rem', minWidth: '3rem', textAlign: 'right'}}>
                                        {value === '' ? 4 : value}%
                                      </span>
                                    </div>
                                  ) : (
                                    <InputText id={"wizard_csf_" + field.name}
                                               value={value}
                                               keyfilter={field.type.includes("Integer") ? "num" : undefined}
                                               onChange={(e) => setWizardCountrySpecificField(field.name, e.target.value)}/>
                                  )}
                                </span>
                                {wizardFieldError(field.name)}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </Panel>
                  )}

                  {wizardStep === 8 && (
                    <div className={"p-text-center"}>
                      <HelpComponent type={"section"} tabNumber={8} sectionNumber={0}/>
                      <img src={wizardEnd} alt={"Felhomatrac Varázsló"} style={{width: '200px'}}/>
                      <h2 className={"p-my-0"}>{t('onboarding_done_title')}</h2>
                      <h3>{t('onboarding_done_reminder')}</h3>
                      <p className={"onboarding_welcome_text p-my-0"}>{t('onboarding_done_support')}</p>
                    </div>
                  )}

                  <div
                    className={"fm-onboarding-wizard__actions" + (wizardStep === 1 ? " fm-onboarding-wizard__actions--single" : "")}>
                    {wizardStep > 1 && (
                      <Button type="button"
                              label={t('onboarding_back')}
                              className="p-button-warning-alt"
                              disabled={wizardSaving || wizardLoading}
                              onClick={onWizardBack}/>
                    )}
                    <div className={"fm-onboarding-wizard__action-group"}>
                      {wizardStep === 7 && (
                        <Button type="button"
                                label={t('onboarding_save_without_ntak_settings')}
                                className="p-button-warning-alt"
                                disabled={wizardSaving || wizardLoading}
                                onClick={onWizardSaveWithoutNtakSettings}/>
                      )}
                      <Button type="button"
                              label={wizardStep === 1 ? t('onboarding_start') : (wizardStep === 8 ? t('onboarding_finish') : t('onboarding_continue'))}
                              className="p-button-succes-alt"
                              loading={wizardSaving || wizardLoading}
                              onClick={onWizardNext}/>
                      {wizardStep === 8 && (
                        <span className={"p-d-none p-d-lg-block"}>
                        <Button type="button"
                                label={t('onboarding_go_to_builder')}
                                className="p-button-warning-alt"
                                disabled={wizardSaving || wizardLoading}
                                onClick={() => navigate('/builder')}/>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Dialog>

            <div className={"p-p-3 p-mb-3 p-p-lg-0"}
                 style={{maxWidth: '1910px', marginLeft: 'auto', marginRight: 'auto'}}>
              <Accordion activeIndex={null} className={"p-my-0 p-shadow-0"}>
                <AccordionTab header={
                  <>
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6  p-p-0 p-m-0"}>
                        <div className={"p-grid p-p-0 p-m-0"}>
                          <div className={"p-col p-col-align-center p-text-right"} style={{maxWidth: '35px'}}>
                            <i className={"pi pi-cog"} style={{'fontSize': '1.5em'}}></i>
                          </div>
                          <div className={"p-col p-col-align-center"}>
                            <small className={"p-text-uppercase"}>{t('setup_state_descr')}</small>
                            <h3 className={"p-m-0 p-p-0 p-text-secondary"}>{t('setup_state')}</h3>
                          </div>
                        </div>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-p-0 p-m-0"}>
                        <div style={{position: 'relative'}}>
                          <ProgressBar value={setupProgressPercent}
                                       style={{position: 'relative', zIndex: 0}}></ProgressBar>
                          {setupProgressPercent === 0 && (
                            <span style={{
                              position: 'absolute',
                              top: '50%',
                              left: '0.5rem',
                              transform: 'translateY(-50%)',
                              fontSize: '1rem',
                              color: 'var(--text-color-secondary, #6c757d)'
                            }}>
                                  0%
                                </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className={"p-grid p-mt-0 p-mx-2 fm-controlpanel-setup-overview"}>
                      <div className={"p-col-6 fm-controlpanel-setup-overview-item"}>
                        <div className={"p-d-flex"}>
                          {setupState?.operator_data?.is_ready === true ? (
                            <i className={"pi pi-check-circle p-text-success p-mr-3"} style={{fontSize: '2.2rem'}}></i>
                          ) : (
                            <i className={"pi pi-exclamation-triangle p-text-warning p-mr-3"}
                               style={{fontSize: '2.2rem'}}></i>
                          )}
                          <div className={""}>
                            <span className={"p-d-block p-text-bold"}>{t('setup_overview_operator_data')}</span>
                            <span
                              className={"p-d-block " + (setupStep1Ready ? 'p-text-success' : 'p-text-warning')}
                              {...(!setupStep1Ready ? getSetupWarningLinkProps('/operator/create') : {})}>
                              {setupStep1Ready ? t('setup_status_ready') : t('setup_status_incomplete')}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={"p-col-6 fm-controlpanel-setup-overview-item"}>
                        <div className={"p-d-flex"}>
                          {setupState?.accommodations?.is_ready === true ? (
                            <i className={"pi pi-check-circle p-text-success p-mr-3"} style={{fontSize: '2.2rem'}}></i>
                          ) : (
                            <i className={"pi pi-exclamation-triangle p-text-warning p-mr-3"}
                               style={{fontSize: '2.2rem'}}></i>
                          )}
                          <div className={""}>
                            <span className={"p-d-block p-text-bold"}>{t('setup_overview_accommodation_data')}</span>
                            <span
                              className={"p-d-block " + (setupStep2Ready ? 'p-text-success' : 'p-text-warning')}
                              {...(!setupStep2Ready ? getSetupWarningLinkProps('/accommodation/create') : {})}>
                              {setupStep2Ready ? t('setup_status_ready') : t('setup_status_incomplete')}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={"p-col-6 fm-controlpanel-setup-overview-item"}>
                        <div className={"p-d-flex p-ai-center"}>
                          {setupState?.accommodations?.items?.length > 0 && setupState.accommodations.items.every((accommodation) => accommodation?.residential_categories?.items?.length > 0 && accommodation.residential_categories.items.every((category) => category?.is_ready === true)) ? (
                            <i className={"pi pi-check-circle p-text-success p-mr-3"} style={{fontSize: '2.2rem'}}></i>
                          ) : (
                            <i className={"pi pi-exclamation-triangle p-text-warning p-mr-3"}
                               style={{fontSize: '2.2rem'}}></i>
                          )}
                          <div className={""}>
                            <span className={"p-d-block p-text-bold"}>{t('setup_overview_categories')}</span>
                            <span
                              className={"p-d-block " + (setupStep3Ready ? 'p-text-success' : 'p-text-warning')}
                              {...(!setupStep3Ready ? getSetupWarningLinkProps('/category/create') : {})}>
                              {setupStep3Ready ? t('setup_status_ready') : t('setup_status_incomplete')}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={"p-col-6 fm-controlpanel-setup-overview-item"}>
                        <div className={"p-d-flex p-ai-center"}>
                          {setupStep4Ready ? (
                            <i className={"pi pi-check-circle p-text-success p-mr-3"} style={{fontSize: '2.2rem'}}></i>
                          ) : (
                            <i className={"pi pi-exclamation-triangle p-text-warning p-mr-3"}
                               style={{fontSize: '2.2rem'}}></i>
                          )}
                          <div className={""}>
                            <span className={"p-d-block p-text-bold"}>{t('setup_overview_units')}</span>
                            <span
                              className={"p-d-block " + (setupStep4Ready ? 'p-text-success' : 'p-text-warning')}
                              {...(!setupStep4Ready ? getSetupWarningLinkProps('/unit/create') : {})}>
                              {setupStep4Ready ? t('setup_status_ready') : t('setup_status_incomplete')}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={"p-col-6 fm-controlpanel-setup-overview-item"}>
                        <div className={"p-d-flex p-ai-center"}>
                          {setupStep5Ready ? (
                            <i className={"pi pi-check-circle p-text-success p-mr-3"} style={{fontSize: '2.2rem'}}></i>
                          ) : (
                            <i className={"pi pi-exclamation-triangle p-text-warning p-mr-3"}
                               style={{fontSize: '2.2rem'}}></i>
                          )}
                          <div>
                            <span className={"p-d-block p-text-bold"}>{t('setup_overview_pricing')}</span>
                            <span
                              className={"p-d-block " + (setupStep5Ready ? 'p-text-success' : 'p-text-warning')}
                              {...(!setupStep5Ready ? getSetupWarningLinkProps(setupPricingRoute) : {})}>
                              {setupStep5Ready ? t('setup_status_ready') : t('setup_status_incomplete')}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                }>
                  {setupState?.accommodations?.items?.length > 0 && (
                    <>
                      <h3 className={"p-mt-3 p-mb-3 p-d-flex p-ai-center"}>
                        <i className={"pi pi-building p-mr-2"} style={{fontSize: '1.8rem'}}></i>
                        {t('accommodations')}
                      </h3>
                      <div className={"p-grid p-mt-0 fm-controlpanel-accommodations-grid"}>
                        {setupState.accommodations.items.map((accommodation) => {
                          const categories = accommodation?.residential_categories?.items || [];
                          const categoriesCount = categories.length;
                          const units = categories.reduce((allUnits, category) => {
                            return allUnits.concat(category?.residential_units?.items || []);
                          }, []);
                          const unitsCount = units.length;
                          const unitsWithMissingPricesCount = units.filter((unit) => {
                            return !isSetupUnitPricingReady(unit);
                          }).length;
                          const firstCategoryWithMissingPrices = categories.find((category) =>
                            (category?.residential_units?.items || []).some((unit) => !isSetupUnitPricingReady(unit)));
                          const firstUnitWithMissingPrices = (firstCategoryWithMissingPrices?.residential_units?.items || [])
                            .find((unit) => !isSetupUnitPricingReady(unit));
                          const accommodationPricingRoute = firstUnitWithMissingPrices
                            ? getSetupUnitPriceRoute(firstUnitWithMissingPrices, firstCategoryWithMissingPrices)
                            : '/unit/create';

                          return (
                            <div
                              key={accommodation.id}
                              className={"p-col-12 " + (hasSingleAccommodation ? 'p-lg-12' : 'p-lg-6') + " fm-controlpanel-accommodations-grid-col"}>
                              <div className={"p-p-3 fm-controlpanel-setup-surface"}>
                                <h3 className={"p-my-0 p-mb-3"}>
                                  {accommodation.name}
                                </h3>
                                <div className={"p-grid p-mt-0"}>
                                  <div className={"p-col-12 p-lg-6"}>
                                    <div className={"p-d-flex p-ai-center"}>
                                      {categoriesCount > 0 ? (
                                        <i className={"pi pi-check-circle p-text-success p-mr-2"}
                                           style={{fontSize: '1.6rem'}}></i>
                                      ) : (
                                        <i className={"pi pi-exclamation-circle p-text-warning p-mr-2"}
                                           style={{fontSize: '1.6rem'}}></i>
                                      )}
                                      <div>
                                        <span className={"p-d-block p-text-bold"}>{t('setup_overview_categories')}</span>
                                        <span
                                          className={"p-d-block " + (categoriesCount > 0 ? 'p-text-success' : 'p-text-warning')}
                                          {...(categoriesCount === 0 ? getSetupWarningLinkProps('/category/create') : {})}>
                                          {categoriesCount > 0 ? t('setup_categories_configured', {count: categoriesCount}) : t('setup_status_incomplete')}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className={"p-col-12 p-lg-6"}>
                                    <div className={"p-d-flex p-ai-center"}>
                                      {unitsCount === 0 ? (
                                        <i className={"pi pi-exclamation-circle p-text-warning p-mr-2"}
                                           style={{fontSize: '1.6rem'}}></i>
                                      ) : unitsWithMissingPricesCount > 0 ? (
                                        <i className={"pi pi-exclamation-triangle p-text-warning p-mr-2"}
                                           style={{fontSize: '1.6rem'}}></i>
                                      ) : (
                                        <i className={"pi pi-check-circle p-text-success p-mr-2"}
                                           style={{fontSize: '1.6rem'}}></i>
                                      )}
                                      <div>
                                        <span className={"p-d-block p-text-bold"}>{t('setup_overview_units')}</span>
                                        {unitsCount === 0 ? (
                                          <span
                                            className={"p-d-block p-text-warning"}
                                            {...getSetupWarningLinkProps('/unit/create')}>{t('setup_status_incomplete')}</span>
                                        ) : unitsWithMissingPricesCount > 0 ? (
                                          <span className={"p-d-block p-text-warning"}
                                                {...getSetupWarningLinkProps(accommodationPricingRoute)}>
                                            {t('setup_units_with_missing_prices', {
                                              unitsCount,
                                              missingCount: unitsWithMissingPricesCount
                                            })}
                                          </span>
                                        ) : (
                                          <span
                                            className={"p-d-block p-text-success"}>{t('setup_units_configured', {count: unitsCount})}</span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  {categories.length === 0 ? (
                                    <div className={"p-p-3 p-mt-3 fm-controlpanel-setup-surface-inner"}>
                                      <strong>{t('setup_no_categories_configured')}</strong>
                                      {missingCategoriesTodo && (
                                        <div className={"p-mt-3"}>
                                          <div
                                            className={"p-d-flex p-ai-center p-jc-between p-p-2 fm-controlpanel-setup-surface"}
                                            style={{flexDirection: 'row'}}>
                                            <div className={"p-d-flex p-ai-center"}>
                                              <i className={"pi pi-exclamation-circle p-text-warning p-mr-2"}></i>
                                              <span>{missingCategoriesTodo.label}</span>
                                            </div>
                                            <i
                                              className={"pi pi-angle-right"}
                                              style={{cursor: 'pointer'}}
                                              onClick={() => navigate(missingCategoriesTodo.route)}></i>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  ) : (
                                    categories.map((category) => {
                                      const categoryUnits = category?.residential_units?.items || [];
                                      const categoryUnitsWithMissingPricesCount = categoryUnits.filter((unit) => {
                                        const pricedDays = Number(unit?.prices?.items?.priced_days || 0);
                                        const requiredDays = Number(unit?.prices?.items?.required_days || 0);
                                        return requiredDays <= 0 || pricedDays < requiredDays;
                                      }).length;

                                      return (
                                        <div key={category.id || category.name}
                                             className={"p-p-3 p-mt-3 fm-controlpanel-setup-surface-inner"}>
                                          <div className={"p-grid"}>
                                            <div className={"p-col p-text-bold"}>{category.name}</div>
                                            <div
                                              className={"p-col p-text-bold " + (categoryUnitsWithMissingPricesCount > 0 ? 'p-text-warning' : '')}
                                              {...(categoryUnitsWithMissingPricesCount > 0
                                                ? getSetupWarningLinkProps(getSetupCategoryPriceRoute(category))
                                                : {})}>
                                              {categoryUnits.length === 0
                                                ? t('setup_status_incomplete')
                                                : categoryUnitsWithMissingPricesCount > 0
                                                  ? t('setup_units_prices_missing', {count: categoryUnitsWithMissingPricesCount})
                                                  : t('setup_status_ready')}
                                            </div>
                                          </div>
                                          <div>
                                            {categoryUnits.length === 0 ? (
                                              <div>{t('setup_no_units_configured')}</div>
                                            ) : (
                                              categoryUnits.map((unit, unitIndex) => {
                                                const pricedDays = Number(unit?.prices?.items?.priced_days || 0);
                                                const requiredDays = Number(unit?.prices?.items?.required_days || 0);
                                                const startDate = unit?.prices?.items?.start_date || '-';
                                                const endDate = unit?.prices?.items?.end_date || '-';
                                                const unitPricingReady = requiredDays > 0 && pricedDays >= requiredDays;

                                                return (
                                                  <div className={"p-grid"}
                                                       key={unit.id || (unit.name + '-' + unitIndex)}>
                                                    <div className={"p-col"}>{unit.name}</div>
                                                    <div
                                                      className={"p-col " + (unitPricingReady ? '' : 'p-text-warning')}
                                                      {...(!unitPricingReady
                                                        ? getSetupWarningLinkProps(getSetupUnitPriceRoute(unit, category))
                                                        : {})}>
                                                      {unitPricingReady ? t('setup_status_ready') : t('setup_status_incomplete')}
                                                    </div>
                                                    <div className={"p-col"}>
                                                      {requiredDays > 0
                                                        ? (
                                                          <>
                                                              <span
                                                                className={pricedDays < requiredDays ? 'p-text-warning' : 'p-text-success'}
                                                                {...(pricedDays < requiredDays
                                                                  ? getSetupWarningLinkProps(getSetupUnitPriceRoute(unit, category))
                                                                  : {})}>
	                                                              {pricedDays}
	                                                            </span>
                                                            <span>{t('setup_unit_price_progress_tail', {requiredDays})}</span>
                                                          </>
                                                        )
                                                        : (
                                                          <span className={"p-text-warning"}
                                                                {...getSetupWarningLinkProps(getSetupUnitPriceRoute(unit, category))}>
                                                            {t('setup_unit_price_progress_missing')}
                                                          </span>
                                                        )}
                                                    </div>
                                                    <div className={"p-col"}>{t('setup_unit_price_period', {
                                                      startDate,
                                                      endDate
                                                    })}</div>
                                                  </div>
                                                );
                                              })
                                            )}
                                          </div>
                                        </div>
                                      );
                                    })
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}

                  <div className={"p-grid p-mt-3 p-mx-auto"} style={{maxWidth: '600px'}}>
                    <div className={"p-col-12 p-lg-4 p-col-align-center p-text-center"}>
                      <img src={wizard} alt={t('wizard')} style={{width: '150px'}}/>
                    </div>
                    <div className={"p-col-12 p-lg-8 p-col-align-center"}>
                      <h3 className={"p-mt-0"}>
                        {t('setup_state_help_title')}
                      </h3>
                      <p className={"p-text-secondary p-mb-0"} style={{whiteSpace: 'pre-line'}}>
                        {t('setup_state_help_secondary')}
                      </p>
                    </div>
                  </div>

                </AccordionTab>
              </Accordion>
            </div>
            {accommodations && !accommodations[0] && wizardModalVisible === false &&
              <Button
                type="button"
                label={t('onboarding_open_wizard')}
                icon={"pi pi-star-fill"}
                onClick={() => {
                  setWizardModalVisible(true)
                }}
                className="p-button-warning"
                style={{position: 'fixed', bottom: '20px', left: '20px'}}
              />
            }
            {accommodations && accommodations[0] &&
              <div className={"p-p-3 p-p-lg-0"}>
                <Card className={"p-my-2 p-shadow-0"}
                      style={{maxWidth: '1910px', marginLeft: 'auto', marginRight: 'auto'}}>
                  <div className={"p-grid col-borders"}>
                    <div className={"p-col-12 p-lg-6 col-border-right"}>
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-5 p-col-align-center"}>
                          <small className={"p-text-uppercase"}>{t('arrivals')}</small>
                          <h3 className={"p-m-0 p-p-0 p-text-secondary"}>{checksArrivalDay}</h3>
                        </div>
                        <div className={"p-col-12 p-lg-3 p-col-align-center"}>
                      <span className="p-inputgroup">
                        <InputText id="search"
                                   disabled={!checksArrivals.length}
                                   placeholder={t('search')}
                                   onChange={(e) => {
                                     setChecksArrivalsFiltered(checksArrivals)
                                     clearTimeout(window.searchTimeout)
                                     window.searchTimeout = setTimeout(function () {
                                       if (e.target.value.length > 1) {
                                         const lowerCaseQuery = e.target.value.toLowerCase();
                                         const filtered = checksArrivals.filter((arrival) =>
                                           Object.values(arrival).some((value) =>
                                             (value?.toString().toLowerCase() || '').includes(lowerCaseQuery)
                                           )
                                         );
                                         setChecksArrivalsFiltered(filtered);
                                       } else {
                                         setChecksArrivalsFiltered(checksArrivals)
                                       }
                                     }, 1000)
                                   }}
                                   className={""}
                        />
                      </span>
                        </div>
                        <div className={"p-col p-col-align-center"}>
                      <span className={"p-inputgroup"}>
                        <Button label={"-1"}
                                disabled={loading}
                                className={"p-button-success"}
                                onClick={() => {
                                  setChecksArrivalDay(moment(checksArrivalDay).subtract(+1, 'days').format(t('YYYY-MM-DD')))
                                }}/>
                        <Calendar value={checksArrivalDay ? moment(checksArrivalDay, 'YYYY-MM-DD').toDate() : null}
                                  dateFormat={t('YY-MM-DD')}
                                  placeholder={checksArrivalDay}
                                  locale="default"
                                  id={"checksArrivalDay"}
                                  onChange={(e) => {
                                    setChecksArrivalDay(moment.utc(e.value).local().format(t('YYYY-MM-DD')))
                                  }}/>
                        <Button label={"+1"}
                                disabled={loading}
                                className={"p-button-success"}
                                onClick={() => {
                                  setChecksArrivalDay(moment(checksArrivalDay).subtract(-1, 'days').format(t('YYYY-MM-DD')))
                                }}/>
                      </span>
                        </div>
                        <div className={"p-col p-col-align-center p-text-right"} style={{maxWidth: '35px'}}>
                          <i className={"pi pi-download"} style={{'fontSize': '1.5em'}}></i>
                        </div>
                      </div>
                      <div className={"p-datatable-wrapper"}>
                        <table
                          className={"w-100 p-datatable p-datatable-table table-striped controlpanel-checks-table"}
                          cellPadding={0}
                          cellSpacing={0} border={0}>
                          <thead>
                          <tr>
                            <th className={"p-text-left"}>{t('name')}</th>
                            <th className={"p-text-left"}>{t('id_type')}</th>
                            <th className={"p-text-left"}>{t('id_number')}</th>
                            <th className={"p-text-left"}>{t('reserved_from')}</th>
                            <th className={"p-text-left"}>{t('status')}</th>
                          </tr>
                          </thead>
                          <tbody>
                          {checksArrivalsFiltered && checksArrivalsFiltered[0] ? (
                            <>
                              {checksArrivalsFiltered.map((arrival, index) => {
                                return (
                                  <tr key={index}>
                                    <td>
                                      <span className={"controlpanel-checks-table__label"}>{t('name')}</span>
                                      {arrival.firstname} {arrival.lastname}
                                    </td>
                                    <td>
                                      <span className={"controlpanel-checks-table__label"}>{t('id_type')}</span>
                                      {t(arrival?.idType?.toLowerCase())}
                                    </td>
                                    <td>
                                      <span className={"controlpanel-checks-table__label"}>{t('id_number')}</span>
                                      {arrival.idNumber}
                                    </td>
                                    <td className={"p-text-left"}>
                                      <span className={"controlpanel-checks-table__label"}>{t('reserved_from')}</span>
                                      <span
                                        className={"p-text-bold"}>{moment.utc(arrival.reservedFrom).local().format(t('YYYY-MM-DD'))}</span>
                                    </td>
                                    <td className={"p-text-right controlpanel-checks-table__actions"}
                                        style={{'width': '160px'}}>
                                      <span className={"controlpanel-checks-table__label"}>{t('status')}</span>
                                      {(() => {
                                        if (arrival.status === 'will_arrive') {
                                          return (
                                            <>
                                              <Button
                                                type="button"
                                                label={t('check_in')}
                                                icon={"pi pi-sign-in"}
                                                loading={loading}
                                                onClick={() => {
                                                  window.App.setState({[`confirmArrivalCheckIn${arrival.id}`]: true})
                                                }}
                                                className="p-button-success p-button-sm p-mr-2 p-d-block w-100 p-text-nowrap"
                                              />
                                              <ConfirmDialog group="declarative"
                                                             visible={window.App.state[`confirmArrivalCheckIn${arrival.id}`]}
                                                             acceptLabel={t('yes')} rejectLabel={t('no')}
                                                             onHide={() => {
                                                               window.App.setState({[`confirmArrivalCheckIn${arrival.id}`]: false})
                                                             }}
                                                             message={t('confirm_event_patch_message')}
                                                             header={t('check_in')}
                                                             icon="pi pi-exclamation-triangle"
                                                             accept={() => {
                                                               window.App.setState({[`confirmArrivalCheckIn${arrival.id}`]: false})
                                                               setLoading(true)
                                                               axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest/" + arrival.id,
                                                                 {
                                                                   status: "checked_in",
                                                                 },
                                                                 {
                                                                   params: {},
                                                                   headers: {
                                                                     'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                                                     "Sys-name": Cookies.get("instanceId"),
                                                                     "Preferred-locale": Cookies.get("language")
                                                                   }
                                                                 })
                                                                 .then(response => {
                                                                   setLoading(false)
                                                                   window.App.setState({rerenderReservationGuestList: Math.random()})
                                                                   window.App.toastShow('success', t('success'), response.data.message)
                                                                 })
                                                                 .catch(error => {
                                                                   setLoading(false)
                                                                   window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                                                 })
                                                             }}
                                                             reject={() => {
                                                               window.App.setState({[`confirmArrivalCheckIn${arrival.id}`]: false})
                                                             }}/>
                                            </>
                                          );
                                        } else if (arrival.status === 'checked_in') {
                                          return (
                                            <>
                                              <Button
                                                type="button"
                                                label={t('check_out')}
                                                icon={"pi pi-sign-out"}
                                                loading={loading}
                                                onClick={() => {
                                                  window.App.setState({[`confirmArrivalCheckOut${arrival.id}`]: true})
                                                }}
                                                className="p-button-warning p-button-sm p-mr-2 p-d-block w-100"
                                              />
                                              <ConfirmDialog group="declarative"
                                                             visible={window.App.state[`confirmArrivalCheckOut${arrival.id}`]}
                                                             acceptLabel={t('yes')} rejectLabel={t('no')}
                                                             onHide={() => {
                                                               window.App.setState({[`confirmArrivalCheckOut${arrival.id}`]: false})
                                                             }}
                                                             message={t('confirm_event_patch_message')}
                                                             header={t('check_out')}
                                                             icon="pi pi-exclamation-triangle"
                                                             accept={() => {
                                                               window.App.setState({[`confirmArrivalCheckOut${arrival.id}`]: false})
                                                               setLoading(true)
                                                               axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest/" + arrival.id,
                                                                 {
                                                                   status: "checked_out",
                                                                 },
                                                                 {
                                                                   params: {},
                                                                   headers: {
                                                                     'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                                                     "Sys-name": Cookies.get("instanceId"),
                                                                     "Preferred-locale": Cookies.get("language")
                                                                   }
                                                                 })
                                                                 .then(response => {
                                                                   setLoading(false)
                                                                   window.App.setState({rerenderReservationGuestList: Math.random()})
                                                                   window.App.toastShow('success', t('success'), response.data.message)
                                                                 })
                                                                 .catch(error => {
                                                                   setLoading(false)
                                                                   window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                                                 })
                                                             }}
                                                             reject={() => {
                                                               window.App.setState({[`confirmArrivalCheckOut${arrival.id}`]: false})
                                                             }}/>
                                            </>
                                          );
                                        } else {
                                          return (
                                            <>
                                              <Button
                                                type="button"
                                                label={t('check_in')}
                                                icon={"pi pi-sign-in"}
                                                loading={loading}
                                                onClick={() => {
                                                  window.App.setState({[`confirmArrivalCheckIn${arrival.id}`]: true})
                                                }}
                                                className="p-button-success p-button-sm p-mr-2 p-d-block w-100"
                                              />
                                              <ConfirmDialog group="declarative"
                                                             visible={window.App.state[`confirmArrivalCheckIn${arrival.id}`]}
                                                             acceptLabel={t('yes')} rejectLabel={t('no')}
                                                             onHide={() => {
                                                               window.App.setState({[`confirmArrivalCheckIn${arrival.id}`]: false})
                                                             }}
                                                             message={t('confirm_event_patch_message')}
                                                             header={t('check_in')}
                                                             icon="pi pi-exclamation-triangle"
                                                             accept={() => {
                                                               window.App.setState({[`confirmArrivalCheckIn${arrival.id}`]: false})
                                                               setLoading(true)
                                                               axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest/" + arrival.id,
                                                                 {
                                                                   status: "checked_in",
                                                                 },
                                                                 {
                                                                   params: {},
                                                                   headers: {
                                                                     'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                                                     "Sys-name": Cookies.get("instanceId"),
                                                                     "Preferred-locale": Cookies.get("language")
                                                                   }
                                                                 })
                                                                 .then(response => {
                                                                   setLoading(false)
                                                                   window.App.setState({rerenderReservationGuestList: Math.random()})
                                                                   window.App.toastShow('success', t('success'), response.data.message)
                                                                 })
                                                                 .catch(error => {
                                                                   setLoading(false)
                                                                   window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                                                 })
                                                             }}
                                                             reject={() => {
                                                               window.App.setState({[`confirmArrivalCheckIn${arrival.id}`]: false})
                                                             }}/>
                                            </>
                                          );
                                        }
                                      })()}
                                    </td>
                                  </tr>
                                )
                              })}
                            </>
                          ) : (
                            <tr>
                              <td colSpan={6}>{t('arrival_not_found')}</td>
                            </tr>
                          )}
                          </tbody>
                        </table>
                      </div>
                      <div className={"p-grid p-mt-2"}>
                        <div className={"p-col-12 p-col-align-center p-text-right p-pb-0"}>
                          <Button
                            type="button"
                            label={t('export_csv')}
                            icon={"pi pi-download"}
                            loading={loading}
                            disabled={!checksArrivalsFiltered.length}
                            onClick={() => {
                              setLoading(true)
                              axios.get(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "export/arrivals?start_date=" + checksArrivalDay,
                                {
                                  responseType: 'blob',
                                  params: {},
                                  headers: {
                                    'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                    "Sys-name": Cookies.get("instanceId"),
                                    "Preferred-locale": Cookies.get("language")
                                  }
                                })
                                .then(response => {
                                  setLoading(false)
                                  const contentDisposition = response?.headers?.['content-disposition'] || response?.headers?.['Content-Disposition'];
                                  const utf8FileNameMatch = contentDisposition?.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
                                  const fileNameMatch = contentDisposition?.match(/filename\s*=\s*("?)([^";]+)\1/i);
                                  const headerFileName = utf8FileNameMatch?.[1]
                                    ? decodeURIComponent(utf8FileNameMatch[1].trim().replace(/^["']|["']$/g, ''))
                                    : fileNameMatch?.[2]?.trim();
                                  fileDownload(response.data, headerFileName || `arrivals_${checksArrivalDay}.csv`);
                                })
                                .catch(error => {
                                  setLoading(false)
                                  window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error.response)
                                })
                            }}
                            className="p-button-warning p-ml-2"
                          />
                          <Button
                            type="button"
                            label={t('export_xlsx')}
                            icon={"pi pi-download"}
                            loading={loading}
                            disabled={!checksArrivalsFiltered.length}
                            onClick={() => {
                              setLoading(true)
                              axios.get(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "export/arrivals?start_date=" + checksArrivalDay + "&format=xlsx",
                                {
                                  responseType: 'blob',
                                  params: {},
                                  headers: {
                                    'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                    "Sys-name": Cookies.get("instanceId"),
                                    "Preferred-locale": Cookies.get("language")
                                  }
                                })
                                .then(response => {
                                  setLoading(false)
                                  const contentDisposition = response?.headers?.['content-disposition'] || response?.headers?.['Content-Disposition'];
                                  const utf8FileNameMatch = contentDisposition?.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
                                  const fileNameMatch = contentDisposition?.match(/filename\s*=\s*("?)([^";]+)\1/i);
                                  const headerFileName = utf8FileNameMatch?.[1]
                                    ? decodeURIComponent(utf8FileNameMatch[1].trim().replace(/^["']|["']$/g, ''))
                                    : fileNameMatch?.[2]?.trim();
                                  fileDownload(response.data, headerFileName || `arrivals_${checksArrivalDay}.xlsx`);
                                })
                                .catch(error => {
                                  setLoading(false)
                                  window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error.response)
                                })
                            }}
                            className="p-button-warning p-ml-2"
                          />
                        </div>
                      </div>
                    </div>
                    <div className={"p-col-12 p-lg-6 col-border-left"}>
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-5 p-col-align-center"}>
                          <small className={"p-text-uppercase"}>{t('departures')}</small>
                          <h3 className={"p-m-0 p-p-0 p-text-secondary"}>{checksDepartureDay}</h3>
                        </div>
                        <div className={"p-col-12 p-lg-3 p-col-align-center"}>
                      <span className="p-inputgroup">
                        <InputText id="search"
                                   placeholder={t('search')}
                                   disabled={!checksDepartures.length}
                                   onChange={(e) => {
                                     setChecksDeparturesFiltered(checksDepartures)
                                     clearTimeout(window.searchTimeout)
                                     window.searchTimeout = setTimeout(function () {
                                       if (e.target.value.length > 1) {
                                         const lowerCaseQuery = e.target.value.toLowerCase();
                                         const filtered = checksDepartures.filter((departure) =>
                                           Object.values(departure).some((value) =>
                                             (value?.toString().toLowerCase() || '').includes(lowerCaseQuery)
                                           )
                                         );
                                         setChecksDeparturesFiltered(filtered);
                                       } else {
                                         setChecksDeparturesFiltered(checksDepartures)
                                       }
                                     }, 1000)
                                   }}
                                   className={""}
                        />
                      </span>
                        </div>
                        <div className={"p-col p-col-align-center"}>
                      <span className={"p-inputgroup"}>
                        <Button label={"-1"}
                                disabled={loading}
                                className={"p-button-success"}
                                onClick={() => {
                                  setChecksDepartureDay(moment(checksDepartureDay).subtract(+1, 'days').format(t('YYYY-MM-DD')))
                                }}/>
                        <Calendar value={checksDepartureDay ? moment(checksDepartureDay, 'YYYY-MM-DD').toDate() : null}
                                  dateFormat={t('YY-MM-DD')}
                                  placeholder={checksDepartureDay}
                                  locale="default"
                                  id={"checksDepartureDay"}
                                  onChange={(e) => {
                                    setChecksDepartureDay(moment.utc(e.value).local().format(t('YYYY-MM-DD')))
                                  }}/>
                        <Button label={"+1"}
                                disabled={loading}
                                className={"p-button-success"}
                                onClick={() => {
                                  setChecksDepartureDay(moment(checksDepartureDay).subtract(-1, 'days').format(t('YYYY-MM-DD')))
                                }}/>
                      </span>
                        </div>
                        <div className={"p-col p-col-align-center p-text-right"} style={{maxWidth: '35px'}}>
                          <i className={"pi pi-upload"} style={{'fontSize': '1.5em'}}></i>
                        </div>
                      </div>
                      <div className={"p-datatable-wrapper"}>
                        <table
                          className={"w-100 p-datatable p-datatable-table table-striped controlpanel-checks-table"}
                          cellPadding={0}
                          cellSpacing={0}
                          border={0}>
                          <thead>
                          <tr>
                            <th className={"p-text-left"}>{t('name')}</th>
                            <th className={"p-text-left"}>{t('id_type')}</th>
                            <th className={"p-text-left"}>{t('id_number')}</th>
                            <th className={"p-text-left"}>{t('reserved_from')}</th>
                            <th className={"p-text-left"}>{t('status')}</th>
                          </tr>
                          </thead>
                          <tbody>
                          {checksDeparturesFiltered && checksDeparturesFiltered[0] ? (
                            <>
                              {checksDeparturesFiltered.map((departure, index) => {
                                return (
                                  <tr key={index}>
                                    <td>
                                      <span className={"controlpanel-checks-table__label"}>{t('name')}</span>
                                      {departure.firstname} {departure.lastname}
                                    </td>
                                    <td>
                                      <span className={"controlpanel-checks-table__label"}>{t('id_type')}</span>
                                      {t(departure?.idType?.toLowerCase())}
                                    </td>
                                    <td>
                                      <span className={"controlpanel-checks-table__label"}>{t('id_number')}</span>
                                      {departure.idNumber}
                                    </td>
                                    <td className={"p-text-left"}>
                                      <span className={"controlpanel-checks-table__label"}>{t('reserved_from')}</span>
                                      <span
                                        className={"p-text-bold"}>{moment.utc(departure.reservedFrom).local().format(t('YYYY-MM-DD'))}</span>
                                    </td>
                                    <td className={"p-text-right controlpanel-checks-table__actions"}
                                        style={{'width': '160px'}}>
                                      <span className={"controlpanel-checks-table__label"}>{t('status')}</span>
                                      {(() => {
                                        if (departure.status === 'will_arrive') {
                                          return (
                                            <>
                                              <Button
                                                type="button"
                                                label={t('check_in')}
                                                icon={"pi pi-sign-in"}
                                                loading={loading}
                                                onClick={() => {
                                                  window.App.setState({[`confirmDepartureCheckIn${departure.id}`]: true})
                                                }}
                                                className="p-button-success p-button-sm p-mr-2 p-d-block w-100 p-text-nowrap"
                                              />
                                              <ConfirmDialog group="declarative"
                                                             visible={window.App.state[`confirmDepartureCheckIn${departure.id}`]}
                                                             acceptLabel={t('yes')} rejectLabel={t('no')}
                                                             onHide={() => {
                                                               window.App.setState({[`confirmDepartureCheckIn${departure.id}`]: false})
                                                             }}
                                                             message={t('confirm_event_patch_message')}
                                                             header={t('check_in')}
                                                             icon="pi pi-exclamation-triangle"
                                                             accept={() => {
                                                               window.App.setState({[`confirmDepartureCheckIn${departure.id}`]: false})
                                                               setLoading(true)
                                                               axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest/" + departure.id,
                                                                 {
                                                                   status: "checked_in",
                                                                 },
                                                                 {
                                                                   params: {},
                                                                   headers: {
                                                                     'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                                                     "Sys-name": Cookies.get("instanceId"),
                                                                     "Preferred-locale": Cookies.get("language")
                                                                   }
                                                                 })
                                                                 .then(response => {
                                                                   setLoading(false)
                                                                   window.App.setState({rerenderReservationGuestList: Math.random()})
                                                                   window.App.toastShow('success', t('success'), response.data.message)
                                                                 })
                                                                 .catch(error => {
                                                                   setLoading(false)
                                                                   window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                                                 })
                                                             }}
                                                             reject={() => {
                                                               window.App.setState({[`confirmDepartureCheckIn${departure.id}`]: false})
                                                             }}/>
                                            </>
                                          );
                                        } else if (departure.status === 'checked_in') {
                                          return (
                                            <>
                                              <Button
                                                type="button"
                                                label={t('check_out')}
                                                icon={"pi pi-sign-out"}
                                                loading={loading}
                                                onClick={() => {
                                                  window.App.setState({[`confirmDepartureCheckOut${departure.id}`]: true})
                                                }}
                                                className="p-button-warning p-button-sm p-mr-2 p-d-block w-100"
                                              />
                                              <ConfirmDialog group="declarative"
                                                             visible={window.App.state[`confirmDepartureCheckOut${departure.id}`]}
                                                             acceptLabel={t('yes')} rejectLabel={t('no')}
                                                             onHide={() => {
                                                               window.App.setState({[`confirmDepartureCheckOut${departure.id}`]: false})
                                                             }}
                                                             message={t('confirm_event_patch_message')}
                                                             header={t('check_out')}
                                                             icon="pi pi-exclamation-triangle"
                                                             accept={() => {
                                                               window.App.setState({[`confirmDepartureCheckOut${departure.id}`]: false})
                                                               setLoading(true)
                                                               axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest/" + departure.id,
                                                                 {
                                                                   status: "checked_out",
                                                                 },
                                                                 {
                                                                   params: {},
                                                                   headers: {
                                                                     'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                                                     "Sys-name": Cookies.get("instanceId"),
                                                                     "Preferred-locale": Cookies.get("language")
                                                                   }
                                                                 })
                                                                 .then(response => {
                                                                   setLoading(false)
                                                                   window.App.setState({rerenderReservationGuestList: Math.random()})
                                                                   window.App.toastShow('success', t('success'), response.data.message)
                                                                 })
                                                                 .catch(error => {
                                                                   setLoading(false)
                                                                   window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                                                 })
                                                             }}
                                                             reject={() => {
                                                               window.App.setState({[`confirmDepartureCheckOut${departure.id}`]: false})
                                                             }}/>
                                            </>
                                          );
                                        } else {
                                          return (
                                            <>
                                              <Button
                                                type="button"
                                                label={t('check_in')}
                                                icon={"pi pi-sign-in"}
                                                loading={loading}
                                                onClick={() => {
                                                  window.App.setState({[`confirmDepartureCheckIn${departure.id}`]: true})
                                                }}
                                                className="p-button-success p-button-sm p-mr-2 p-d-block w-100"
                                              />
                                              <ConfirmDialog group="declarative"
                                                             visible={window.App.state[`confirmDepartureCheckIn${departure.id}`]}
                                                             acceptLabel={t('yes')} rejectLabel={t('no')}
                                                             onHide={() => {
                                                               window.App.setState({[`confirmDepartureCheckIn${departure.id}`]: false})
                                                             }}
                                                             message={t('confirm_event_patch_message')}
                                                             header={t('check_in')}
                                                             icon="pi pi-exclamation-triangle"
                                                             accept={() => {
                                                               window.App.setState({[`confirmDepartureCheckIn${departure.id}`]: false})
                                                               setLoading(true)
                                                               axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest/" + departure.id,
                                                                 {
                                                                   status: "checked_in",
                                                                 },
                                                                 {
                                                                   params: {},
                                                                   headers: {
                                                                     'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                                                     "Sys-name": Cookies.get("instanceId"),
                                                                     "Preferred-locale": Cookies.get("language")
                                                                   }
                                                                 })
                                                                 .then(response => {
                                                                   setLoading(false)
                                                                   window.App.setState({rerenderReservationGuestList: Math.random()})
                                                                   window.App.toastShow('success', t('success'), response.data.message)
                                                                 })
                                                                 .catch(error => {
                                                                   setLoading(false)
                                                                   window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                                                 })
                                                             }}
                                                             reject={() => {
                                                               window.App.setState({[`confirmDepartureCheckIn${departure.id}`]: false})
                                                             }}/>
                                            </>
                                          );
                                        }
                                      })()}
                                    </td>
                                  </tr>
                                )
                              })}
                            </>
                          ) : (
                            <tr>
                              <td colSpan={6}>{t('departure_not_found')}</td>
                            </tr>
                          )}
                          </tbody>
                        </table>
                      </div>
                      <div className={"p-grid p-mt-2"}>
                        <div className={"p-col-12 p-col-align-center p-text-right p-pb-0"}>
                          <Button
                            type="button"
                            label={t('export_csv')}
                            icon={"pi pi-download"}
                            loading={loading}
                            disabled={!checksDeparturesFiltered.length}
                            onClick={() => {
                              setLoading(true)
                              axios.get(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "export/departures?end_date=" + checksDepartureDay,
                                {
                                  responseType: 'blob',
                                  params: {},
                                  headers: {
                                    'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                    "Sys-name": Cookies.get("instanceId"),
                                    "Preferred-locale": Cookies.get("language")
                                  }
                                })
                                .then(response => {
                                  setLoading(false)
                                  const contentDisposition = response?.headers?.['content-disposition'] || response?.headers?.['Content-Disposition'];
                                  const utf8FileNameMatch = contentDisposition?.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
                                  const fileNameMatch = contentDisposition?.match(/filename\s*=\s*("?)([^";]+)\1/i);
                                  const headerFileName = utf8FileNameMatch?.[1]
                                    ? decodeURIComponent(utf8FileNameMatch[1].trim().replace(/^["']|["']$/g, ''))
                                    : fileNameMatch?.[2]?.trim();
                                  fileDownload(response.data, headerFileName || `departures_${checksDepartureDay}.csv`);
                                })
                                .catch(error => {
                                  setLoading(false)
                                  window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error.response)
                                })
                            }}
                            className="p-button-warning p-ml-2"
                          />
                          <Button
                            type="button"
                            label={t('export_xlsx')}
                            icon={"pi pi-download"}
                            loading={loading}
                            disabled={!checksDeparturesFiltered.length}
                            onClick={() => {
                              setLoading(true)
                              axios.get(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "export/departures?end_date=" + checksDepartureDay + "&format=xlsx",
                                {
                                  responseType: 'blob',
                                  params: {},
                                  headers: {
                                    'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                    "Sys-name": Cookies.get("instanceId"),
                                    "Preferred-locale": Cookies.get("language")
                                  }
                                })
                                .then(response => {
                                  setLoading(false)
                                  const contentDisposition = response?.headers?.['content-disposition'] || response?.headers?.['Content-Disposition'];
                                  const utf8FileNameMatch = contentDisposition?.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
                                  const fileNameMatch = contentDisposition?.match(/filename\s*=\s*("?)([^";]+)\1/i);
                                  const headerFileName = utf8FileNameMatch?.[1]
                                    ? decodeURIComponent(utf8FileNameMatch[1].trim().replace(/^["']|["']$/g, ''))
                                    : fileNameMatch?.[2]?.trim();
                                  fileDownload(response.data, headerFileName || `departures_${checksDepartureDay}.xlsx`);
                                })
                                .catch(error => {
                                  setLoading(false)
                                  window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error.response)
                                })
                            }}
                            className="p-button-warning p-ml-2"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>
              </div>
            }
            {accommodations && accommodations[0] &&
              <div className={"p-p-3 p-p-lg-0"}
                   style={{maxWidth: '1910px', marginLeft: 'auto', marginRight: 'auto'}}>
                <div className={"p-grid"} style={{display: 'flex', flexWrap: 'wrap'}}>
                  <div className={"p-col-12 p-lg-4"} style={{display: 'flex', flexDirection: 'column'}}>
                    <Card className={"p-mt-2 p-shadow-0"} style={{flex: 1}}>
                      <div className={"p-grid"}>
                        <div className={"p-col p-col-align-center"}>
                          <small className={"p-text-uppercase"}>{t('fast_checkin')}</small>
                          <h3 className={"p-m-0 p-p-0 p-text-secondary"}>{reservedDay}</h3>
                        </div>
                        <div className={"p-col p-col-align-center p-text-right"}>
                        <span className={"p-inputgroup"}>
                          <Button label={"-1"}
                                  disabled={loading}
                                  className={"p-button-success"}
                                  onClick={() => {
                                    setReservedDay(moment(reservedDay).subtract(+1, 'days').format(t('YYYY-MM-DD')))
                                  }}/>
                          <Calendar value={reservedDay ? moment(reservedDay, 'YYYY-MM-DD').toDate() : null}
                                    dateFormat={t('YY-MM-DD')}
                                    placeholder={reservedDay}
                                    locale="default"
                                    id={"reservedDay"}
                                    onChange={(e) => {
                                      setReservedDay(moment.utc(e.value).local().format(t('YYYY-MM-DD')))
                                    }}/>
                          <Button label={"+1"}
                                  disabled={loading}
                                  className={"p-button-success"}
                                  onClick={() => {
                                    setReservedDay(moment(reservedDay).subtract(-1, 'days').format(t('YYYY-MM-DD')))
                                  }}/>
                        </span>
                        </div>
                      </div>
                      <DataTable
                        value={reservations}
                        size={"small"}
                        emptyMessage={t('empty_message')}
                        autoLayout={true}
                        responsiveLayout={window.App.state.responsiveLayout}
                        breakpoint="1365px"
                        stripedRows
                        dataKey="id"
                      >
                        <Column field="association_code" sortable header={t('id')}
                                className={"p-text-nowrap"}
                                sortField={"id"}
                                filterField={"public_id"}
                                body={(rowData) => (
                                  <>
                    <span className={"tt-association-code-info-" + rowData.id + " p-mr-2"}
                          data-pr-tooltip={rowData?.association_code}>
                      <i className={"pi pi-info-circle"}
                         style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>
                    </span>
                                    <Tooltip target={".tt-association-code-info-" + rowData.id}/>
                                    <span
                                      className={"p-badge"}
                                      style={{
                                        minWidth: '110px',
                                        fontSize: '1rem',
                                        backgroundColor: rowData?.status
                                          ? rowData?.status?.toLowerCase() === 'pending'
                                            ? '#dddddd'
                                            : rowData?.status?.toLowerCase() === 'confirmed'
                                              ? '#f1eea5'
                                              : rowData?.status?.toLowerCase() === 'cancelled'
                                                ? '#f7a2a2'
                                                : rowData?.status?.toLowerCase() === 'checked_in'
                                                  ? '#3ec0e9'
                                                  : rowData?.status?.toLowerCase() === 'checked_out'
                                                    ? '#0abb87'
                                                    : rowData?.status?.toLowerCase() === 'relocated'
                                                      ? '#fbc02d'
                                                      : rowData?.status?.toLowerCase() === 'no_show'
                                                        ? '#8a2be2'
                                                        : '#ccc'
                                          : undefined,
                                        color: rowData?.status
                                          ? rowData?.status?.toLowerCase() === 'pending'
                                          || rowData?.status?.toLowerCase() === 'confirmed'
                                            ? '#5f656b'
                                            : rowData?.status?.toLowerCase() === 'relocated'
                                              ? '#212529'
                                              : rowData?.status?.toLowerCase() === 'no_show'
                                                ? '#fff'
                                                : undefined
                                          : undefined
                                      }}
                                    >
                      {rowData?.association_code?.split(' | ').pop()?.trim()}
                    </span>
                                  </>
                                )}
                        ></Column>
                        <Column field="reserved_from" header={t('reserved_from')}
                                body={(rowData) => {
                                  if (rowData.reserved_from !== null) {
                                    return (
                                      <span>{moment.utc(rowData.reserved_from).local().format(t('YYYY-MM-DD HH:mm'))}</span>
                                    )
                                  }
                                }}></Column>
                        <Column className={"p-text-right p-text-nowrap"} body={(rowData) => {
                          return (
                            <>
                              <Button icon="pi pi-mobile"
                                      className="p-button-sm p-button-warning p-ml-2"
                                      tooltip={t('check_in_link')}
                                      onClick={() => {
                                        openReservationCheckinLink(rowData?.id)
                                      }}/>
                            </>
                          )
                        }}></Column>
                      </DataTable>
                    </Card>
                  </div>
                  <div className={"p-col-12 p-lg-8"} style={{display: 'flex', flexDirection: 'column'}}>
                    <Card className={"p-mt-2 p-shadow-0"} style={{flex: 1}}>
                      <div className={"p-grid"}>
                        <div className={"p-col p-col-align-center"}>
                          <small className={"p-text-uppercase"}>{t('reserved')} {t('units')}</small>
                          <h3 className={"p-m-0 p-p-0 p-text-secondary"}>{reservedDay}</h3>
                        </div>
                        <div className={"p-col-12 p-lg-3 p-col-align-center p-text-right"}>
                        <span className={"p-inputgroup"}>
                          <Button label={"-1"}
                                  disabled={loading}
                                  className={"p-button-success"}
                                  onClick={() => {
                                    setReservedDay(moment(reservedDay).subtract(+1, 'days').format(t('YYYY-MM-DD')))
                                  }}/>
                          <Calendar value={reservedDay ? moment(reservedDay, 'YYYY-MM-DD').toDate() : null}
                                    dateFormat={t('YY-MM-DD')}
                                    placeholder={reservedDay}
                                    locale="default"
                                    id={"reservedDay"}
                                    onChange={(e) => {
                                      setReservedDay(moment.utc(e.value).local().format(t('YYYY-MM-DD')))
                                    }}/>
                          <Button label={"+1"}
                                  disabled={loading}
                                  className={"p-button-success"}
                                  onClick={() => {
                                    setReservedDay(moment(reservedDay).subtract(-1, 'days').format(t('YYYY-MM-DD')))
                                  }}/>
                        </span>
                        </div>
                        <div className={"p-col p-col-align-center p-text-right p-d-none p-d-lg-block"}
                             style={{maxWidth: '35px'}}>
                          <i className={"pi pi-download"} style={{'fontSize': '1.5em'}}></i>
                        </div>
                      </div>
                      <DataTable
                        value={reservations}
                        size={"small"}
                        emptyMessage={t('empty_message')}
                        autoLayout={true}
                        responsiveLayout={window.App.state.responsiveLayout}
                        breakpoint="1365px"
                        stripedRows
                        dataKey="id"
                      >
                        <Column field="accommodation.name" header={t('accommodation')}
                                body={(rowData) => <><span className={"p-text-nowrap"}>{rowData?.accommodation?.name}<span
                                  className={"tt-auto-invoice p-ml-2"}
                                  data-pr-tooltip={rowData?.accommodation?.auto_invoice_on_check_out === 'CREATE_AND_SYNC' ? t('auto_invoice_tooltip_active') : t('auto_invoice_tooltip_inactive')}><svg
                                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16"
                                  fill="none"
                                  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                                  className={"auto-invoice-icon"} style={{
                                  color: rowData?.accommodation?.auto_invoice_on_check_out === 'CREATE_AND_SYNC' ? '#0abb87' : '#dddddd',
                                  position: 'relative',
                                  bottom: '-3px'
                                }}><path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8"/><path
                                  d="M5 21l2.5-1.5L10 21l2.5-1.5L14 21l1.5-1"/><path d="M9 7h6"/><path d="M9 11h4"/><path
                                  d="M18 14a3 3 0 1 0 3 3"/><path d="M21 20v-3h-3"/></svg></span></span><Tooltip
                                  target=".tt-auto-invoice"/></>}
                        ></Column>
                        <Column field="residential_unit.name" header={t('residential_unit')}></Column>
                        <Column field="residential_unit.name" header={t('guests')}
                                body={(rowData) => {
                                  return (
                                    <>
                                      {rowData.guests.length}
                                    </>
                                  )
                                }}
                        ></Column>
                        <Column field="reserved_from" header={t('reserved_from')}
                                body={(rowData) => {
                                  if (rowData.reserved_from !== null) {
                                    return (
                                      <span>{moment.utc(rowData.reserved_from).local().format(t('YYYY-MM-DD HH:mm'))}</span>
                                    )
                                  }
                                }}></Column>
                        <Column field="reserved_to" header={t('reserved_to')}
                                body={(rowData) => {
                                  if (rowData.reserved_to !== null) {
                                    return (
                                      <span>
                                      {moment.utc(rowData.reserved_to).local().format(t('YYYY-MM-DD HH:mm'))}
                                        {rowData.relocated_to &&
                                          <>
                                        <span className={"p-badge p-badge-warning p-ml-2"}>{t('relocated_to')}<i
                                          className="pi pi-sign-in p-ml-1" style={{fontSize: "0.6rem"}}></i></span>
                                          </>
                                        }
                                        {rowData.relocated_from &&
                                          <>
                                        <span className={"p-badge p-badge-warning p-ml-2"}><i
                                          className="pi pi-sign-out p-mr-1"
                                          style={{fontSize: "0.6rem"}}></i>{t('relocated_from')}</span>
                                          </>
                                        }
                                    </span>
                                    )
                                  }
                                }}></Column>
                        <Column field="status" header={t('movable')}
                                body={(rowData) => {
                                  const isClean = rowData?.residential_unit?.clean === true;
                                  const residentialUnitId = rowData?.residential_unit?.id;
                                  const cleanOptions = [
                                    {label: t('yes'), value: true},
                                    {label: t('no'), value: false},
                                  ];
                                  return (
                                    <SelectButton
                                      value={isClean}
                                      options={cleanOptions}
                                      optionLabel="label"
                                      optionValue="value"
                                      disabled={!residentialUnitId}
                                      onChange={(e) => {
                                        if (!residentialUnitId) {
                                          return;
                                        }
                                        axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "residential-unit/"
                                          + residentialUnitId,
                                          {
                                            clean: e.value === true,
                                          },
                                          {
                                            params: {},
                                            headers: {
                                              'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                              "Sys-name": Cookies.get("instanceId"),
                                              "Preferred-locale": Cookies.get("language")
                                            }
                                          })
                                          .then(response => {
                                            window.App.setState({rerenderReservationList: Math.random()})
                                          })
                                          .catch(error => {

                                          })
                                      }}
                                    />
                                  )
                                }}
                        ></Column>
                      </DataTable>
                    </Card>
                  </div>
                </div>
              </div>
            }

            {accommodations && accommodations[0] &&
              <div className={"p-p-3 p-p-lg-0"}
                   style={{maxWidth: '1910px', marginLeft: 'auto', marginRight: 'auto'}}>
                <div className={"p-grid"} style={{display: 'flex', flexWrap: 'wrap'}}>
                  <div className={"p-col-12 p-lg-4"} style={{display: 'flex', flexDirection: 'column'}}>
                    <Card className={"p-mt-2 p-shadow-0"} style={{flex: 1}}>
                      <div className={"p-grid"}>
                        <div className={"p-col p-col-align-center p-text-right"} style={{maxWidth: '35px'}}>
                          <i className={"pi pi-file"} style={{'fontSize': '1.5em'}}></i>
                        </div>
                        <div className={"p-col p-col-align-center"}>
                          <small className={"p-text-uppercase"}>{t('close_day_details')}</small>
                          <h3 className={"p-m-0 p-p-0 p-text-secondary"}>{t('close_day')}</h3>
                        </div>
                      </div>
                      <div className={"p-grid p-mt-1"}>
                        <div className={"p-col-12"}>
                          <div className="p-field p-fluid">
                      <span className={"p-inputgroup"}>
                        <Dropdown options={accommodations}
                                  optionLabel="name"
                                  optionValue="id"
                                  id={"closeAccommodation"}
                                  emptyMessage={"Még nincs szálláshely felvéve..."}
                                  onChange={(e) => {
                                    setCloseAccommodation(e.value)
                                  }}
                                  value={closeAccommodation}
                        />
                        <Calendar value={closeDay ? moment(closeDay, 'YYYY-MM-DD').toDate() : null}
                                  dateFormat={t('YY-MM-DD')}
                                  placeholder={closeDay}
                                  locale="default"
                                  id={"closed_day"}
                                  className={"p-ml-2"}
                                  onChange={(e) => {
                                    setCloseDay(moment.utc(e.value).local().format(t('YYYY-MM-DD')))
                                  }}/>
                        <Button type="button"
                                disabled={!closeAccommodation}
                                label={t('close_daily')}
                                icon={"pi pi-check"}
                                onClick={() => {
                                  axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "accommodation/" + closeAccommodation + "/close-day",
                                    {
                                      closed_day: closeDay,
                                    },
                                    {
                                      params: {},
                                      headers: {
                                        'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                        "Sys-name": Cookies.get("instanceId"),
                                        "Preferred-locale": Cookies.get("language")
                                      }
                                    })
                                    .then(response => {
                                      window.App.toastShow('success', t('success'), response.data.message)
                                      refreshDailyClosureStatusesAfterClose(closeAccommodation, closeDay)
                                    })
                                    .catch(error => {
                                      window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                    })
                                }}
                                className="p-button-success p-ml-2"/>
                      </span>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </div>
                  <div className={"p-col-12 p-lg-8"} style={{display: 'flex', flexDirection: 'column'}}>
                    <Card className={"p-mt-2 p-shadow-0"} style={{flex: 1}}>
                      <div className={"p-grid"}>
                        <div className={"p-col p-col-align-center"}>
                          <small className={"p-text-uppercase"}>NTAK napi zárás</small>
                          <h3 className={"p-m-0 p-p-0 p-text-secondary"}>Napi zárás státusz</h3>
                        </div>
                        <div className={"p-col p-col-align-center p-text-right"}>
                          {dailyClosureStatusMeta?.generatedAt &&
                            <small className={"p-text-color-secondary"}>
                              Frissítve: {formatDailyClosureDateTime(dailyClosureStatusMeta.generatedAt)}
                            </small>
                          }
                        </div>
                        {/*<div className={"p-col p-col-align-center p-text-right"} style={{maxWidth: '35px'}}>*/}
                        {/*  <i className={"pi pi-sync"} style={{'fontSize': '1.5em'}}></i>*/}
                        {/*</div>*/}
                      </div>
                      <div className={"p-grid p-mt-0"}>
                        <div className={"p-col-12"}>
                          <DataTable
                            value={dailyClosureStatuses}
                            size={"small"}
                            loading={dailyClosureStatusLoading}
                            emptyMessage={t('empty_message')}
                            autoLayout={true}
                            responsiveLayout={window.App.state.responsiveLayout}
                            breakpoint="1365px"
                            stripedRows
                            dataKey="accommodationId"
                          >
                            <Column field="accommodationName" header={t('accommodation')}
                                    body={(rowData) => {
                                      return (
                                        <span
                                          style={{opacity: (rowData?.status || '').toLowerCase() === 'not_applicable' ? 0.6 : 1}}>
                                          {rowData?.accommodationName || '-'}
                                        </span>
                                      )
                                    }}
                            ></Column>
                            <Column field="status" header={t('status')}
                                    body={(rowData) => {
                                      const statusValue = (rowData?.status || '').toLowerCase();
                                      const rowOpacity = statusValue === 'not_applicable' ? 0.6 : 1;
                                      const statusMeta = getDailyClosureStatusMeta(statusValue);
                                      const tooltipClass = "tt-daily-closure-status-"
                                        + (rowData?.accommodationId || rowData?.hotelConnectAccommodationId || 'item');
                                      return (
                                        <div style={{opacity: rowOpacity}}>
                                          <span className={"p-badge"} style={{
                                            ...statusMeta.style,
                                            display: 'block',
                                            width: '100%',
                                            fontWeight: 400
                                          }}>
                                            {statusMeta.value}
                                          </span>
                                          {statusValue === 'attention' && rowData?.lastAttempt?.error &&
                                            <>
                                              <span className={tooltipClass + " p-ml-2"}>
                                                <i className={"pi pi-info-circle fm-controlpanel-info-icon"}></i>
                                              </span>
                                              <Tooltip target={"." + tooltipClass}>
                                                {rowData.lastAttempt.error}
                                              </Tooltip>
                                            </>
                                          }
                                          {statusValue === 'not_ready' && rowData?.certificateStatus &&
                                            <small className={"p-ml-2"}>certificate: {rowData.certificateStatus}</small>
                                          }
                                        </div>
                                      )
                                    }}></Column>
                            <Column field="lastClosedDay" header={"Utolsó lezárt nap"}
                                    body={(rowData) => {
                                      return (
                                        <span
                                          style={{opacity: (rowData?.status || '').toLowerCase() === 'not_applicable' ? 0.6 : 1}}>
                                          {rowData?.lastClosedDay || '-'}
                                        </span>
                                      )
                                    }}
                            ></Column>
                            <Column field="lastAttempt.status" header={"Utolsó sync státusz"}
                                    body={(rowData) => {
                                      const attemptStatus = (rowData?.lastAttempt?.status || '').toLowerCase();
                                      const attemptStatusMeta = getDailyClosureAttemptStatusMeta(attemptStatus);
                                      const attemptError = rowData?.lastAttempt?.error || '';
                                      const hasAttemptError = (attemptStatus === 'failed' || attemptStatus === 'error') && !!attemptError;
                                      const attemptTooltipClass = "tt-daily-closure-attempt-error-icon-"
                                        + (rowData?.accommodationId || rowData?.hotelConnectAccommodationId || 'item');
                                      return (
                                        <>
                                          <div className={"p-d-flex p-ai-center"} style={{gap: '0.35rem'}}>
                                            {hasAttemptError &&
                                              <span className={attemptTooltipClass}
                                                    data-pr-tooltip={attemptError}>
                                                <i className={"pi pi-info-circle"}
                                                   style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>
                                              </span>
                                            }
                                            <span
                                              className={"p-badge p-d-flex p-ai-center p-jc-center"}
                                              style={{
                                                ...attemptStatusMeta.style,
                                                opacity: (rowData?.status || '').toLowerCase() === 'not_applicable' ? 0.6 : 1,
                                                display: 'block',
                                                width: '100%',
                                                fontWeight: 400
                                              }}>
                                              <span>{attemptStatusMeta.value}</span>
                                            </span>
                                          </div>
                                          {hasAttemptError &&
                                            <Tooltip target={"." + attemptTooltipClass}/>
                                          }
                                        </>
                                      )
                                    }}
                            ></Column>
                            <Column field="lastAttempt.happenedAt" header={"Utolsó sync időpontja"}
                                    body={(rowData) => {
                                      return (
                                        <span
                                          style={{opacity: (rowData?.status || '').toLowerCase() === 'not_applicable' ? 0.6 : 1}}>
                                          {formatDailyClosureDateTime(rowData?.lastAttempt?.happenedAt)}
                                        </span>
                                      )
                                    }}
                            ></Column>
                            <Column field="nextRunAt" header={"Következő futás"} body={(rowData) => {
                              return (
                                <span
                                  style={{opacity: (rowData?.status || '').toLowerCase() === 'not_applicable' ? 0.6 : 1}}>
                                  {formatDailyClosureDateTime(rowData?.nextRunAt)}
                                </span>
                              )
                            }}></Column>
                            <Column field="willSyncDates" header={"Következő beküldendő napok"} body={(rowData) => {
                              const syncDates = rowData?.willSyncDates || [];
                              return (
                                <span
                                  style={{opacity: (rowData?.status || '').toLowerCase() === 'not_applicable' ? 0.6 : 1}}>
                                  {syncDates.length > 0 ? syncDates.join(', ') : '-'}
                                </span>
                              )
                            }}></Column>
                          </DataTable>
                        </div>
                      </div>

                    </Card>
                  </div>
                </div>
              </div>
            }

            {accommodations && accommodations[0] &&
              <div className={"p-p-3 p-p-lg-0"}
                   style={{maxWidth: '1910px', marginLeft: 'auto', marginRight: 'auto'}}>
                <div className={"p-grid"} style={{display: 'flex', flexWrap: 'wrap'}}>
                  <div className={"p-col-12 p-lg-12"} style={{display: 'flex', flexDirection: 'column'}}>
                    <Card className={"p-mt-2 p-shadow-0"} style={{flex: 1}}>
                      <div className={"p-grid"}>
                        <div className={"p-col p-col-align-center"}>
                          <small className={"p-text-uppercase"}>{t('search_folios')}</small>
                          <h3 className={"p-m-0 p-p-0 p-text-secondary"}>{t('folios')}</h3>
                        </div>
                        <div className={"p-col p-col-align-center p-text-right"}>
                          <div className="p-field p-m-0">
                        <span className={""}>
                          <Button type="button" label={t('folios_manage')} icon={"pi pi-table"}
                                  onClick={() => {
                                    navigate('/control-panel?manage=folio&folioIds=' + selectedFolios.map(folio => folio.id).join(','))
                                  }}
                                  disabled={!selectedFolios[0]}
                                  className="p-button-warning p-mr-2"/>
                          <Button type="button" label={t('new_folio')} icon={"pi pi-plus"}
                                  onClick={() => {
                                    navigate('/control-panel?create=folio')
                                  }}
                                  className="p-button-success p-mr-2"/>
                          <InputText id="search"
                                     placeholder={t('search')}
                                     onChange={(e) => {
                                       setFolioFilter(e.target.value)
                                       localStorage.setItem('folioFilter', e.target.value)
                                       clearTimeout(window.searchTimeout)
                                       window.searchTimeout = setTimeout(function () {
                                         window.App.setState({rerenderFolioList: Math.random()})
                                       }, 1000)
                                     }}
                                     value={folioFilter || localStorage.getItem('folioFilter')}
                                     className={""}
                          />
                        </span>
                          </div>
                        </div>
                        <div className={"p-col p-col-align-center p-text-right"} style={{maxWidth: '35px'}}>
                          <i className={"pi pi-wallet"} style={{'fontSize': '1.5em'}}></i>
                        </div>
                      </div>
                      <div className={"p-grid p-mt-0"}>
                        <div className={"p-col-12"}>
                          <DataTable
                            value={folios}
                            size={"small"}
                            emptyMessage={t('empty_message')}
                            autoLayout={true}
                            responsiveLayout={window.App.state.responsiveLayout}
                            breakpoint="1365px"
                            stripedRows
                            dataKey="id"
                            selection={selectedFolios}
                            onSelectionChange={(e) => setSelectedFolios(e.value)}
                            selectionMode={"single"}
                            onRowDoubleClick={(rowData) => {
                              navigate('/folio/update/' + rowData.data.id)
                            }}
                          >
                            <Column selectionMode="multiple" headerStyle={{width: '3rem'}}></Column>
                            <Column field="name" header={t('name')}
                                    body={(rowData) => {
                                      return (
                                        <>
                                    <span className={"tooltip-" + rowData.id}>
                                      <i className={"pi pi-info-circle p-mr-2 fm-controlpanel-info-icon"}></i>
                                    </span>
                                          {rowData.name}
                                          <Tooltip target={".tooltip-" + rowData.id}>
                                            {t('folio')}: {rowData.id}
                                          </Tooltip>
                                        </>
                                      )
                                    }}
                            ></Column>
                            <Column header={t('reservation') + " / " + t('customer')}
                                    body={(rowData) => {
                                      return (
                                        <>
                                          {rowData?.customer?.id &&
                                            <>
                                              <i className={"pi pi-window-maximize"}
                                                 onClick={(e) => {
                                                   navigate('/control-panel/customer/read/' + rowData?.customer?.id)
                                                 }}
                                              ></i>
                                              &nbsp;
                                              {rowData?.customer?.firstname} {rowData?.customer?.lastname}
                                            </>
                                          }
                                          {rowData.reservation_group?.id &&
                                            <>
                                              <i className={"pi pi-window-maximize"}
                                                 onClick={(e) => {
                                                   navigate('/control-panel/reservation-group/read/' + rowData.reservation_group?.id)
                                                 }}
                                              ></i>
                                              &nbsp;
                                              {rowData.reservation_group?.public_id.toUpperCase()}
                                            </>
                                          }
                                        </>
                                      )
                                    }}></Column>
                            <Column field="net_amount" header={t('net_amount')}
                                    className={"p-text-right"}
                                    body={(rowData) => {
                                      return (
                                        <>
                                          {currencyFormatter.format(
                                            rowData.net_amount, {
                                              precision: t('currency_precision'),
                                              symbol: t('currency_symbol'),
                                              decimal: t('currency_decimal'),
                                              thousand: t('currency_thousand'),
                                            }
                                          )}
                                          &nbsp;{rowData.currency}
                                        </>
                                      )
                                    }}
                            ></Column>
                            <Column field="vat" header={t('vat')}
                                    className={"p-text-right p-text-nowrap"}
                                    body={(rowData) => {
                                      return (
                                        <>
                                          {currencyFormatter.format(
                                            rowData.vat, {
                                              precision: t('currency_precision'),
                                              symbol: t('currency_symbol'),
                                              decimal: t('currency_decimal'),
                                              thousand: t('currency_thousand'),
                                            }
                                          )}
                                          &nbsp;{rowData.currency}
                                        </>
                                      )
                                    }}
                            ></Column>
                            <Column field="gross_amount" header={t('gross_amount')}
                                    className={"p-text-right p-text-nowrap"}
                                    body={(rowData) => {
                                      return (
                                        <>
                                          {currencyFormatter.format(
                                            rowData.gross_amount, {
                                              precision: t('currency_precision'),
                                              symbol: t('currency_symbol'),
                                              decimal: t('currency_decimal'),
                                              thousand: t('currency_thousand'),
                                            }
                                          )}
                                          &nbsp;{rowData.currency}
                                        </>
                                      )
                                    }}
                            ></Column>
                            <Column className={"p-text-right p-text-nowrap"} body={(rowData) => {
                              return (
                                <>
                                  <Button icon="pi pi-pencil"
                                          className="p-button-sm p-button-warning p-ml-2"
                                          tooltip={t('edit')}
                                          tooltipOptions={{position: 'left'}}
                                          onClick={() => {
                                            navigate('/control-panel?update=folio&folioId=' + rowData.id)
                                          }}/>
                                </>
                              )
                            }}></Column>
                          </DataTable>
                        </div>
                      </div>

                    </Card>
                  </div>
                </div>
              </div>
            }
            {accommodations && accommodations[0] &&
              <div className={"p-p-3 p-p-lg-0 p-mt-2"}
                   style={{maxWidth: '1910px', marginLeft: 'auto', marginRight: 'auto'}}>
                <Panel>
                  <div className={"p-grid"} style={{alignItems: 'center'}}>
                    <div className={"p-col p-col-align-center"}>
                    </div>
                    <div className={"p-col-12 p-lg-3 p-col-align-center p-text-right p-pr-0"}>
                    <span className={"p-inputgroup"}>
                      <Calendar
                        id={"reservations_date_range"}
                        value={reservationsDateRange}
                        locale="default"
                        dateFormat={t('YY-MM-DD')}
                        showOtherMonths
                        selectOtherMonths
                        selectionMode="range"
                        showIcon
                        onChange={(e) => {
                          setReservationsDateRange(e.value || [])
                        }}
                      />
                    </span>
                    </div>
                  </div>
                  <div className={"p-grid"} style={{display: 'flex', flexWrap: 'wrap'}}>
                    <div className={"p-col-12 p-lg-4"} style={{display: 'flex', flexDirection: 'column'}}>
                      <small className={"p-text-uppercase"}>{t('reservations_by_statuses')}</small>
                      <h3 className={"p-m-0 p-p-0 p-text-secondary"}>
                        {reservationsDateRange?.[0] && reservationsDateRange?.[1]
                          ? moment.utc(reservationsDateRange[0]).local().format(t('YYYY-MM-DD')) + ' - ' + moment.utc(reservationsDateRange[1]).local().format(t('YYYY-MM-DD'))
                          : reservationsDateRange?.[0]
                            ? moment.utc(reservationsDateRange[0]).local().format(t('YYYY-MM-DD')) + ' ?'
                            : '?'}
                      </h3>
                      <Chart type="bar" data={
                        {
                          labels: reservationsByStatusesLabel,
                          datasets: [
                            {
                              type: 'bar',
                              data: reservationsByStatusesData,
                            },
                          ]
                        }
                      } options={{
                        animation: false,
                        plugins: {
                          title: {
                            display: false,
                          },
                          legend: {
                            display: false,
                          },
                        },
                        scales: {
                          x: {
                            grid: {
                              display: false,
                            },
                          },
                          y: {
                            grid: {
                              display: false,
                            },
                          },
                        },
                      }} className="w-full bar-chart p-mt-3"/>
                      <div className={"p-text-center p-mt-4"}>
                        <Button
                          label={t('download')}
                          icon={"pi pi-download"}
                          className={"p-button-sm p-button-outlined"}
                          onClick={async () => {
                            const rows = reservationsByStatusesLabel.map((label, index) => {
                              const value = Number(reservationsByStatusesData[index]) || 0;
                              return [String(label || ''), value];
                            });
                            const XLSXModule = await import('xlsx');
                            const XLSX = XLSXModule.default || XLSXModule;
                            const workbook = XLSX.utils.book_new();
                            const worksheet = XLSX.utils.aoa_to_sheet([
                              [t('reservations_by_statuses') + ' - '
                              + (reservationsDateRange?.[0] ? moment.utc(reservationsDateRange[0]).local().format(t('YYYY-MM-DD')) : '-')
                              + ' - '
                              + (reservationsDateRange?.[1] ? moment.utc(reservationsDateRange[1]).local().format(t('YYYY-MM-DD')) : '-')],
                              [t('status'), t('reservations')],
                              ...rows
                            ]);
                            worksheet['!cols'] = [{wch: 28}, {wch: 14}];
                            worksheet['!merges'] = [{s: {r: 0, c: 0}, e: {r: 0, c: 1}}];
                            XLSX.utils.book_append_sheet(workbook, worksheet, String(t('reservations_by_statuses')).slice(0, 31));
                            const workbookBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
                            fileDownload(
                              new Blob([workbookBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
                              'reservations_by_statuses_' + moment().format('YYYY-MM-DD') + '.xlsx'
                            );
                          }}
                        />
                      </div>
                    </div>
                    <div className={"p-col-12 p-lg-4"} style={{display: 'flex', flexDirection: 'column'}}>
                      <small className={"p-text-uppercase"}>{t('reservations_by_channels')}</small>
                      <h3 className={"p-m-0 p-p-0 p-text-secondary"}>
                        {reservationsDateRange?.[0] && reservationsDateRange?.[1]
                          ? moment.utc(reservationsDateRange[0]).local().format(t('YYYY-MM-DD')) + ' - ' + moment.utc(reservationsDateRange[1]).local().format(t('YYYY-MM-DD'))
                          : reservationsDateRange?.[0]
                            ? moment.utc(reservationsDateRange[0]).local().format(t('YYYY-MM-DD')) + ' ?'
                            : '?'}
                      </h3>
                      <Chart type="bar" data={
                        {
                          labels: reservationsByChanelsLabel,
                          datasets: [
                            {
                              type: 'bar',
                              data: reservationsByChanelsData,
                            },
                          ]
                        }
                      } options={{
                        animation: false,
                        plugins: {
                          title: {
                            display: false,
                          },
                          legend: {
                            display: false,
                          },
                        },
                        scales: {
                          x: {
                            grid: {
                              display: false,
                            },
                          },
                          y: {
                            grid: {
                              display: false,
                            },
                          },
                        },
                      }} className="w-full bar-chart p-mt-3"/>
                      <div className={"p-text-center p-mt-4"}>
                        <Button
                          label={t('download')}
                          icon={"pi pi-download"}
                          className={"p-button-sm p-button-outlined"}
                          onClick={async () => {
                            const rows = reservationsByChanelsLabel.map((label, index) => {
                              const value = Number(reservationsByChanelsData[index]) || 0;
                              return [String(label || ''), value];
                            });
                            const XLSXModule = await import('xlsx');
                            const XLSX = XLSXModule.default || XLSXModule;
                            const workbook = XLSX.utils.book_new();
                            const worksheet = XLSX.utils.aoa_to_sheet([
                              [t('reservations_by_channels') + ' - '
                              + (reservationsDateRange?.[0] ? moment.utc(reservationsDateRange[0]).local().format(t('YYYY-MM-DD')) : '-')
                              + ' - '
                              + (reservationsDateRange?.[1] ? moment.utc(reservationsDateRange[1]).local().format(t('YYYY-MM-DD')) : '-')],
                              [t('source'), t('reservations')],
                              ...rows
                            ]);
                            worksheet['!cols'] = [{wch: 28}, {wch: 14}];
                            worksheet['!merges'] = [{s: {r: 0, c: 0}, e: {r: 0, c: 1}}];
                            XLSX.utils.book_append_sheet(workbook, worksheet, String(t('reservations_by_channels')).slice(0, 31));
                            const workbookBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
                            fileDownload(
                              new Blob([workbookBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
                              'reservations_by_channels_' + moment().format('YYYY-MM-DD') + '.xlsx'
                            );
                          }}
                        />
                      </div>
                    </div>
                    <div className={"p-col-12 p-lg-4"} style={{display: 'flex', flexDirection: 'column'}}>
                      <div className={"p-grid"}>
                        <div className={"p-col p-col-align-center"}>
                          <small className={"p-text-uppercase"}>{t('reservations_by_occupancy')}</small>
                          <h3 className={"p-m-0 p-p-0 p-text-secondary"}>
                            {reservationsDateRange?.[0] && reservationsDateRange?.[1]
                              ? moment.utc(reservationsDateRange[0]).local().format(t('YYYY-MM-DD')) + ' - ' + moment.utc(reservationsDateRange[1]).local().format(t('YYYY-MM-DD'))
                              : reservationsDateRange?.[0]
                                ? moment.utc(reservationsDateRange[0]).local().format(t('YYYY-MM-DD')) + ' ?'
                                : '?'}
                          </h3>
                        </div>
                        <div className={"p-col p-col-align-center p-text-right"}>
                          {reservationsByOccupancyType === 'bar' &&
                            <Button icon={"pi pi-chart-line"}
                                    className={"p-button-warning"}
                                    onClick={() => {
                                      setReservationsByOccupancyType('line')
                                    }}/>
                          }
                          {reservationsByOccupancyType === 'line' &&
                            <Button icon={"pi pi-chart-bar"}
                                    className={"p-button-warning"}
                                    onClick={() => {
                                      setReservationsByOccupancyType('bar')
                                    }}/>
                          }
                        </div>
                      </div>
                      <Chart type={reservationsByOccupancyType} data={reservationsByOccupancyMultidata}
                             options={{
                               animation: false,
                               plugins: {
                                 title: {
                                   display: false,
                                 },
                                 legend: {
                                   display: false,
                                 },
                               },
                               scales: {
                                 x: {
                                   grid: {
                                     display: true,
                                   },
                                 },
                                 y: {
                                   grid: {
                                     display: false,
                                   },
                                 },
                               },
                             }} className="w-full bar-chart p-mt-3"/>
                      <div className={"p-text-center p-mt-3"}>
                        <Button
                          label={t('download')}
                          icon={"pi pi-download"}
                          className={"p-button-sm p-button-outlined"}
                          onClick={async () => {
                            const rawLabels = Array.isArray(reservationsByOccupancyMultidata?.labels) ? reservationsByOccupancyMultidata.labels : [];
                            const rawDatasets = Array.isArray(reservationsByOccupancyMultidata?.datasets) ? reservationsByOccupancyMultidata.datasets : [];
                            const rows = rawLabels.map((dateLabel, rowIndex) => {
                              const cells = rawDatasets.map((dataset) => {
                                const value = Number(dataset?.data?.[rowIndex]) || 0;
                                return value;
                              });
                              return [String(dateLabel || ''), ...cells];
                            });
                            const XLSXModule = await import('xlsx');
                            const XLSX = XLSXModule.default || XLSXModule;
                            const workbook = XLSX.utils.book_new();
                            const worksheet = XLSX.utils.aoa_to_sheet([
                              [t('reservations_by_occupancy') + ' - '
                              + (reservationsDateRange?.[0] ? moment.utc(reservationsDateRange[0]).local().format(t('YYYY-MM-DD')) : '-')
                              + ' - '
                              + (reservationsDateRange?.[1] ? moment.utc(reservationsDateRange[1]).local().format(t('YYYY-MM-DD')) : '-')],
                              [t('ntak_report_date'), ...rawDatasets.map((dataset) => String(dataset?.label || ''))],
                              ...rows
                            ]);
                            worksheet['!cols'] = [{wch: 16}, ...rawDatasets.map(() => ({wch: 12}))];
                            worksheet['!merges'] = [{s: {r: 0, c: 0}, e: {r: 0, c: rawDatasets.length}}];
                            XLSX.utils.book_append_sheet(workbook, worksheet, String(t('reservations_by_occupancy')).slice(0, 31));
                            const workbookBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
                            fileDownload(
                              new Blob([workbookBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
                              'reservations_by_occupancy_' + moment().format('YYYY-MM-DD') + '.xlsx'
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Panel>
              </div>
            }
            {accommodations && accommodations[0] &&
              <div className={"p-p-3 p-p-lg-0 p-mt-3"}
                   style={{maxWidth: '1910px', marginLeft: 'auto', marginRight: 'auto'}}>
                <Card className={"p-shadow-0"}>
                  <div className={"p-grid"} style={{alignItems: 'center'}}>
                    <div className={"p-col p-col-align-center"}>
                      <small className={"p-text-uppercase"}>{t('ntak_report_descr')}</small>
                      <h3 className={"p-m-0 p-p-0 p-text-secondary"}>{t('ntak_report')}</h3>
                    </div>
                    <div className={"p-col p-col-align-center p-text-right p-pr-0"}>
                      {ntakReport &&
                        <Button
                          label={t('download')}
                          icon={"pi pi-download"}
                          className={"p-button-outlined"}
                          onClick={async () => {
                            const roomChartData = {
                              labels: [t('issued_rooms'), t('out_of_order_rooms'), t('out_of_service_rooms'), t('available_rooms')],
                              datasets: [
                                {
                                  data: [
                                    Number(ntakReport?.room_summary?.issued_rooms) || 0,
                                    Number(ntakReport?.room_summary?.out_of_order_rooms) || 0,
                                    Number(ntakReport?.room_summary?.out_of_service_rooms) || 0,
                                    Math.max((Number(ntakReport?.room_summary?.saleable_rooms) || 0) - (Number(ntakReport?.room_summary?.issued_rooms) || 0), 0)
                                  ],
                                  backgroundColor: ['#ef4444', '#f59e0b', '#64748b', '#22c55e'],
                                  hoverBackgroundColor: ['#dc2626', '#d97706', '#475569', '#16a34a']
                                },
                              ]
                            };
                            const roomLabels = Array.isArray(roomChartData?.labels) ? roomChartData.labels : [];
                            const roomValues = Array.isArray(roomChartData?.datasets?.[0]?.data) ? roomChartData.datasets[0].data : [];
                            const roomRows = roomLabels.map((label, index) => {
                              const value = Number(roomValues[index]) || 0;
                              return [String(label || ''), value];
                            });

                            const revenueChartData = {
                              labels: [t('ntak_report_ifa'), t('ntak_report_accommodation_fee'), t('other')],
                              datasets: [
                                {
                                  data: getNtakRevenueChartValues(ntakReport),
                                  backgroundColor: ['#3b82f6', '#10b981', '#f59e0b'],
                                  hoverBackgroundColor: ['#2563eb', '#059669', '#d97706']
                                },
                              ]
                            };
                            const revenueLabels = Array.isArray(revenueChartData?.labels) ? revenueChartData.labels : [];
                            const revenueValues = Array.isArray(revenueChartData?.datasets?.[0]?.data) ? revenueChartData.datasets[0].data : [];
                            const revenueRows = revenueLabels.map((label, index) => {
                              const value = Number(revenueValues[index]) || 0;
                              return [String(label || ''), value];
                            });

                            const tableRows = (ntakReport?.sold_nights || []).map((rowData) => [
                              String(rowData?.building_code || ''),
                              String(rowData?.room_number || ''),
                              String(rowData?.unit_type || ''),
                              String(rowData?.reservation_number || ''),
                              String(rowData?.sales_channel || ''),
                              String(rowData?.market_segment || ''),
                              Number(rowData?.guests?.length || 0),
                              normalizeNtakAmount((rowData?.charges || []).reduce((sum, charge) => sum + (Number(charge?.gross_amount) || 0), 0)),
                              normalizeNtakAmount((rowData?.expenses || []).reduce((sum, expense) => sum + (Number(expense?.gross_amount) || 0), 0)),
                            ]);

                            const XLSXModule = await import('xlsx');
                            const XLSX = XLSXModule.default || XLSXModule;
                            const workbook = XLSX.utils.book_new();

                            const roomSheet = XLSX.utils.aoa_to_sheet([
                              [t('ntak_report_room_distribution')],
                              [t('type'), t('amount')],
                              ...roomRows
                            ]);
                            roomSheet['!cols'] = [{wch: 30}, {wch: 14}];
                            roomSheet['!merges'] = [{s: {r: 0, c: 0}, e: {r: 0, c: 1}}];
                            XLSX.utils.book_append_sheet(workbook, roomSheet, String(t('ntak_report_room_distribution')).slice(0, 31));

                            const revenueSheet = XLSX.utils.aoa_to_sheet([
                              [t('ntak_report_revenue_distribution')],
                              [t('type'), t('amount')],
                              ...revenueRows
                            ]);
                            revenueSheet['!cols'] = [{wch: 34}, {wch: 18}];
                            revenueSheet['!merges'] = [{s: {r: 0, c: 0}, e: {r: 0, c: 1}}];
                            XLSX.utils.book_append_sheet(workbook, revenueSheet, String(t('ntak_report_revenue_distribution')).slice(0, 31));

                            const lodgingSheet = XLSX.utils.aoa_to_sheet([
                              [t('ntak_report') + ' - ' + t('ntak_report_date') + ': ' + (ntakReport?.report_date ? moment.utc(ntakReport?.report_date).local().format(t('YYYY-MM-DD')) : '-')],
                              [t('building_code'), t('room_number'), t('unit_type'), t('reservation_number'), t('channel'), t('segment'), t('guests'), t('ntak_report_charges_total'), t('ntak_report_expenses_total')],
                              ...tableRows
                            ]);
                            lodgingSheet['!cols'] = [{wch: 18}, {wch: 16}, {wch: 16}, {wch: 20}, {wch: 16}, {wch: 20}, {wch: 10}, {wch: 18}, {wch: 18}];
                            lodgingSheet['!merges'] = [{s: {r: 0, c: 0}, e: {r: 0, c: 8}}];
                            XLSX.utils.book_append_sheet(workbook, lodgingSheet, String(t('ntak_report')).slice(0, 31));

                            const workbookBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
                            fileDownload(
                              new Blob([workbookBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
                              'ntak_report_full_' + moment().format('YYYY-MM-DD') + '.xlsx'
                            );
                          }}
                        />
                      }
                    </div>
                    <div className={"p-col-12 p-lg-5 p-col-align-center"}>
                      <div style={{display: 'flex', justifyContent: 'flex-end', flexWrap: 'nowrap', gap: '0.5rem'}}>
                        <Dropdown options={accommodations}
                                  optionLabel="name"
                                  optionValue="id"
                                  id={"ntakAccommodation"}
                                  emptyMessage={t('empty_message')}
                                  onChange={(e) => {
                                    setNtakAccommodation(e.value)
                                  }}
                                  value={ntakAccommodation}
                                  placeholder={t('accommodation')}
                                  style={{minWidth: '280px'}}
                        />
                        <span className={"p-d-none p-d-lg-inline-block"}>
                          <span className={"p-inputgroup"} style={{maxWidth: '310px'}}>
                        <Button label={"-1"}
                                disabled={ntakReportLoading}
                                className={"p-button-success"}
                                onClick={() => {
                                  setNtakReportDay(moment(ntakReportDay).subtract(+1, 'days').format(t('YYYY-MM-DD')))
                                }}/>
                        <Calendar value={ntakReportDay ? moment(ntakReportDay, 'YYYY-MM-DD').toDate() : null}
                                  dateFormat={t('YY-MM-DD')}
                                  placeholder={ntakReportDay}
                                  locale="default"
                                  id={"ntakReportDay"}
                                  onChange={(e) => {
                                    setNtakReportDay(moment.utc(e.value).local().format(t('YYYY-MM-DD')))
                                  }}/>
                        <Button label={"+1"}
                                disabled={ntakReportLoading}
                                className={"p-button-success"}
                                onClick={() => {
                                  setNtakReportDay(moment(ntakReportDay).subtract(-1, 'days').format(t('YYYY-MM-DD')))
                                }}/>
                      </span>
                        </span>
                      </div>
                    </div>
                    <div className={"p-col p-col-align-center p-text-right p-d-none p-d-lg-block"}
                         style={{maxWidth: '35px'}}>
                      <i className={"pi pi-file"} style={{'fontSize': '1.5em'}}></i>
                    </div>
                  </div>
                  {ntakAccommodation && !ntakAccommodationId &&
                    <small className={"p-text-danger p-d-block p-mt-2"}>
                      {t('ntak_report_missing_ntak_id')}
                    </small>
                  }
                  {ntakAccommodation && ntakAccommodationId && ntakReportNotAvailable && !ntakReportLoading &&
                    <p className={"p-m-0 p-p-0"}>
                      {t('ntak_report_not_available_for_accommodation')}
                    </p>
                  }
                  {ntakReportLoading &&
                    <ProgressBar mode="indeterminate"
                                 style={{height: '5px', position: 'fixed', top: 0, zIndex: 9}}></ProgressBar>
                  }
                  {ntakReport &&
                    <div className={"p-grid"} ref={ntakReportContentRef}>
                      <div className={"p-col-12"}>
                        <div className={"p-grid"} style={{display: 'flex', flexWrap: 'wrap'}}>
                          <div className={"p-col-12 p-lg-3"} style={{display: 'flex', flexDirection: 'column'}}>
                            <Card className={"p-shadow-0"} style={{flex: 1}}>
                              <small className={"p-text-uppercase"}>{t('ntak_report_room_distribution')}</small>
                              {hasNtakRoomChartData ?
                                <div style={{display: 'flex', justifyContent: 'center', height: '300px'}}>
                                  <Chart type="doughnut" data={{
                                    labels: [t('issued_rooms'), t('out_of_order_rooms'), t('out_of_service_rooms'), t('available_rooms')],
                                    datasets: [
                                      {
                                        data: ntakRoomChartValues,
                                        backgroundColor: ['#ef4444', '#f59e0b', '#64748b', '#22c55e'],
                                        hoverBackgroundColor: ['#dc2626', '#d97706', '#475569', '#16a34a'],
                                        borderColor: ntakChartSurfaceColor,
                                        hoverBorderColor: ntakChartSurfaceColor,
                                        borderWidth: 2
                                      },
                                    ]
                                  }}
                                         options={ntakDoughnutChartOptions}
                                         className="w-full p-mt-2" style={{height: '300px'}}/>
                                </div>
                                :
                                <div className="ntak-report-chart-empty">
                                  <i className="pi pi-chart-pie"></i>
                                  <span>{t('empty_message')}</span>
                                </div>
                              }
                            </Card>
                          </div>
                          <div className={"p-col-12 p-lg-3"} style={{display: 'flex', flexDirection: 'column'}}>
                            <small className={"p-text-uppercase p-mt-3"}>{t('room_summary')}</small>
                            <div className={"p-mt-2"}>
                              <div>{t('total_rooms')}: <strong>{(Number(ntakReport?.room_summary?.total_rooms) || 0).toLocaleString()}</strong>
                              </div>
                              <div>{t('total_capacity')}: <strong>{(Number(ntakReport?.room_summary?.total_capacity) || 0).toLocaleString()}</strong>
                              </div>
                              <div>{t('out_of_order_capacity')}: <strong>{(Number(ntakReport?.room_summary?.out_of_order_capacity) || 0).toLocaleString()}</strong>
                              </div>
                              <div>{t('out_of_service_capacity')}: <strong>{(Number(ntakReport?.room_summary?.out_of_service_capacity) || 0).toLocaleString()}</strong>
                              </div>
                            </div>
                            <div className={"p-mt-3"}>
                              <small className={"p-text-uppercase"}>
                                {t('saleable_rooms')} / {t('issued_rooms')} ({(Number(ntakReport?.room_summary?.issued_rooms) || 0).toLocaleString()} / {(Number(ntakReport?.room_summary?.saleable_rooms) || 0).toLocaleString()})
                              </small>
                              <div className={"p-mt-1"} style={{
                                height: '12px',
                                borderRadius: '8px',
                                backgroundColor: '#f2f3f8',
                                overflow: 'hidden'
                              }}>
                                <div
                                  style={{
                                    height: '12px',
                                    width: ((Number(ntakReport?.room_summary?.saleable_rooms) || 0) > 0
                                      ? Math.round(((Number(ntakReport?.room_summary?.issued_rooms) || 0) / (Number(ntakReport?.room_summary?.saleable_rooms) || 1)) * 100)
                                      : 0) + '%',
                                    backgroundColor: '#22c55e',
                                    transition: 'width 0.2s ease'
                                  }}
                                />
                              </div>
                            </div>
                            <div className={"p-mt-3"}>
                              <small className={"p-text-uppercase"}>
                                {t('saleable_capacity')} / {t('issued_capacity')} ({(Number(ntakReport?.room_summary?.issued_capacity) || 0).toLocaleString()} / {(Number(ntakReport?.room_summary?.saleable_capacity) || 0).toLocaleString()})
                              </small>
                              <div className={"p-mt-1"} style={{
                                height: '12px',
                                borderRadius: '8px',
                                backgroundColor: '#f2f3f8',
                                overflow: 'hidden'
                              }}>
                                <div
                                  style={{
                                    height: '12px',
                                    width: ((Number(ntakReport?.room_summary?.saleable_capacity) || 0) > 0
                                      ? Math.round(((Number(ntakReport?.room_summary?.issued_capacity) || 0) / (Number(ntakReport?.room_summary?.saleable_capacity) || 1)) * 100)
                                      : 0) + '%',
                                    backgroundColor: '#3b82f6',
                                    transition: 'width 0.2s ease'
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className={"p-col-12 p-lg-3"} style={{display: 'flex', flexDirection: 'column'}}>
                            <Card className={"p-shadow-0"} style={{flex: 1}}>
                              <small className={"p-text-uppercase"}>{t('ntak_report_revenue_distribution')}</small>
                              {hasNtakRevenueChartData ?
                                <div style={{display: 'flex', justifyContent: 'center', height: '300px'}}>
                                  <Chart type="doughnut" data={{
                                    labels: [t('ntak_report_ifa'), t('ntak_report_accommodation_fee'), t('other')],
                                    datasets: [
                                      {
                                        data: ntakRevenueChartValues,
                                        backgroundColor: ['#3b82f6', '#10b981', '#f59e0b'],
                                        hoverBackgroundColor: ['#2563eb', '#059669', '#d97706'],
                                        borderColor: ntakChartSurfaceColor,
                                        hoverBorderColor: ntakChartSurfaceColor,
                                        borderWidth: 2
                                      },
                                    ]
                                  }}
                                         options={ntakDoughnutChartOptions}
                                         className="w-full p-mt-2" style={{height: '300px'}}/>
                                </div>
                                :
                                <div className="ntak-report-chart-empty">
                                  <i className="pi pi-chart-pie"></i>
                                  <span>{t('empty_message')}</span>
                                </div>
                              }
                            </Card>
                          </div>
                          <div className={"p-col-12 p-lg-3"} style={{display: 'flex', flexDirection: 'column'}}>
                            <Card className={"p-shadow-0"} style={{flex: 1}}>
                              <small className={"p-text-uppercase"}>{t('ifa')}</small>
                              <h4 className={"p-mt-1 p-mb-1 p-p-0 p-text-secondary"}>
                                {ntakReport?.ifa?.type ? t(String(ntakReport?.ifa?.type || '').toLowerCase()) : '-'}
                              </h4>
                              <h4 className={"p-mt-1 p-mb-3 p-p-0 p-text-secondary"}>
                                {(Number(ntakReport?.ifa?.amount) || 0).toLocaleString()}
                              </h4>

                              <small className={"p-text-uppercase"}>{t('ntak_report_status')}</small>
                              <h4 className={"p-mt-1 p-mb-3 p-p-0"}>
                              <span
                                className={"p-badge " + (ntakReport?.closure?.accommodation_not_operating ? 'p-badge-danger' : 'p-badge-success')}>
                                {ntakReport?.closure?.accommodation_not_operating ? t('ntak_report_closed') : t('ntak_report_open')}
                              </span>
                              </h4>

                              <small className={"p-text-uppercase"}>{t('ntak_adatszolgaltatasi_azon')}</small>
                              <h4 className={"p-mt-1 p-mb-3 p-p-0 p-text-secondary"}>
                                {ntakAccommodationId || '-'}
                              </h4>

                              <small className={"p-text-uppercase"}>{t('ntak_report_date')}</small>
                              <h4 className={"p-mt-1 p-mb-3 p-p-0 p-text-secondary"}>
                                {ntakReport?.report_date ? moment.utc(ntakReport?.report_date).local().format(t('YYYY-MM-DD')) : '-'}
                              </h4>

                              <small className={"p-text-uppercase"}>{t('ntak_report_generated_at')}</small>
                              <h4 className={"p-mt-1 p-mb-0 p-p-0 p-text-secondary"}>
                                {ntakReport?.report_generated_at ? moment.utc(ntakReport?.report_generated_at).local().format(t('YYYY-MM-DD HH:mm:ss')) : '-'}
                              </h4>
                            </Card>
                          </div>
                        </div>
                      </div>
                      <div className={"p-col-12"}>
                        <Accordion activeIndex={null} className={"p-shadow-0"}>
                          <AccordionTab header={t('details')}>
                            <div className={"p-grid"}>
                              <div className={"p-col-12"}>
                                <DataTable
                                  value={ntakReport?.sold_nights || []}
                                  size={"small"}
                                  emptyMessage={t('empty_message')}
                                  autoLayout={true}
                                  responsiveLayout={window.App.state.responsiveLayout}
                                  breakpoint="1365px"
                                  stripedRows
                                >
                                  {/** <Column field="building_code" header={t('building_code')}/> */}
                                  <Column field="room_number" header={t('room_number')}/>
                                  <Column field="unit_type" header={t('unit_type')}/>
                                  <Column field="reservation_number" header={t('reservation_number')}/>
                                  <Column field="sales_channel" header={t('channel')}
                                          body={(rowData) => rowData?.sales_channel ? t(String(rowData?.sales_channel || '').toLowerCase()) : '-'}/>
                                  <Column field="market_segment" header={t('segment')}
                                          body={(rowData) => rowData?.market_segment ? t(String(rowData?.market_segment || '').toLowerCase()) : '-'}/>
                                  <Column field="guests" header={t('guests')}
                                          body={(rowData) => rowData?.guests?.length || 0}/>
                                  <Column header={t('ntak_report_charges_total')}
                                          className={"p-text-right"}
                                          body={(rowData) => normalizeNtakAmount((rowData?.charges || []).reduce((sum, charge) => sum + (Number(charge?.gross_amount) || 0), 0)).toLocaleString()}/>
                                  <Column header={t('ntak_report_expenses_total')}
                                          className={"p-text-right"}
                                          body={(rowData) => normalizeNtakAmount((rowData?.expenses || []).reduce((sum, expense) => sum + (Number(expense?.gross_amount) || 0), 0)).toLocaleString()}/>
                                </DataTable>
                              </div>
                              <div className={"p-col-12"}>
                                <small className={"p-text-uppercase"}>{t('out_of_order_units')}</small>
                                <DataTable
                                  value={ntakReport?.out_of_order_units || []}
                                  size={"small"}
                                  emptyMessage={t('empty_message')}
                                  autoLayout={true}
                                  responsiveLayout={window.App.state.responsiveLayout}
                                  breakpoint="1365px"
                                  stripedRows
                                >
                                  {/** <Column field="building_code" header={t('building_code')}/> */}
                                  <Column field="room_number" header={t('room_number')}/>
                                  <Column field="unit_type" header={t('unit_type')}/>
                                  <Column field="reason" header={t('reason')}/>
                                </DataTable>
                              </div>
                              <div className={"p-col-12 p-lg-6"}>
                                <small className={"p-text-uppercase"}>{t('other_charges')}</small>
                                <DataTable
                                  value={ntakReport?.other_charges || []}
                                  size={"small"}
                                  emptyMessage={t('empty_message')}
                                  autoLayout={true}
                                  responsiveLayout={window.App.state.responsiveLayout}
                                  breakpoint="1365px"
                                  stripedRows
                                >
                                  <Column field="date" header={t('date')}/>
                                  <Column field="reservation_number" header={t('reservation_number')}/>
                                  <Column field="main_category" header={t('category')}
                                          body={(rowData) => rowData?.main_category ? t(String(rowData?.main_category || '').toLowerCase()) : '-'}/>
                                  <Column field="sub_category" header={t('subcategory')}
                                          body={(rowData) => rowData?.sub_category ? t(String(rowData?.sub_category || '').toLowerCase()) : '-'}/>
                                  <Column field="vat_rate" header={t('vat')}/>
                                  <Column field="gross_amount" header={t('gross_amount')} className={"p-text-right"}
                                          body={(rowData) => normalizeNtakAmount(rowData?.gross_amount).toLocaleString()}/>
                                </DataTable>
                              </div>
                              <div className={"p-col-12 p-lg-6"}>
                                <small className={"p-text-uppercase"}>{t('other_expenses')}</small>
                                <DataTable
                                  value={ntakReport?.other_expenses || []}
                                  size={"small"}
                                  emptyMessage={t('empty_message')}
                                  autoLayout={true}
                                  responsiveLayout={window.App.state.responsiveLayout}
                                  breakpoint="1365px"
                                  stripedRows
                                >
                                  <Column field="date" header={t('date')}/>
                                  <Column field="reservation_number" header={t('reservation_number')}/>
                                  <Column field="main_category" header={t('category')}
                                          body={(rowData) => rowData?.main_category ? t(String(rowData?.main_category || '').toLowerCase()) : '-'}/>
                                  <Column field="sub_category" header={t('subcategory')}
                                          body={(rowData) => rowData?.sub_category ? t(String(rowData?.sub_category || '').toLowerCase()) : '-'}/>
                                  <Column field="vat_rate" header={t('vat')}/>
                                  <Column field="gross_amount" header={t('gross_amount')} className={"p-text-right"}
                                          body={(rowData) => normalizeNtakAmount(rowData?.gross_amount).toLocaleString()}/>
                                </DataTable>
                              </div>
                              <div className={"p-col-12 p-lg-6"}>
                                <small className={"p-text-uppercase"}>{t('post_stay_charges')}</small>
                                <DataTable
                                  value={ntakReport?.post_stay_charges || []}
                                  size={"small"}
                                  emptyMessage={t('empty_message')}
                                  autoLayout={true}
                                  responsiveLayout={window.App.state.responsiveLayout}
                                  breakpoint="1365px"
                                  stripedRows
                                >
                                  <Column field="date" header={t('date')}/>
                                  <Column field="reservation_number" header={t('reservation_number')}/>
                                  <Column field="main_category" header={t('category')}
                                          body={(rowData) => rowData?.main_category ? t(String(rowData?.main_category || '').toLowerCase()) : '-'}/>
                                  <Column field="sub_category" header={t('subcategory')}
                                          body={(rowData) => rowData?.sub_category ? t(String(rowData?.sub_category || '').toLowerCase()) : '-'}/>
                                  <Column field="vat_rate" header={t('vat')}/>
                                  <Column field="gross_amount" header={t('gross_amount')} className={"p-text-right"}
                                          body={(rowData) => normalizeNtakAmount(rowData?.gross_amount).toLocaleString()}/>
                                </DataTable>
                              </div>
                              <div className={"p-col-12 p-lg-6"}>
                                <small className={"p-text-uppercase"}>{t('post_stay_expenses')}</small>
                                <DataTable
                                  value={ntakReport?.post_stay_expenses || []}
                                  size={"small"}
                                  emptyMessage={t('empty_message')}
                                  autoLayout={true}
                                  responsiveLayout={window.App.state.responsiveLayout}
                                  breakpoint="1365px"
                                  stripedRows
                                >
                                  <Column field="date" header={t('date')}/>
                                  <Column field="reservation_number" header={t('reservation_number')}/>
                                  <Column field="main_category" header={t('category')}
                                          body={(rowData) => rowData?.main_category ? t(String(rowData?.main_category || '').toLowerCase()) : '-'}/>
                                  <Column field="sub_category" header={t('subcategory')}
                                          body={(rowData) => rowData?.sub_category ? t(String(rowData?.sub_category || '').toLowerCase()) : '-'}/>
                                  <Column field="vat_rate" header={t('vat')}/>
                                  <Column field="gross_amount" header={t('gross_amount')} className={"p-text-right"}
                                          body={(rowData) => normalizeNtakAmount(rowData?.gross_amount).toLocaleString()}/>
                                </DataTable>
                              </div>
                            </div>
                          </AccordionTab>
                        </Accordion>
                      </div>
                    </div>
                  }
                  {ntakReportLoading && !ntakReport && ntakReportContentHeight > 0 &&
                    <div style={{minHeight: ntakReportContentHeight + 'px'}}></div>
                  }
                </Card>
              </div>
            }

            <Sidebar position="right" visible={action === 'show' && entity === 'reservation'}
                     closeOnEscape={true}
                     style={{width: '90%', maxWidth: '1200px'}}
                     onHide={() => {
                       navigate(-1);
                     }}>
              <_FM_ReservationShowComponent backlink={'/control-panel'}/>
            </Sidebar>
            <Sidebar position="right" visible={action === 'update' && entity === 'reservation'}
                     closeOnEscape={true}
                     style={{width: '90%', maxWidth: '1200px'}}
                     onHide={() => {
                       navigate('/control-panel');
                     }}>
              <_FM_ReservationFormComponent backlink={'/control-panel'}/>
            </Sidebar>
            <Sidebar position="right"
                     visible={window.App.urlVars().create === 'folio' || window.App.urlVars().update === 'folio'}
                     closeOnEscape={true}
                     style={{width: '90%', maxWidth: '1200px'}}
                     onHide={() => {
                       navigate(-1);
                     }}>
              <_FM_FolioFormComponent backlink={'/control-panel'}/>
            </Sidebar>
            <Sidebar position="right" visible={window.App.urlVars().manage === 'folio'}
                     closeOnEscape={true}
                     style={{width: '99%'}}
                     onHide={() => {
                       navigate(-1);
                     }}>
              <_FM_FolioDndComponent backlink={'/control-panel'}/>
            </Sidebar>

            <Dialog visible={action === 'read' && entity === 'customer'}
                    style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}
                    onHide={() => {
                      navigate(-1)
                    }} modal={false} draggable={false}>
              <_FM_CustomerShowComponent backlink={'/control-panel'}/>
            </Dialog>
            <Dialog visible={action === 'read' && entity === 'reservation-group'}
                    style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}
                    onHide={() => {
                      navigate(-1)
                    }} modal={false} draggable={false}>
              <_FM_ReservationgroupShowComponent backlink={'/control-panel'}/>
            </Dialog>
            <Dialog header={t('new_receipt')} visible={window.App.urlVars().create === 'invoice'}
                    style={{width: '99%'}}
                    contentStyle={{overflowX: 'hidden', overflowY: 'auto'}}
                    blockScroll={true}
                    onHide={() => {
                      navigate(-1)
                    }} modal={false} draggable={false}>
              <_FM_ReceiptFormComponent/>
            </Dialog>
            <Dialog header={t('new_receipt')} visible={window.App.urlVars().read === 'invoice'}
                    style={{width: '99%'}}
                    contentStyle={{overflowX: 'hidden', overflowY: 'auto'}}
                    blockScroll={true}
                    onHide={() => {
                      navigate(-1)
                    }} modal={false} draggable={false}>
              <_FM_ReceiptShowComponent/>
            </Dialog>
          </>
        ) :
        (
          <>
          </>
        )
      }
    </div>
  )
}
export default withTranslation('common')(_FM_ControlpanelPage);
